export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Ansicht anpassen",
	"action.default.view": "Standardansicht",
	"action.viewcart": "Einkaufswagen ansehen",
	"active": "Active",
	"add-suborg.add-suborg": "Unterorganisation hinzufügen",
	"add-suborg.admin-info": "Administrator-Informationen",
	"add-suborg.administrator": "Administrator",
	"add-suborg.confirmation": "Bestätigung",
	"add-suborg.email": "Mailadresse des Administrators",
	"add-suborg.firstname": "Vorname des Administrators",
	"add-suborg.id": "ID der Organisation",
	"add-suborg.intro": "Wählen Sie für die Organisation ArcelorMittal Europe eine vorhandene Organisation aus oder erstellen Sie eine neue:",
	"add-suborg.lastname": "Nachname des Administrators",
	"add-suborg.matchin-org-intro": "Daten aus passender Organisation verwenden:",
	"add-suborg.matching-organizations": "Passende Organisationen",
	"add-suborg.new-org-intro": "Eine Unterorganisation komplett neu erstellen:",
	"add-suborg.org-info": "Informationen zur Organisation",
	"add-suborg.org-name": "Name der Organisation",
	"add-suborg.organization-details": "Details zur Organisation",
	"add-suborg.please-select": "Bitte eine Option wählen",
	"add-suborg.quick-search": "Benutzer suchen",
	"add-suborg.vat-num-already-exists": "Die Umsatzsteuernummer ist bereits vorhanden. Bitte eine neue Umsatzsteuernummer angeben",
	"add-suborg.vat-number": "Steuernummer",
	"add-user.add-user": "Benutzer hinzufügen",
	"add-user.admin-user": "Als Administrator für diese Organisation werben",
	"add-user.confirmation": "Bestätigung",
	"add-user.email": "E-Mail",
	"add-user.email-exist": "E-Mail-ID bereits vorhanden",
	"add-user.intro": "Wählen Sie für die Organisation ArcelorMittal Europe einen vorhandenen Benutzer aus oder erstellen Sie einen neuen:",
	"add-user.matchin-users-intro": "Daten von passenden Benutzern verwenden:",
	"add-user.matching-users": "Passende Benutzer",
	"add-user.name": "Name",
	"add-user.new-user-intro": "  Einen Benutzer komplett neu erstellen:",
	"add-user.please-select": "Bitte eine Option wählen",
	"add-user.proceed-to-creation": "Weiter zur Erstellung",
	"add-user.referal-organization": "Verweisende Organisation",
	"add-user.required": "Erforderlich",
	"add-user.services": "Services",
	"add-user.services-management": "Verwaltung der Services",
	"add-user.user-creation": "Benutzererstellung",
	"add-user.user-email": "E-Mail",
	"add-user.user-exists": "Ausgewählter Benutzer existiert bereits für Organisation",
	"add-user.user-firstname": "Vorname",
	"add-user.user-informations": "Informationen zum Benutzer",
	"add-user.user-lastname": "Nachname",
	"add-user.user-not-active": "Ausgewählter Benutzer nicht aktiv",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Beim Hinzufügen von Artikeln zum Warenkorb ist ein Fehler aufgetreten. Bitte versuchen Sie es nach einiger Zeit erneut.",
	"add.to.cart.label": "In den Warenkorb legen",
	"administrator.message": "ist der Administrator der Organisation:",
	"ag-grid.copy": "Kopieren",
	"ag-grid.copyWithHeaders": "Mit Überschriften kopieren",
	"ag-grid.csvExport": "CSV Export",
	"ag-grid.excelExport": "Excel Export (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Excel Export (.xlm)&lrm;",
	"ag-grid.export": "Export",
	"ag-grid.paste": "Einfügen",
	"all.productsFamilies.not.available": "Alle Produktfamilien sind nicht verfügbar",
	"application.procurement.supplier.rfqNumber": "Lieferanten RFQ-Nummer",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "AQDB-Daten",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "Qualitätsdaten einsehen",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Weiter",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Weiter zur Bestellung",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "nur PDF, DOC, XLS, PPT Dateien oder Bilder. Maximal 20 MB pro Datei und maximal 3 Dateien.",
	"auction-material.category.subcategory": "Kat./Subkat.",
	"auction-material.details": "Details zum Material",
	"auction-material.downgrading.reason": "Grund für Herabstufung",
	"auction-material.oil.type": "Öltyp",
	"auction-offer.now-rows": "Kein Auktionsangebot Verfügbar",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Auktionen – Gebotsliste",
	"auction.bid.week": "Gebot Woche",
	"auction.bidding": "Auktionsgebote auf …",
	"auction.bids": "Gebote",
	"auction.bundle.number": "Bündelnummer",
	"auction.confirm.bid": "Gebot bestätigen",
	"auction.confirmation": "Bestätigung",
	"auction.dashboard": "Dashboard für Auktionen",
	"auction.description": "Auktionsbeschreibung",
	"auction.ended": "Beendet",
	"auction.entry": "Auktionen",
	"auction.main.steelgrade": "Hauptstahlsorte (pro Volumen)",
	"auction.market": "Markt",
	"auction.mill": "Werk",
	"auction.my.auction.bids": "Meine Auktionsgebote",
	"auction.name": "Auktionsname",
	"auction.new.offer.check": "Neues Auktionsangebot prüfen",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Pending",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Bündel",
	"auction.offer.clear.infos": "Infos löschen",
	"auction.offer.customer.reference": "Kundenreferenz",
	"auction.offer.customerref.mandatory": "Kundenreferenz muss angegeben werden",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Effektiv Preis",
	"auction.offer.exw.price": "EXW-Preis €/t",
	"auction.offer.exwprice.mandatory": "EXW-Preis muss angegeben werden",
	"auction.offer.invoicing.in": "Rechnungsstellung in",
	"auction.offer.lanned.loading.date": "Voraussichtliches Verladedatum",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Zahlungsbedingung",
	"auction.offer.tmode.mandatory": "Das Transportmittel muss angegeben werden",
	"auction.offer.transport.cost": "Transportkosten",
	"auction.offer.transport.invoiced.conditions": "Transport – in Rechnung gestellte Bedingungen",
	"auction.offer.type.of.maritime.transport": "Art des Seetransports",
	"auction.overview": "Ihre Auktionsübersicht diese Woche",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Produkttyp",
	"auction.selection": "Auktionsauswahl",
	"auction.submit.not.authorized.internal": "Einreichungsaktion im Simulations- oder Delegationsmodus nicht erlaubt",
	"auction.timer.days": "Tage",
	"auction.timer.endsin": "Endet in",
	"auction.timer.hours": "h",
	"auction.timer.minutes": "min",
	"auction.timer.weight.available": "Verfügbar",
	"auction.transport.price": "Transportkosten (€/t)",
	"auction.weight.unit.gross": "Brutto",
	"auctions.menu": "Auktionen",
	"auctions.opened": "Eröffnete Auktionen",
	"batch-card.all-documents": "Alle Dokumente für dieses Coil",
	"batch-card.batch-information": "Materialinformationen",
	"batch-card.batch-status": "Materialstatus",
	"batch-card.certificate-display-all": "Alle Werkszeugnisse anzeigen",
	"batch-card.create-call-off": "Einen neuen eCall-off starten",
	"batch-card.current-location": "Aktueller Lagerort",
	"batch-card.customer-article-reference": "Artikelreferenz des Kunden",
	"batch-card.customer-order-number": "Kundenbestellnummer",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Versandbereit",
	"batch-card.days-in-stock": "Coilalter",
	"batch-card.detailed-batch-status": "Detaillierter Chargenstatus",
	"batch-card.dispatch-advice-display-all": "Alle Lieferscheine anzeigen",
	"batch-card.document-date": "Datum",
	"batch-card.document-number": "Dokumentnummer",
	"batch-card.document-show": "Dokument anzeigen",
	"batch-card.document-type": "Typ",
	"batch-card.final-use": "Verwendungszweck",
	"batch-card.followup": "Verfolgung",
	"batch-card.gross-weight": "Bruttogewicht",
	"batch-card.heat-number": "Schmelznummer",
	"batch-card.invoice-display-all": "Alle Rechnungen anzeigen",
	"batch-card.last-certificate": "Letztes Werkszeugnis",
	"batch-card.last-dispatch-advice": "Letzter Lieferschein",
	"batch-card.last-documents": "Letzte Dokumente",
	"batch-card.last-invoice": "Letzte Rechnung",
	"batch-card.length": "Länge (mm)",
	"batch-card.mill": "Werk",
	"batch-card.mill-order-number": "Werksnummer",
	"batch-card.net-weight": "Nettogewicht",
	"batch-card.package-serial-number": "Paket Serien Nummer",
	"batch-card.planned-loading-date": "Geplantes Ladedatum",
	"batch-card.shipments": "Versand",
	"batch-card.steelgrade": "Stahlsorte",
	"batch-card.stock-alert": "Alarm Lagerbestand",
	"batch-card.supplier-order-number": "Lieferantenauftragsnummer",
	"batch-card.thickness": "Dicke (mm)",
	"batch-card.width": "Breite (mm)",
	"batch-list.last-seen": "Zuletzt angezeigte Coils",
	"batch.card": "Materialinformationen",
	"batch.card.article": "Artikel",
	"batch.card.customer": "Kunde",
	"batch.card.dimensions": "Abmessungen",
	"batch.card.final-use": "Verwendungszweck",
	"batch.card.go-to-the-order": "Zum Auftrag",
	"batch.card.information": "Materialinformationen",
	"batch.card.invoiced": "Fakturiert",
	"batch.card.mill": "Werk",
	"batch.card.mill-order": "Werksnummer",
	"batch.card.order": "Auftrag",
	"batch.card.weight": "Gewicht",
	"batch.coil-length": "Länge (mm)",
	"batch.current-location": "Aktueller Lagerort",
	"batch.current.location": "Aktueller Lagerort",
	"batch.date-for-dispatch": "Versandbereit seit",
	"batch.despatch.advice": "Lieferschein",
	"batch.despatch.date": "Versanddatum",
	"batch.detailed-batch-status": "Detaillierter Coilstatus",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Nur Chargen ab Rechnungsnummer:",
	"batch.from.same.invoice.available": "sind für diese Forderung verfügbar",
	"batch.gross": "Bruttogewicht",
	"batch.gross-t": "Brutto (t)",
	"batch.heat-number": "Schmelznummer",
	"batch.in-stock": "auf Lager",
	"batch.in-transit-detail": "Im Transport - Detail",
	"batch.invoice.date": "Invoice date",
	"batch.length": "Länge",
	"batch.net": "Nettogewicht",
	"batch.net-t": "Netto (t)",
	"batch.not.invoiced": "Nicht in Rechnung gestellte Charge",
	"batch.not.invoiced.select.other": "Bitte kommen Sie später wieder, um ein Qualitätsproblem mit dieser Materialeinheit zu melden.",
	"batch.not.invoiced.sorry": "Leider wurde die ausgewählte Charge noch nicht in Rechnung gestellt.",
	"batch.package-serial-number": "Paket Serien Nummer",
	"batch.planned-loading-date": "Voraussichtliches Verladedatum",
	"batch.reference": "Materialnummer",
	"batch.requested-delivery-date": "Angefragtes Lieferdatum eCall-off",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "Versanddatum",
	"batch.shipto": "Warenempfänger",
	"batch.status": "Coilstatus",
	"batch.supplier.invoice.number": "Invoice number",
	"batch.view.all": "Alle Coils anzeigen",
	"batch.view.all.at": "Alle Coils anzeigen in",
	"batches.detailed.batch.status": "Detaillierter Coilstatus",
	"batches.doc": "Dok",
	"batches.gross-t": "Brutto (t)",
	"batches.net-t": "Netto (t)",
	"batches.number.of.day.in.stock": "Tage im Lager",
	"blocked-service-alert.plural": "Entschuldigen Sie, diese Dienste sind momentan nicht verfügbar, bitte versuchen Sie es später: {{services}}",
	"blocked-service-alert.refresh": "Aktualisieren",
	"blocked-service-alert.singular": "Entschuldigen Sie, dieser Dienst ist momentan nicht verfügbar, bitte versuchen Sie es später: {{service}}",
	"browse.files": "Dateien durchsuchen",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "kein ausgewähltes Produkt",
	"card.prototype": "Prototyp",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Produktion",
	"card.selected": "{{value}} ausgewählte Produkte",
	"cdd.in.date": "Best.Lief.Dat. (Tag)",
	"cdd.in.week": "Best.Lief.Dat. (Woche)",
	"chart-title.M1": "Jan",
	"chart-title.M10": "Okt",
	"chart-title.M11": "Nov",
	"chart-title.M12": "Dez",
	"chart-title.M2": "Feb",
	"chart-title.M3": "Mar",
	"chart-title.M4": "Apr",
	"chart-title.M5": "Mai",
	"chart-title.M6": "Jun",
	"chart-title.M7": "Jul",
	"chart-title.M8": "Aug",
	"chart-title.M9": "Sep",
	"chart-title.Q1": "Q1",
	"chart-title.Q2": "Q2",
	"chart-title.Q3": "Q3",
	"chart-title.Q4": "Q4",
	"chart-title.S1": "S1",
	"chart-title.S2": "S2",
	"check.new.offer": "Neue Angebote prüfen",
	"choose.customer.last.used": "Zuletzt ausgewählt:",
	"choose.customer.restrict": "Bitte wählen Sie einen Kunden aus, für den Sie die Informationen anzeigen möchten. Die App wurde für die Benutzung durch Kunden konzipiert und erlaubt deshalb nur die Anzeige von einem Kunden auf einmal.",
	"choose.customer.select": "Als interner Benutzer müssen Sie einen Kunden auswählen für den Sie Daten anzeigen möchten.",
	"choose.visibility.select": "Bitte wählen Sie Ihre Organisation, für die Sie Daten anzeigen wollen, aus den vorhandenen Optionen aus:",
	"claim-batch.receipt-date": "Empfangsdatum",
	"claim.action.plan.notif": "Rufen Sie bei Bedarf Ihren technischen Kontakt an, um eine Mängelbehebung zu erhalten.",
	"claim.add-batch-to-this-issue": "Charge zu dieser Ausgabe hinzufügen",
	"claim.add.attachment": "Anhang hinzufügen",
	"claim.additional.costs.invalid": "Der für sonstige Kosten geforderte Betrag muss gültig sein.",
	"claim.additional.costs.mandatory": "Für sonstige Kosten geltend gemachter Betrag muss angegeben werden",
	"claim.additional.costs.requested": "Angeforderte zusätzliche Kosten",
	"claim.amount.for.other.costs": "Für sonstige Kosten geforderter Betrag",
	"claim.amount.previous.value": "Ihr bisheriger Wert: {{value}}",
	"claim.amount.unit.error": "Die Rechnung wurde gestellt in:",
	"claim.archived": "Archiv",
	"claim.attach.several.documents": "Eines oder mehrere Dokumente anhängen",
	"claim.attachment.error": "Ihre Anhänge wurden nicht korrekt hochgeladen. Bitte versuchen Sie es erneut.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "Der Dateiname sollte weniger als 80 Zeichen umfassen",
	"claim.attachment.limit.zr": "Bitte geben Sie alle relevanten Details an, die zur Validierung des beanspruchten Betrags und der Menge erforderlich sind, wie z. B. die betroffenen Coil-Nummern, das Gewicht und andere unterstützende Informationen. Vollständige und genaue Angaben helfen uns, Ihre Reklamation schnell und effizient zu bearbeiten. Der Dateiname sollte weniger als 80 Zeichen umfassen",
	"claim.attachment.mandatory": "Bitte mindestens einen Anhang hinzufügen",
	"claim.attachment.uploading.error": "Einige Anhänge werden noch hochgeladen, bitte warten Sie.",
	"claim.attachments": "Anhänge",
	"claim.attachments.description": "Bitte mindestens ein Foto oder Video hinzufügen, das ArcelorMittal helfen kann, Rückmeldungen zu Ihrer Anfrage zu geben",
	"claim.barcode.number": "Strichcode-Nummer",
	"claim.batch": "Charge",
	"claim.batch.reference.mandatory": "Chargenreferenz ist obligatorisch",
	"claim.batch.selection": "Charge wählen",
	"claim.batches": "Chargen",
	"claim.choose.defect": "Defekt auswählen",
	"claim.claimtype.label": "Anspruchstyp",
	"claim.comment": "Kommentar",
	"claim.comment.mandatory": "Kommentar ist obligatorisch",
	"claim.comment.placeholder": "Geben Sie einen kurzen Kommentar ein, um das Qualitätsproblem zu erläutern. Versuchen Sie, so detailliert und genau wie möglich zu sein.",
	"claim.contact.type.mandatory": "Kontaktart ist eine Pflichtangabe",
	"claim.created": "Erstellt",
	"claim.created.by": "Erstellt von",
	"claim.current.status": "Aktueller Status",
	"claim.current.statusddot": "Aktueller Status:",
	"claim.dashboard.services": "Meine Services",
	"claim.dashboard.services.claims": "Feedback zur Qualität",
	"claim.defect": "Defekt",
	"claim.defect.mandatory": "Defekt ist obligatorisch",
	"claim.display-pending-drafts": "Feedback(s) ausstehend",
	"claim.display-saved-drafts": "Entwurf(e) gespeichert",
	"claim.first.batch.selection": "Erste Charge wählen",
	"claim.full.quantity": "Stückzahl gesamt",
	"claim.go-back-to-batch-management": "Zurück zur Chargenverwaltung",
	"claim.guarantee.request": "NEUE GARANTIE ANFORDERN",
	"claim.impacted.quantity": "Betroffene Menge",
	"claim.impacted.quantity.mandatory": "Betroffene Menge ist obligatorisch",
	"claim.impacted.quantity.minimum": "Bitte geben Sie eine gültige Menge ein, die größer oder gleich 1 ist.",
	"claim.impacted.quantity.t": "Betroffene Menge (t)",
	"claim.last.modification": "Letzte Änderung",
	"claim.main.batch.remove": "Entfernen",
	"claim.main.batch.selected": "Gewählte Charge",
	"claim.material.costs": "Materialkosten",
	"claim.material.unit": "Materialeinheit",
	"claim.multi.batch.related.order": "Zugehörige Bestellung",
	"claim.no.attachment": "Kein Anhang",
	"claim.no.reference": "Ohne Referenz",
	"claim.no.sample.needed": "Für diesen Mangel wird kein Exemplar benötigt.",
	"claim.not-existing-or-not-permission": "Die Reklamation existiert nicht oder Sie haben nicht das Recht diese Reklamation anzuzeigen.",
	"claim.optional": "Optional",
	"claim.other.amount.cost": "Für sonstige Kosten geforderter Betrag",
	"claim.paid.amount": "Bezahlter Betrag",
	"claim.placeholder.reference.number": "Kundenreferenznummer",
	"claim.quality.issue": "Beschwerde",
	"claim.quality.issue.information": "Informationen zur Qualität",
	"claim.quality.issue.summary": "Zusammenfassung der Qualität",
	"claim.quantity.limit.error": "Angefragte Menge höher als berechnete Menge.",
	"claim.quantity.previous.value": "Ihr bisheriger Wert: {{value}}",
	"claim.quantity.tons.error": "Die betroffene Menge sollte weniger als 1000 für die folgende Einheit sein: Metrische Tonnen",
	"claim.quantity.unit.error": "Die Rechnung wurde gestellt in:",
	"claim.raise-new-quality-issue": "Ein Qualitätsproblem anzeigen",
	"claim.receipt.date.mandatory": "Empfangsdatum muss angegeben werden",
	"claim.reference.number": "Referenznummer",
	"claim.request.type": "Art der Forderung",
	"claim.requested.amount": "Geforderter Betrag",
	"claim.requested.material.costs": "Angeforderte Materialkosten",
	"claim.sample": "Das Exemplar wird geschickt an:",
	"claim.sample.agency": "Geschäftskontakt",
	"claim.sample.cts": "Technischer Kontakt",
	"claim.sample.mandatory": "Exemplar ist obligatorisch",
	"claim.sample.not": "Ich werde kein Exemplar zusenden",
	"claim.sample.not.recommended": "(nicht empfohlen)",
	"claim.sample.other": "Andere",
	"claim.sample.other.comment": "Geben Sie den Bestimmungsort des Exemplars ein.",
	"claim.status.created": "Erstellt",
	"claim.total.amount": "Gesamtbetrag",
	"claim.total.requested.amount": "Summe des geforderten Betrags",
	"claim.total.requested.calculated": "Gesamtangeforderterbetrag berechnet",
	"claim.total.weight": "Gesamtgewicht",
	"claim.type.filter.label": "Anspruchstyp",
	"claim.type.zl": "Kundenanspruch ZL",
	"claim.type.zr": "Anspruchsregularisierung ZR",
	"claim.visit": "Kontakt von ArcelorMittal",
	"claim.visit.text": "Ich möchte von einem ArcelorMittal-Ansprechpartner kontaktiert werden.",
	"claim.warning": "Warnung",
	"claim.warning.takenintoaccount": "Warnung berücksichtigt",
	"claim.zr.attachment.info": "Bitte geben Sie immer alle betroffenen Chargen und alle relevanten Details (z. B. Menge pro Charge) an, um eine reibungslose und effiziente Schadensbehandlung zu gewährleisten.",
	"coil.calculator.additional.data": "Zusätzliche Daten",
	"coil.calculator.all.other.coils": "Alle anderen Coils",
	"coil.calculator.density.text": "Sie basiert auf einer konstanten Dichte von 7,85 t/m³.",
	"coil.calculator.inner.diameter": "Innendurchmesser des Coil",
	"coil.calculator.inner.diameter.label": "Innendurchmesser des Coil (mm)",
	"coil.calculator.inner.diameter.mandatory": "Innendurchmesser des Coil muss angegeben werden",
	"coil.calculator.input.parameters": "Eingabeparameter",
	"coil.calculator.length": "Länge des Coil",
	"coil.calculator.length.label": "Länge des Coil in Meter",
	"coil.calculator.length.mandatory": "Länge des Coil muss angegeben werden",
	"coil.calculator.metallic.coating.thickness.label": "Stärke der Metallbeschichtung (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Art der Metallbeschichtung",
	"coil.calculator.metallic.coating.type.mandatory": "Art der Metallbeschichtung muss angegeben werden",
	"coil.calculator.no.result.text": "Bitte füllen Sie alle Felder aus, um die Ergebnisse zu sehen.",
	"coil.calculator.nominal.thickness.label": "Nenndicke (mm)",
	"coil.calculator.nominal.thickness.mandatory": "Die Nenndicke ist obligatorisch",
	"coil.calculator.organic.coated.coils": "Organisch beschichtete Coils",
	"coil.calculator.organic.coated.film.thickness.label": "Dicke des organisch beschichteten Films (μm)",
	"coil.calculator.outer.diameter": "Außendurchmesser des Coil",
	"coil.calculator.outer.diameter.label": "Außendurchmesser des Coil (mm)",
	"coil.calculator.outer.diameter.mandatory": "Außendurchmesser des Coil muss angegeben werden",
	"coil.calculator.outer.less.than.inner.error": "Feld kleiner als Innen-Ø",
	"coil.calculator.product.information": "Informationen zum Produkt",
	"coil.calculator.result": "Ergebnis",
	"coil.calculator.specific.weight": "Spezifisches Gewicht",
	"coil.calculator.specific.weight.label": "Spezifisches Gewicht (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "Spezifisches Gewicht muss angegeben werden",
	"coil.calculator.technical.feasibility.text": "Das Tool gibt keine Auskunft über die technische Machbarkeit der berechneten Coils in unseren Werken.",
	"coil.calculator.tool.text": "Dieser \"Coilrechner\" hilft Ihnen bei der Berechnung von Außendurchmesser, Coilgewicht, Coillänge oder spezifischem Gewicht.",
	"coil.calculator.total.paint.thickness.label": "Gesamtlackstärke oben + unten (μm)",
	"coil.calculator.weight": "Coilgewicht",
	"coil.calculator.weight.label": "Coilgewicht (Tonne)",
	"coil.calculator.weight.mandatory": "Coilgewicht muss angegeben werden",
	"coil.calculator.width.label": "Breite (mm)",
	"coil.calculator.width.mandatory": "Breite muss angegeben werden",
	"comment.offer.set": "Kommentare :",
	"commercial-documents-da.enduser": "Endverbraucher",
	"commercial-documents-da.heat": "Wärme",
	"commercial-documents-da.serial": "Seriennummer",
	"commercial-documents-da.supplier-article-reference": "Artikelbezeichnung des Lieferanten",
	"commercial-documents.all-my-documents": "Alle meine Dokumente",
	"commercial-documents.amount": "Amount certified",
	"commercial-documents.batch-number": "Chargennummer",
	"commercial-documents.batches-details": "Details zu den Chargen",
	"commercial-documents.ce.enduser": "Endverbraucher",
	"commercial-documents.ce.serial-number": "Seriennummer",
	"commercial-documents.ce.supplier-article-reference": "Artikelbezeichnung des Lieferanten",
	"commercial-documents.certificate-card": "Zertifikatskarte",
	"commercial-documents.certificate-date": "Datum des Zertifikats",
	"commercial-documents.certificate-number": "Nummer des Zertifikats",
	"commercial-documents.certificate-type": "Art des Zertifikats",
	"commercial-documents.customer": "Kunde",
	"commercial-documents.customer-article-reference": "Artikelbezeichnung des Kunden",
	"commercial-documents.customer-claim-reference": "Kundenreklamationsnummer",
	"commercial-documents.customer-order-number": "Kundenbestellnummer",
	"commercial-documents.date": "Datum des Dokuments",
	"commercial-documents.dimensions": "Abmessungen",
	"commercial-documents.discount": "Rabatt",
	"commercial-documents.dispatch-advice-date": "Datum des Lieferscheins",
	"commercial-documents.dispatch-advice-number": "Lieferscheinnummer",
	"commercial-documents.display-all-orders": "Alle Bestellungen anzeigen",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Seit Ihrer letzten Anmeldung registrierte Dokumente",
	"commercial-documents.documents": "Dokumente",
	"commercial-documents.download-cart": "Warenkorb herunterladen",
	"commercial-documents.emptyHeatNumber": "n./z.",
	"commercial-documents.endQuarter": "End Quarter",
	"commercial-documents.enduser": "Endverbraucher",
	"commercial-documents.final-use": "Endgültige Verwendung",
	"commercial-documents.general-information": "Allgemeine Informationen",
	"commercial-documents.heat-number": "Wärme-Nummer",
	"commercial-documents.invoice": "Rechnung",
	"commercial-documents.invoice-amount": "Rechnungsbetrag (gesamt)",
	"commercial-documents.invoice-amount-without-vat": "Rechnungsbetrag ohne MwSt. (gesamt)",
	"commercial-documents.invoice-card": "Rechnungsbeleg",
	"commercial-documents.invoice-currency": "Währung der Rechnung",
	"commercial-documents.invoice-date": "Rechnungsdatum",
	"commercial-documents.invoice-discount": "Rechnungsrabatt (gesamt)",
	"commercial-documents.invoice-number": "Rechnungsnummer",
	"commercial-documents.invoice-quantity": "RECHNUNGSANZAHL",
	"commercial-documents.invoice-tax-amount": "Rechnungssteuerbetrag (gesamt)",
	"commercial-documents.invoice-type": "Rechnungsart",
	"commercial-documents.invoiced-quantity": "Fakturierte Menge",
	"commercial-documents.invoiced-quantity-unit": "Fakturierte Menge (Einheit)",
	"commercial-documents.line-status": "Status der Zeile",
	"commercial-documents.mill": "Werk",
	"commercial-documents.mill-order-number": "Werksauftragsnummer",
	"commercial-documents.my-commercial-documents": "Meine kommerziellen Dokumente",
	"commercial-documents.number": "Nummer des Dokuments",
	"commercial-documents.order-acknowledgement-date": "Datum der Auftragsbestätigung",
	"commercial-documents.order-acknowledgement-number": "Nummer der Auftragsbestätigung",
	"commercial-documents.order-acknowledgement-type": "Art der Auftragsbestätigung",
	"commercial-documents.order-quantity": "Bestellte Menge  ",
	"commercial-documents.order-reference": "Bestellnummer",
	"commercial-documents.orderAcknowledgement-card": "Auftragsbestätigung",
	"commercial-documents.ordered-quantity": "Bestellte Menge (t)",
	"commercial-documents.orders-line-details": "Details zur Bestellzeile",
	"commercial-documents.orders-number": "Nummer der Bestellung",
	"commercial-documents.payer": "Zahler",
	"commercial-documents.payer-vat-number": "MwSt.-Nummer des Zahlers",
	"commercial-documents.payment-due-date": "Fälligkeitsdatum der Zahlung",
	"commercial-documents.payment-due-to": "Zahlung fällig an",
	"commercial-documents.payment-information": "Zahlungsinformation",
	"commercial-documents.plant-invoice-number": "Nummer der Werksrechnung",
	"commercial-documents.product": "Produkt",
	"commercial-documents.product-descriptions": "Beschreibung des Produkts",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Von SteelUser empfangen",
	"commercial-documents.rrp": "RRP type",
	"commercial-documents.shipto": "Warenempfänger",
	"commercial-documents.soldto": "Auftragsgeber",
	"commercial-documents.steel-grade": "Stahlsorte",
	"commercial-documents.subtype": "Subtyp",
	"commercial-documents.supplier-claim-reference": "Reklamationsnummer des Lieferanten",
	"commercial-documents.supplier-order-number": "Auftragsnummer des Lieferanten",
	"commercial-documents.supplier-vat-number": "Umsatzsteuer-Identifikationsnummer des Lieferanten",
	"commercial-documents.tax": "Steuer",
	"commercial-documents.transport-mode": "Transportart",
	"commercial-documents.transport-reference": "Transport-Referenz",
	"commercial-documents.type": "Art des Dokuments",
	"commercial-documents.vat": "MWST",
	"commercial-documents.vat-percentage": "Prozentsatz der MwSt.",
	"commercial-documents.weight": "Gewicht",
	"commercial-documents.without-vat": "Ohne MwSt.",
	"commercial-documents.xcarbsubtype": "XCarb® sub-type",
	"confirm.continue": "Möchten Sie fortfahren?",
	"confirm.modified": "Zuletzt geändert am",
	"confirm.respectively": "entsprechend.",
	"confirm.same.material": "Es gibt einen weiteren Anspruch auf dieselbe Materialeinheit mit Bezug auf",
	"confirm.thanks": "Vielen Dank, wir haben Ihre Anfrage erhalten.",
	"confirm.thanks.fastlane": "Danke, wir haben Ihre Anfrage erhalten.",
	"confirmation.message": "Nach der Bestätigung können Sie diese Aktion nicht mehr rückgängig machen.",
	"contact.us": "Kontaktieren Sie uns",
	"contactmail.popup.success.msg-line1": "Vielen Dank. Wir haben Ihre Nachricht erhalten.",
	"contactmail.popup.success.msg-line2": "Wir werden Ihnen so bald wie möglich eine Rückmeldung geben.",
	"contactmail.submit.attachment.error.msg": "Entschuldigung, es gibt ein Problem mit Ihrem Anhang, bitte versuchen Sie, ihn neu zu laden.",
	"contactmail.submit.error.msg": "Entschuldigung, es gab ein Problem mit dem Versenden von E-Mails. Bitte versuchen Sie es später noch einmal.",
	"contactmail.submit.session.error.msg": "Entschuldigung, es gibt ein Problem mit Ihrer Sitzung. Bitte versuchen Sie, sich erneut anzumelden.",
	"continue.draft": "Setzen Sie Ihren Entwurf fort",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Eine neue Bestellung erstellen",
	"create.new.request": "EINE NEUE ANFRAGE ERSTELLEN",
	"customer.share.view": "Die Ansicht teilen",
	"customer.simulation": "Kunden auswählen",
	"dashboard.active.parameters": "Aktive Parameter",
	"dashboard.add-widget": "Widget hinzufügen",
	"dashboard.add-widget-instruction": "Bitte wählen Sie das Widget aus, das Sie hinzufügen möchten",
	"dashboard.cancel": "Abbrechen",
	"dashboard.card.time-in-stock": "Lagerdauer",
	"dashboard.card.time-in-stock.time-to-call": "ANRUFZEIT",
	"dashboard.card.time-in-stock.view-details": "Details anzeigen",
	"dashboard.claims": "Reklamationen",
	"dashboard.condition": "Bedingung:",
	"dashboard.customer-material-reference": "Kundenmaterialnummer",
	"dashboard.customize-indicator": "Anpassen",
	"dashboard.customize-information": "Anpassen",
	"dashboard.delete.confirmation-question": "Möchten Sie dieses Widget wirklich löschen?",
	"dashboard.documents-since-last-connection": "Seit Ihrer letzten Verbindung registrierte Dokumente",
	"dashboard.drag-customer-article-here": "Geben Sie hier die Referenz des Kundenartikels ein",
	"dashboard.drag-drop-information": "Ziehen Sie die Werte in das Feld rechts und legen Sie sie dort ab",
	"dashboard.drag-steelgrades-here": "Geben Sie hier die Stahlsorten ein",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Indikator",
	"dashboard.information": "Informationen",
	"dashboard.key-indicator": "Schlüsselindikator",
	"dashboard.key-information": "Wichtige Informationen",
	"dashboard.my-business-overview": "Überblick  ",
	"dashboard.my.data": "Meine Daten",
	"dashboard.order-status": "Auftragsstatus",
	"dashboard.orders": "Aufträge",
	"dashboard.rts-widget.title": "Lager",
	"dashboard.rts-widget.tooltip": "Lieferbare Menge für dieses Produkt in allen Lagerbeständen",
	"dashboard.savechanges": "Änderungen speichern",
	"dashboard.saving": "Dashboard-Widgets wird gespeichert ...",
	"dashboard.schedule.business.order-status": "Lieferpläne",
	"dashboard.spot.order-status": "Auftragsübersicht",
	"dashboard.steelgrade": "Stahlsorte",
	"dashboard.validate": "Bestätigen",
	"dashboard.view.more": "Mehr",
	"dashboard.widget-configuration": "Aufbau",
	"dashboard.widget-preview": "Vorschau",
	"dashboard.widget.highest-stocks": "Top 5 der höchsten Bestände",
	"dashboard.widget.material-ready-to-ship": "Versandbereit",
	"dashboard.without-value": "Kein wert",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Preisangebot",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Back-Office Kunde",
	"datacenter-filter.back-office-role": "Back-Office Rolle",
	"datacenter-filter.batch-reference": "Chargen Referenz",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Rechnungsempfänger",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "Bestätigtes Lieferdatum (Woche)",
	"datacenter-filter.cdd-date": "Bestätigtes Lieferdatum",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Auswahl",
	"datacenter-filter.coating": "Beschichtungsspezifikation",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Collate Documents",
	"datacenter-filter.color-bottom-side": "Farbe Unterseite",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Farbe Oberseite",
	"datacenter-filter.creation-date": "Erstellungsdatum",
	"datacenter-filter.current-location": "Aktueller Lagerort",
	"datacenter-filter.customer-article-reference": "Kundenartikelreferenz",
	"datacenter-filter.customer-order-number": "Kundenbestellnummer",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Organ fiche untere Seite",
	"datacenter-filter.data-sheet-top-side": "Organ fiche obere Seite",
	"datacenter-filter.date-available-for-dispatch": "Versandbereitsdatum",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Lieferadresse",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Lieferart",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Reiseziel per Boot",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Detaillierter Coilstatus",
	"datacenter-filter.dimension": "Dim (mm)",
	"datacenter-filter.dispatch-advice": "Lieferschein",
	"datacenter-filter.dispatch-advice-date": "Verladedatum",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Versanddatum",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Versanddatum",
	"datacenter-filter.dispatch-advice-number": "Lieferschein",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Lieferschein",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Lieferschein",
	"datacenter-filter.dispatch-date": "Versanddatum",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "Endverbraucher",
	"datacenter-filter.final-use": "Verwendungszweck",
	"datacenter-filter.first-name": "Vorname",
	"datacenter-filter.form": "Form",
	"datacenter-filter.grade": "Grad",
	"datacenter-filter.gross-consignment": "Konsi.(Brutto,t)",
	"datacenter-filter.gross-first-batch": "Erste Charge auf Lager (Woche)",
	"datacenter-filter.gross-in-transit-details": "Details zum Transport (brutto, t)",
	"datacenter-filter.gross-last-batch": "Spätester Lagereingang (Woche)",
	"datacenter-filter.heat-number": "Schmelznummer ",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Interpretation Lieferdatum",
	"datacenter-filter.invalid-number": "Ungültige Nummer",
	"datacenter-filter.item-sold-to-party": "Item Kunde",
	"datacenter-filter.last-name": "Nachname",
	"datacenter-filter.length": "Länge (m)",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Werk",
	"datacenter-filter.mill-order-number": "Werks Nummer",
	"datacenter-filter.net-consignment": "Konsi.(Netto,t)",
	"datacenter-filter.net-in-transit": "im Transit (Net, t)",
	"datacenter-filter.net-in-transit-details": "Details zum Transport (netto, t)",
	"datacenter-filter.net-ready-to-ship": "RTS (Netto, t )",
	"datacenter-filter.nominal-gloss-bottom-side": "Nominaler Glanz Unterseite",
	"datacenter-filter.nominal-gloss-top-side": "Nominaler Glanz Oberseite",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Order created by",
	"datacenter-filter.order-creator": "Order creator",
	"datacenter-filter.order-item-status": "Item Status",
	"datacenter-filter.order-reason": "Bestellgrund",
	"datacenter-filter.organic-structure-bottom-side": "Struktur org.Besch.Unterseite",
	"datacenter-filter.organic-structure-top-side": "Struktur org.Besch.Oberseite",
	"datacenter-filter.organization-city": "Stadt",
	"datacenter-filter.organization-id": "ID der Organisation",
	"datacenter-filter.organization-name": "Name der Organisation",
	"datacenter-filter.organization-role": "Rolle",
	"datacenter-filter.organization-service": "Organisation Service",
	"datacenter-filter.organization-status": "Organisation Status",
	"datacenter-filter.organization-suppliers": "Organisation Lieferanten",
	"datacenter-filter.organization-type": "Organisation Art",
	"datacenter-filter.package-serial-number": "Serienummer des Pakets",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "geplantes Ladedatum",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Produzierte Dim",
	"datacenter-filter.producedLength": "Produzierte länge (m)",
	"datacenter-filter.producedThickness": "Produzierte dicke (mm)",
	"datacenter-filter.producedWidth": "Produzierte Breite (mm)",
	"datacenter-filter.product-category": "Produkt Kategorie",
	"datacenter-filter.product-description": "Produkt Beschreibung ",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Protektion",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Vorläufiges Item",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "Gewünschtes Lieferdatum",
	"datacenter-filter.rdd-date": "Gewünschtes Lieferdatum",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Verkaufsquartal",
	"datacenter-filter.service-level": "Service Level",
	"datacenter-filter.service-request": "Serviceanfrage",
	"datacenter-filter.ship-to": "Warenempfänger",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Kunde",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot or schedule",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Stahlsorte",
	"datacenter-filter.steeluser-order-number": "eBusiness Auftragsnummer",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Oberfläche",
	"datacenter-filter.thickness": "Dicke (mm)",
	"datacenter-filter.total-thickness-coating-bottom": "Gesamtdicke der Bodenbeschichtung (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Gesamtdicke der Oberflächenbeschichtung (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Markenname Unterseite",
	"datacenter-filter.trademark-name-top-side": "Markenname Oberseite",
	"datacenter-filter.transport-mode": "Transport Art",
	"datacenter-filter.transport-mode-n1": "N-1 Transport Art",
	"datacenter-filter.transport-mode-n2": "N-2 Transport Art",
	"datacenter-filter.transport-reference": "Transportreferenz",
	"datacenter-filter.transport-reference-n1": "N-1 Transportreferenz",
	"datacenter-filter.transport-reference-n2": "N-2 Transportreferenz",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Erstellungsdatum",
	"datacenter-filter.user-email": "E-Mail",
	"datacenter-filter.user-first-name": "Vorname",
	"datacenter-filter.user-id": "ID",
	"datacenter-filter.user-last-name": "Nachname",
	"datacenter-filter.user-organization-name": "Name der Organisation",
	"datacenter-filter.user-role": "Rolle",
	"datacenter-filter.user-status": "Status",
	"datacenter-filter.users-city": "Stadt",
	"datacenter-filter.users-countrycode": "Länder-Code",
	"datacenter-filter.width": "Breite",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Charge",
	"datacenter-shipment.customer": "Kunde",
	"datacenter-shipment.customer-article-reference": "Artikelbezeichnung des Kunden",
	"datacenter-shipment.customer-order-number": "Kundenbestellnummer",
	"datacenter-shipment.date-available-for-dispatch": "Datum der Versandbereitschaft",
	"datacenter-shipment.dispatch-advice-date": "Datum des Lieferscheins",
	"datacenter-shipment.dispatch-advice-number": "Lieferscheinnummer",
	"datacenter-shipment.grade": "Stahlsorte",
	"datacenter-shipment.gross-weight": "Bruttogewicht (t)",
	"datacenter-shipment.mill": "Werk",
	"datacenter-shipment.net-weight": "Nettogewicht (t)",
	"datacenter-shipment.ship-to": "Versand an",
	"datacenter-shipment.shipment-quantity-gross": "VSB (Brutto, t)",
	"datacenter-shipment.shipment-quantity-net": "VSB (Netto, t)",
	"datacenter-shipment.supplier-order-number": "Lieferantenauftragsnummer",
	"datacenter-shipment.thickness": "Dicke (mm)",
	"datacenter-shipment.transport-mode": "Transportart",
	"datacenter-shipment.transport-reference": "Transport-Referenz",
	"datacenter-shipment.width": "Breite (mm)",
	"datacenter.add-columns": "Spalte hinzufügen",
	"datacenter.all": "alle",
	"datacenter.all-columns-added-to-grid": "Alle Spalten dem Raster hinzufügen",
	"datacenter.all-data-center": "Alle Data center",
	"datacenter.annealed": "Geglüht",
	"datacenter.apply": "Übertragen",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "Beim Verschiffer (Brut, t)",
	"datacenter.at-reshipper-net": "Beim Verschiffer (Net, t)",
	"datacenter.balanced-not-produced": "Wird nicht produziert",
	"datacenter.batch": "Batches",
	"datacenter.batches": "Data center: Batches",
	"datacenter.calloff": "Rechenzentrum: elektronischer Abruf",
	"datacenter.calloff-by-batch": "Elektronischer Abruf nach Charge",
	"datacenter.calloff-by-volume": "Elektronischer Abruf nach Volumen",
	"datacenter.cancel": "abbrechen",
	"datacenter.click-on-items-on-the-right": "Klicken Sie auf das Item rechts um einen Filter hinzuzufügen",
	"datacenter.cold-rolled": "Kaltgewalzt",
	"datacenter.columns": "Spalten",
	"datacenter.commercial-documents": "Data center: Kommerzielle Dokumente",
	"datacenter.composite": "Zusammensetzung",
	"datacenter.create-new-view": "Neue Übersicht erstellen",
	"datacenter.current-layout": "aktuelles Layout",
	"datacenter.customize-view": "personalisierte Ansicht",
	"datacenter.cutting-beveling": "Schneiden und Abschrägen",
	"datacenter.data-center": "Data center",
	"datacenter.data-center-shipments": "Data center: Lieferungen",
	"datacenter.default": "Standard",
	"datacenter.delete": "Gelöscht",
	"datacenter.do-you-want-remove": "möchten Sie diese Ansicht verwerfen",
	"datacenter.document": "Kommerzielle Dokumente",
	"datacenter.documents": "Dokumente",
	"datacenter.download-invoice": "Rechnung herunterladen",
	"datacenter.drag-and-drop-item-hint": "Ziehen und lassen Sie ein Item fallen um eine Spalte hinzuzufügen oder zu entfernen",
	"datacenter.drag-element-here-fixed": "Ziehen Sie hier um eine feste Spalte hinzuzufügen.",
	"datacenter.drag-element-here-hide": "Ziehen Sie das Element hierher, um die Spalten im Raster auszublenden.",
	"datacenter.drag-element-here-scrollable": "Ziehen Sie hier, um scrollbare Spalten hinzuzufügen.",
	"datacenter.edit-view": "Eigene Übersicht erstellen",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filter",
	"datacenter.fixed-columns": "Fixierte Spalten",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "Unter - 30 Tage",
	"datacenter.graph.fourth-bar-label": "91 - Über",
	"datacenter.graph.second-bar-label": "31 - 60 Tage",
	"datacenter.graph.third-bar-label": "61 - 90 Tage",
	"datacenter.guarantee": "Rechenzentrum: Garantie",
	"datacenter.handed-over-to-planning": "In Planung",
	"datacenter.hot-rolled": "Warmgewalzt",
	"datacenter.in-transit-gross": "in Transit (Brutto, t)",
	"datacenter.in-transit-to-customer-gross": "Auf dem Transportweg zum Kunden (brutto, t)",
	"datacenter.in-transit-to-customer-net": "Auf dem Transportweg zum Kunden (netto, t)",
	"datacenter.land-transit-gross": "Landtransit (Brut, t)",
	"datacenter.land-transit-net": "Landtransit (Net, t)",
	"datacenter.layout": "Layout",
	"datacenter.layout-sorting": "Layout und Sortierung",
	"datacenter.metallic-coated": "Metallisch beschichtet",
	"datacenter.minimal-quantity-for-this-item-is": "Die Mindestmenge für diesen Artikel beträgt",
	"datacenter.name-your-new-layout": "benne dein neues Layout",
	"datacenter.nb-days-in-stock": "Anzahl Tage im Lager",
	"datacenter.net-qty-delivered": "Geliefert (Netto t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Normaliesieren",
	"datacenter.offer": "Angebote",
	"datacenter.offer.subcategory": "Unterkategorie",
	"datacenter.offers": "Datenzentrum: Angebotszeilen",
	"datacenter.on-vessel-gross": "Verschifft (Brut, t)",
	"datacenter.on-vessel-net": "Verschifft (Net, t)",
	"datacenter.open-needs": "Offene Bedarfe",
	"datacenter.or-save-as-a-new-view": "oder speichere als neue Ansicht",
	"datacenter.order": "Aufträge",
	"datacenter.ordered": "Bestellt (t)",
	"datacenter.orders": "Data center: Aufträge",
	"datacenter.organic-coated": "Organisch beschichtet",
	"datacenter.organization": "Organisationen",
	"datacenter.organizations": "Data center: Organisationen",
	"datacenter.overseas-transit-gross": "Überseetransit (Brut, t)",
	"datacenter.overseas-transit-net": "Überseetransit (Net, t)",
	"datacenter.oxi-cutting": "Oxy Schneiden",
	"datacenter.packing": "Verpackung",
	"datacenter.pickled": "Gebeizt",
	"datacenter.planned-casting": "Guss geplant",
	"datacenter.prematerial-ordered": "Bestelltes Vor-Material",
	"datacenter.prototypes": "Rechenzentrum: Prototypen",
	"datacenter.qty-delivered": "Geliefert (Brutto t)",
	"datacenter.qty-gross": "Brutto (t)",
	"datacenter.qty-in-production": "WIP (t)",
	"datacenter.qty-in-transit": "in transit (t)",
	"datacenter.qty-net": "Netto (t)",
	"datacenter.qty-not-delivered": "Not Delivered (Gross, t)",
	"datacenter.qty-ordered": "Best (t)",
	"datacenter.qty-ready-to-ship": "Versandbereit (t)",
	"datacenter.quality": "Reklamationen",
	"datacenter.quality-control": "Qualitätskontrolle (t))",
	"datacenter.quality-issues": "Data center: Reklamationen",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "Die angeforderte Menge ist größer als der Maximalwert.",
	"datacenter.reset-all-filters": "Alle Filter zurücksetzen",
	"datacenter.result": "1 Ergebnis",
	"datacenter.results": "{{value}} Ergebnisse",
	"datacenter.rolling-stand": "Walzgerüst",
	"datacenter.rts-gross": "VSB (Brutto, t)",
	"datacenter.save": "Speichern",
	"datacenter.save-as": "speichern unter…",
	"datacenter.save-changes-in-the-view": "speichere Änderung in der Ansicht.",
	"datacenter.save-new-layout-as": "Neue Ansicht speichern unter…",
	"datacenter.save-new-view": "speicher neue Ansicht",
	"datacenter.save-the-view": "speicher Ansicht",
	"datacenter.schedule-business-order": "Lieferpläne",
	"datacenter.schedule-business-orders": "Data center: Lieferpläne",
	"datacenter.scrollable-columns": "Scrollbare Spalten",
	"datacenter.select-a-view": "wähle eine Ansicht",
	"datacenter.selected": "Wert ausgewählt",
	"datacenter.shipment": "Lieferungen",
	"datacenter.shot-blasting": "Sandstrahlen",
	"datacenter.skin-pass": "Dressieren",
	"datacenter.slab": "Bramme",
	"datacenter.slitting": "Spalten",
	"datacenter.sorting": "sortieren",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Gesamt",
	"datacenter.users": "Data center: Benutzer",
	"datacenter.view-load-error": "Daten Zenter Ansicht kann nicht geladen werden.",
	"datacenter.view-name": "Ansichtsname",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "Der Ansichtsname muss eindeutig sein",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Filter hinzufügen",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "Sie haben zu viele feste Spalten, um eine neue Spalte hinzuzufügen.",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Werkszeugnis",
	"datacenterview.DispatchAdvice": "Lieferschein",
	"datacenterview.Invoice": "Rechnung",
	"datacenterview.OrderAcknowledgment": "Auftragsbestätigung",
	"defect.CDCUS00A": "Abmessungen",
	"defect.CDCUS00B": "Gewicht",
	"defect.CDCUS00C": "Oberflächenbeschaffenheit",
	"defect.CDCUS00D": "Beschichtungsproblem",
	"defect.CDCUS00E": "Schweißnähte",
	"defect.CDCUS00F": "Rost",
	"defect.CDCUS00G": "Ebenheit",
	"defect.CDCUS00H": "Mech Prop / Chemische Analyse",
	"defect.CDCUS00I": "Probleme bei der Metallbearbeitung",
	"defect.CDCUS00J": "Verpackung",
	"defect.CDCUS00K": "Lieferzeit",
	"defect.CDCUS00L": "Transport",
	"defect.CDCUS00M": "Etikettenfehler",
	"defect.Z/CDCUS00A/0600": "Abmessungen",
	"defect.Z/CDCUS00B/0100": "Coilgewicht",
	"defect.Z/CDCUS00B/0200": "Gelieferte Menge (zu viel/zu wenig, Abweichung von der in Rechnung gestellten Menge usw.)",
	"defect.Z/CDCUS00C/0400": "Rost und Oxidation",
	"defect.Z/CDCUS00C/1400": "Oberflächenbeschaffenheit",
	"defect.Z/CDCUS00D/0500": "Beschichtungsproblem",
	"defect.Z/CDCUS00E/0400": "Schweißnähte",
	"defect.Z/CDCUS00F/0400": "Oberflächenschutz (Öl, Film usw.)",
	"defect.Z/CDCUS00G/0700": "Ebenheit",
	"defect.Z/CDCUS00H/0600": "Qualität (mechanische Eigenschaften, chemische Analyse usw.)",
	"defect.Z/CDCUS00I/0600": "Verarbeitung",
	"defect.Z/CDCUS00J/0900": "Präsentation (Verpackung, Etikett, Wicklung usw.)",
	"defect.Z/CDCUS00K/0300": "Lieferzeit",
	"defect.Z/CDCUS00L/0100": "Transportfehler (Adresse, Transportmittel)",
	"defect.Z/CDCUS00L/0600": "Transportschaden",
	"defect.Z/CDCUS00M/0300": "Technische Unterlagen (Zertifikate, Produktbeschreibungen, Frachtbrief usw.)",
	"delete.draft": "Ihre Vorlage löschen",
	"delete.only-administrator": "Es ist nicht möglich, diesen Benutzer zu löschen, da es keinen anderen Benutzer im Unternehmen gibt.",
	"delivery-tracking.at-overseas-stock": "Im Lager für Übersee",
	"delivery-tracking.delivery-follow-up": "Versandverfolgung",
	"delivery-tracking.in-land-transit": "Im Landtransport",
	"delivery-tracking.in-overseas-transit": "Auf dem Übersee transport",
	"delivery-tracking.in-transit-to-customer": "im Transit zum Kunden",
	"delivery-tracking.order-and-delivery-overview": "Auftrags- und Lieferübersicht",
	"delivery-tracking.stock-per-mill": "Lagerbestand pro Werk",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "Zum Umlader / Im Landverkehr / Zum Lager",
	"delivery-tracking.total": "total",
	"delivery-tracking.view-details": "Details anzeigen",
	"delivery.status.late": "Verspätet",
	"delivery.status.on-customer-time": "Nach Kundenzeit",
	"delivery.status.on-supplier-time": "Nach Lieferantenzeit",
	"delivery.status.on-time": "Nach Zeit",
	"dialog-upload-file": "Bitte laden Sie eine Datei hoch",
	"dialog.all-column-added-to-grid": "Alle Spalten zum Raster hinzugefügt",
	"dialog.apply": "Übernehmen",
	"dialog.customize.view.title": "Wählen Sie die Spalten durch Ziehen und Ablegen",
	"dialog.delete.description": "Wollen Sie diesen Benutzer wirklich entfernen?",
	"dialog.delete.title": "Benutzer entfernen",
	"dialog.drag-elements-here-hide": "Element ziehen, um Spalten im Raster auszublenden",
	"dialog.drag-elements-here-scrollable": "Ziehen Sie hier, um Spalten im Layout hinzuzufügen",
	"dialog.loose-data-message": "Dadurch werden alle Ihre Daten gelöscht. Möchten Sie fortfahren?",
	"dialog.select.batch": "Charge wählen",
	"doc-ce-subtype.01": "2.1: Erklärung zur Konformität mit der Bestellung",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1: Inspektionsbescheinigung 3.1",
	"doc-ce-subtype.51": "2.2: Prüfbericht",
	"doc-ce-subtype.52": "3.1: Inspektionsbescheinigung 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Konformitätsbescheinigung",
	"doc-ce-subtype.ccpu": "Prüfzertifikat",
	"doc-ce-subtype.cem": "CE-Kennzeichnung",
	"doc-ce-subtype.ceran": "Prüfzertifikat 2.2 Chem. Analyse",
	"doc-ce-subtype.cerre": "Empfangsbestätigung",
	"doc-ce-subtype.cerus": "Empfangsbestätigung",
	"doc-ce-subtype.cinsp": "Inspektionsbescheinigung 3.2",
	"doc-ce-subtype.ctl": "Inspektionsbericht",
	"doc-ce-subtype.fcp": "Produktdatenblatt",
	"doc-ce-subtype.ohsas": "Sicherheitsbericht",
	"doc-in-subtype.AVOIR": "Gutschrift",
	"doc-in-subtype.DEBIT": "Abbuchungsschreiben",
	"doc-in-subtype.FACTU": "Rechnung",
	"doc-oa-subtype.N": "Geändert",
	"doc-oa-subtype.O": "Original",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Download detailed report",
	"download.pdf-files": "PDF-Dateien herunterladen",
	"draft.creationdate": "Datum der Erstellung",
	"draft.deleted.successfully": "Ihre Vorlagenangebot wurde ordnungsgemäß gelöscht",
	"draft.lastupdate": "Letzte Aktualisierung",
	"draft.selected.product": "Ausgewähltes Produkt",
	"draft.total.tons": "Tonnen insgesamt",
	"draft.value": "VORLAGE",
	"draftoffer.list": "Liste der Vorlagen",
	"draftorder.list": "Liste der Vorlagen",
	"drafts.all.drafts": "Alle Vorlagen",
	"drafts.has.been.deleted": "Die Vorlage wurde gelöscht.",
	"drafts.my.drafts": "Meine Vorlagen",
	"drafts.no.draft": "Keine Vorlage",
	"drafts.saved": "Vorlage(n) gespeichert",
	"drafts.search.drafts": "Vorlagen suchen",
	"drafts.sort.by.modification": "Nach Änderung sortieren",
	"drafts.sort.by.reference": "Nach Referenz sortieren",
	"drag.and.drop.files": "Ziehen und ablegen",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "Alle Chargen",
	"ecall-off.apply-for-all": "Für alle anwenden",
	"ecall-off.batch": "Charge",
	"ecall-off.batches": "Chargen",
	"ecall-off.call-off": "Abruf",
	"ecall-off.call-off-by-batch": "Abruf nach Material",
	"ecall-off.call-off-by-volume": "Abruf nach Volumen",
	"ecall-off.call-off-date": "Elektronischer Abruf Datum",
	"ecall-off.call-off-follow-up": "Abrufübersicht",
	"ecall-off.call-off-header-information": "Header-Informationen zum Abruf",
	"ecall-off.call-off-request": "Abrufantrag",
	"ecall-off.callable-weight": "Verfügbares Material insgesamt (To)",
	"ecall-off.called-batches": "Abgerufene Chargen",
	"ecall-off.called-order-items": "Abgerufene Auftragspositionen",
	"ecall-off.called-volume": "Abgerufenes Volumen (To)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Werke ändern",
	"ecall-off.choose-batches": "Wählen Sie die Chargen, die Sie abrufen möchten",
	"ecall-off.choose-order-items": "Wählen Sie die Auftragspositionen, die Sie abrufen möchten",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Kopieren nach",
	"ecall-off.customer-call-off-reference": "Referenz für den Kundenabruf",
	"ecall-off.do-you-really-want-to-change-mills": "Wollen Sie die Werke wirklich ändern?",
	"ecall-off.ecall-card": "Ecall-off-Karte",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "Eingabe der Abrufinformationen",
	"ecall-off.last-call-off-demand": "Letzter Abrufauftrag",
	"ecall-off.material-picking": "Materialkommissionierung",
	"ecall-off.max": "Max. {{value}}",
	"ecall-off.mill-section": "Auswahl des Werks",
	"ecall-off.my-ecalls": "Meine E-Call-offs",
	"ecall-off.no-batches-found": "Keine Chargen gefunden",
	"ecall-off.no-mills": "Es gibt kein Werk mit abrufbaren Chargen.",
	"ecall-off.no-selected-batches": "keine ausgewählten Chargeb",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "Auftragspositionen",
	"ecall-off.personnalize-your-call-off-informations": "Personalisieren Sie Ihre Abrufinformationen",
	"ecall-off.rdd-mode": "RDDC-Modus",
	"ecall-off.ready-to-call": "Ihre {{objects}} abrufbereit",
	"ecall-off.requested-date": "Gewünschter Termin",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "erforderlich",
	"ecall-off.see-card": "Siehe Karte",
	"ecall-off.select-a-mill": "Wählen Sie ein Werk, um Ihr versandfertiges Material anzuzeigen",
	"ecall-off.select-your-mill": "Wählen Sie Ihr Werk aus",
	"ecall-off.selected": "{{value}} ausgewählt",
	"ecall-off.selected-batches": "{{value}} ausgewählte Chargen",
	"ecall-off.selected-batches-only": "Nur ausgewählte Chargen",
	"ecall-off.selected-only": "Nur ausgewählte",
	"ecall-off.selection-will-be-rest": "Die Auswahl wird zurückgesetzt.",
	"ecall-off.separate-email-addresses": "Bitte trennen Sie E-Mail-Adressen durch <<;>> (Semikolon)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "Neuen Abruf erstellen",
	"ecall-off.submit-call-off": "Übermitteln Sie Ihren Abrufantrag",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "Zusammenfassung des Abrufs",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "Die",
	"ecall-off.tons": "Tonnen",
	"ecall-off.total-called-weight": "Gesamtes abgerufenes Gewicht",
	"ecall-off.total-material-request": "Gesamte Materialanforderung",
	"ecall-off.type-your-comment": "Geben Sie Ihre Anmerkung ein",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Referenz zum Entladen",
	"ecall-off.view-batch-card": "Chargenkarte ansehen",
	"ecall-off.your-batches-ready-to-call": "Ihre abrufbereiten Chargen",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Schnellsuche\tz...",
	"edit.draft": "Vorlagen bearbeiten",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Anhang hinzufügen",
	"elink.category": "Kategorie",
	"elink.comment": "Kommentar",
	"elink.comment-is-required": "Kommentar ist erforderlich",
	"elink.contact-mill": "Kontakt Werk",
	"elink.copy-to": "Kopieren nach",
	"elink.data-automatically-sent-with-the-mail": "Daten werden automatisch mit der Mail gesendet",
	"elink.delete": "löschen",
	"elink.dimension": "Dimension (mm)",
	"elink.from": "von",
	"elink.invalid-email-format": "Ungültiges Format der E-Mail-Adresse",
	"elink.message": "Nachricht",
	"elink.send": "Abschicken",
	"elink.subject": "Gegenstand",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "Enddatum",
	"eoffer-From.month": "Vom Monat",
	"eoffer-Period.label": "Zeitraum",
	"eoffer-Period.type": "Typ des Zeitraums",
	"eoffer-Period.type.custom": "Für ein benutzerdefiniertes Intervall",
	"eoffer-Period.type.month": "Für ein Monatsintervall",
	"eoffer-Period.type.quarter": "Für ein Quartalsintervall",
	"eoffer-Period.type.semester": "Für ein Semesterintervall",
	"eoffer-Period.type.year": "Für ein Jahresintervall",
	"eoffer-Quarter": "Quartal",
	"eoffer-Semester": "Semester",
	"eoffer-To.month": "Bis zum Monat",
	"eoffer-selected.period": "Ausgewählter Zeitraum",
	"eoffer.Choose.the.split.of.quantities.by": "Wählen Sie die Aufteilung der Mengen durch",
	"eoffer.accepted": "Akzeptiert",
	"eoffer.action.default": "Standard",
	"eoffer.action.delete": "Löschen",
	"eoffer.action.duplicate": "Duplikat",
	"eoffer.action.new": "Neu",
	"eoffer.action.new.request": "Anfrage",
	"eoffer.action.new.request.for-a-new": "für ein neues Angebot",
	"eoffer.additional.fields": "Zusätzliche Eigenschaften",
	"eoffer.assistant": "Commercial Kontakt (Assistant)",
	"eoffer.available.fields": "Verfügbare Eigenschaften",
	"eoffer.cancel": "Abbrechen",
	"eoffer.cart.finalise": "Einkaufswagen fertigstellen",
	"eoffer.cart.input.request": "Geben Sie die gewünschte Menge, das Lieferdatum und andere Informationen ein",
	"eoffer.cart.volume.request": "Angefordertes Volumen",
	"eoffer.choose.split.quantities.error": "Bitte wählen Sie die Aufteilung der Mengen",
	"eoffer.choose.split.quantity.error": "Bitte wählen Sie die Mengenaufteilung",
	"eoffer.cockpit": "eAngebot Cockpit",
	"eoffer.comment": "Kommentar",
	"eoffer.comment.product.is": "Ihr Kommentar zu diesem Produkt",
	"eoffer.confirm.thanks": "Vielen Dank, wir haben Ihre Anfrage erhalten.",
	"eoffer.continue": "Weiter",
	"eoffer.continue.draft": "Vorlage fortsetzen",
	"eoffer.create.enduser": "Endverbraucher",
	"eoffer.currency": "Währung",
	"eoffer.current.step": "Aktueller Schritt",
	"eoffer.customer": "Kunde",
	"eoffer.datacenter.offerLines": "Datencenter: Angebotslinien",
	"eoffer.delivery.date": "Interpretation des Lieferdatums",
	"eoffer.dialog.clear.products": "Wenn Sie die Kunden- oder Lieferadresse oder den Endverbraucher ändern, gehen die Produkte im Warenkorb verloren. Möchtest du fortfahren?",
	"eoffer.dialog.month": "Monat",
	"eoffer.dialog.monthweek": "Monat oder Woche",
	"eoffer.dialog.offer.remove.product": "Das ausgewählte Produkt entfernen - wollen Sie fortfahren?",
	"eoffer.dialog.offer.submission.error": "Fehler beim Senden des Angebots",
	"eoffer.dialog.pdm": "Bevorzugtes Lieferwerk",
	"eoffer.dialog.period": "Wählen Sie die Periode aus",
	"eoffer.dialog.quantity": "Menge",
	"eoffer.dialog.requested.delivery.time": "Wählen Sie die angefragte Lieferzeit aus",
	"eoffer.dialog.reset.requested.delivery.time": "Sie ändern den Zeitraum und setzen Sie die gewünschten Lieferzeiten zurück. Möchten Sie fortfahren?",
	"eoffer.dialog.week": "Woche",
	"eoffer.dialog.year": "Jahr",
	"eoffer.dimension.mm": "Abmessungen (mm)",
	"eoffer.draft": "Vorlage",
	"eoffer.draft.edit.message.line": "um sie an ArcelorMittal zu übermitteln oder zu löschen.",
	"eoffer.draft.edit.message.text": "Sie können es später in Ihrer … bearbeiten",
	"eoffer.draft.list.link": "Vorlagenliste",
	"eoffer.draft.saved.successfully": "Ihre Angebotsanfrage wurde ordnungsgemäß als Entwurf gespeichert",
	"eoffer.drafts": "Vorlagen",
	"eoffer.enduser": "Endverbraucher",
	"eoffer.entry": "Angebotserfassung",
	"eoffer.error.loading": "Nicht möglich die Parameterwerte zu laden",
	"eoffer.error.noenduser": "Kunde ohne Endverbraucher",
	"eoffer.error.noshipto": "Kunde ohne Warenempfänger",
	"eoffer.error.noshiptoenduser": "Kunde ohne Warenempfänger und Endverbraucher",
	"eoffer.error.nosoldto": "Kunde nicht gefunden",
	"eoffer.feasibility": "Realisierbarkeit",
	"eoffer.feasibility.no": "Abgelehnt",
	"eoffer.feasibility.pending": "Offene",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Eigenschaft",
	"eoffer.form": "Form",
	"eoffer.header.commercial.contacts": "GESCHÄFTSKONTAKT",
	"eoffer.header.commitment.period": "Bindungsfrist:",
	"eoffer.header.custOffNumber": "Referenz für Kundenangebot",
	"eoffer.header.customer": "Kunde",
	"eoffer.header.entity.information": "Informationen zu Entitäten",
	"eoffer.header.last.update.date": "Datum der letzten Aktualisierung",
	"eoffer.header.offer.name": "Name des Angebots",
	"eoffer.header.offer.validity.date": "Geltungsdauer des Angebots:",
	"eoffer.header.suppOffNumber": "Referenz des Lieferantenangebots",
	"eoffer.header.technical.contacts": "TECHNISCHER KONTAKT",
	"eoffer.header.terms.information": "Informationen zu den Bedingungen",
	"eoffer.header.total": "Gesamt",
	"eoffer.home": "eAngebot",
	"eoffer.home.active": "Angebote",
	"eoffer.home.cockpit": "Mein eAngebot Cockpit",
	"eoffer.home.request": "Neu",
	"eoffer.home.tool": "Ein Angebot anfragen",
	"eoffer.idd.not.found": "Parameter für die Interpretation des Lieferdatums nicht gefunden",
	"eoffer.in.calculation": "In Berechnung",
	"eoffer.incot.not.found": "Incoterm Parameter nicht gefunden",
	"eoffer.incoterms": "Incoterm",
	"eoffer.interpretation.delivery.date": "Interpretation des Lieferdatums",
	"eoffer.mandatory.currency.reference": "Die Währung muss angegeben werden",
	"eoffer.mandatory.delivery.address": "Die Lieferadresse ist eine Pflichtangabe",
	"eoffer.mandatory.enduser.reference": "Der Endverbraucher muss angegeben werden",
	"eoffer.mandatory.idd.reference": "Die Interpretation des Lieferdatums muss angegeben werden",
	"eoffer.mandatory.incot.reference": "Incoterm muss angegeben werden",
	"eoffer.mandatory.priceUnit.reference": "Die Preiseinheit muss angegeben werden",
	"eoffer.mandatory.quantity": "Die Menge muss angegeben werden",
	"eoffer.mandatory.requestedDeliveryTime": "Die angefragte Lieferzeit muss angegeben werden",
	"eoffer.mandatory.rfq.reference": "Die RFQ Referenz muss angegeben werden",
	"eoffer.mandatory.soldTo.reference": "Der Kunde muss eingegeben werden",
	"eoffer.mandatory.tmode.reference": "Das Transportmittal muss angegeben werden",
	"eoffer.merge.warning": "Einige Artikel wurden zusammengeführt. Sie wurden als identische Produkte erkannt.",
	"eoffer.message.offer.not.saved": "Es ist nicht möglich das Angebot zu speichern.",
	"eoffer.message.offer.not.submit": "Angebotserstellung nicht möglich",
	"eoffer.message.offer.saved": "Angebot gespeichert",
	"eoffer.mill": "Werk",
	"eoffer.mill.supplier.choice": "Entscheidung des Lieferanten",
	"eoffer.minimum.quantity": "Mindestmenge 1 ist erforderlich",
	"eoffer.next": "Weiter",
	"eoffer.offer": "Angebot",
	"eoffer.offer.and.order": "Angebotsübersicht",
	"eoffer.offer.card": "Angebotskarte",
	"eoffer.offer.dashboard.not.retrived": "Angebotsangaben im Dashboard können nicht abgerufen werden",
	"eoffer.offer.plural": "Angebote",
	"eoffer.offer.request": "Angebotsanfrage",
	"eoffer.offer.terms": "Wählen Sie Ihre Bedingungen für die Angebotsanfrage aus",
	"eoffer.offerLine": "Angebotslinie",
	"eoffer.offerLine.plural": "Angebotslinien",
	"eoffer.offers.draft": "Angebote - Vorlagen",
	"eoffer.paymentTerms": "Zahlungsbedingung ",
	"eoffer.pc.label.weightDiameterMax": "Max",
	"eoffer.pc.label.weightDiameterMin": "Min",
	"eoffer.pc.label.weightDiameterUnit": "Einheit",
	"eoffer.period": "Periode",
	"eoffer.period.end": "Zeitraum (Ende)",
	"eoffer.period.in.month.value": "{{value}} Monat",
	"eoffer.period.month": "Periode (in Monaten)",
	"eoffer.period.orderBook": "Periode für die vergangenen Aufträgen",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Bitte eine Auswahl treffen",
	"eoffer.period.semester.initial.letter": "Home",
	"eoffer.period.start": "Zeitraum (Anfang)",
	"eoffer.prefered.delivery.mill": "Bevorzugtes Lieferwerk",
	"eoffer.previous": "Vorhergehende",
	"eoffer.price": "Preis",
	"eoffer.pricing.unit": "Preiseinheit",
	"eoffer.product": "Produkt",
	"eoffer.product.card": "Informationen zum Produkt",
	"eoffer.product.family": "Produktfamilie",
	"eoffer.product.family.infos.text": "Bitte wählen Sie einen Kunden, eine Lieferadresse und einen Endnutzer aus, um auf die Produktliste zuzugreifen",
	"eoffer.product.family.plural": "Produktfamilien",
	"eoffer.product.load.content": "Nicht möglich den Inhalt der Produkte zu laden",
	"eoffer.product.not.found": "Produktbeschreibung nicht verfügbar",
	"eoffer.product.plural": "Produkte",
	"eoffer.quantity": "Anzahl",
	"eoffer.quantity.error": "Bitte geben Sie eine gültige Menge ein",
	"eoffer.quantity.ton": "Menge (t)",
	"eoffer.quit.with.save": "Speichern und Verlassen",
	"eoffer.quit.without.save": "Verlassen ohne zu Sichern",
	"eoffer.referenceAm": "Referenz AM",
	"eoffer.refresh": "Aktualisierung",
	"eoffer.remove.product": "Weiter und die ausgewählten Produkte entfernen",
	"eoffer.request.new.offer": "Neues Angebot anfordern",
	"eoffer.request.new.offer.from.draft": "Ein neues Angebot für dies anfragen",
	"eoffer.requested": "Gefordert",
	"eoffer.requested.delivery.time": "Angefragte Lieferzeit",
	"eoffer.reset.requested.delivery.time": "Weiter und die Lieferzeiten zurücksetzen",
	"eoffer.review.selections.and.submit": "Überprüfen Sie Ihre Auswahl und bestätigen Sie.",
	"eoffer.rfq.id": "Ihre eindeutige RFQ Referenz ist",
	"eoffer.rfq.reference": "Ihre RFQ Referenz",
	"eoffer.save": "Speichern",
	"eoffer.save.offer.draft": "Angebotsanfrage als Entwurf speichern",
	"eoffer.save.offer.question": "Sie verlassen den Wizard ohne dans Angebot zu sichern - wollen Sie fortfahren?",
	"eoffer.searchfield.extendable": "Schnellsuche",
	"eoffer.select.period.info": "Bitte klicken Sie hier um eine Periode zwischen einem Monat und einem Jahr auszuwählen.",
	"eoffer.select.price": "Wählen Sie die Preisperiode für dieses Angebot aus",
	"eoffer.selector": "Wähler/ in",
	"eoffer.set.entities": "Einheiten für dieses Angebot einstellen",
	"eoffer.shipto": "Lieferadresse",
	"eoffer.simulation.shipto.enduser.error": "Fehler aufgrund der erzwungenen Weiterleitung an [shipto/enduser] nach der Simulation.",
	"eoffer.soldto": "Lieferadresse",
	"eoffer.status": "Status",
	"eoffer.status.accepted": "Akzeptiert",
	"eoffer.status.accepted.plural": "Akzeptiert",
	"eoffer.status.canceled": "Storniert",
	"eoffer.status.canceled.plural": "Storniert",
	"eoffer.status.draft": "Vorlage",
	"eoffer.status.draft.plural": "Vorlagen",
	"eoffer.status.offered": "Angeboten",
	"eoffer.status.offered.plural": "Angeboten",
	"eoffer.status.rejected": "Hat abgelehnt",
	"eoffer.status.requested": "Gefordert",
	"eoffer.status.requested.plural": "Gefordert",
	"eoffer.steelGrade": "Stahlsorte",
	"eoffer.subcategory": "Unterkategorie",
	"eoffer.submission.feedback": "Sie können den Status Ihrer Anfrage über Ihr Angebotsanfrage-Dashboard verfolgen",
	"eoffer.submit": "Senden",
	"eoffer.supplier.offer.number": "Referenz des Lieferantenangebots",
	"eoffer.table.customer": "Kunde",
	"eoffer.table.enduser": "Endverbraucher",
	"eoffer.table.header.colTopSide": "Farbe Oberseite",
	"eoffer.table.header.custMatRef": "Artikelreferenz des Kunden",
	"eoffer.table.header.custOffRef": "Referenz für Kundenangebot",
	"eoffer.table.header.delivery.mill": "Bevorzugtes Lieferwerk",
	"eoffer.table.header.dim": "Abmessung (mm)",
	"eoffer.table.header.dimension": "Abmessungen (mm)",
	"eoffer.table.header.dimensions": "Abmessungen",
	"eoffer.table.header.feasibility": "Realisierbarkeit",
	"eoffer.table.header.last.update": "Datum der letzten Aktualisierung",
	"eoffer.table.header.orderCount": "Artikel",
	"eoffer.table.header.period": "Periode",
	"eoffer.table.header.price": "Preis",
	"eoffer.table.header.qttOrdered": "Menge",
	"eoffer.table.header.quantity": "Menge (t)",
	"eoffer.table.header.rfqRef": "RFQ Referenz",
	"eoffer.table.header.standsteelGrade": "Standard-Stahlsorte",
	"eoffer.table.header.status": "Status",
	"eoffer.table.header.steelGrade": "Grad",
	"eoffer.table.item.number": "Nummer des Artikels",
	"eoffer.table.morw": "Monat oder Woche",
	"eoffer.table.price.unit": "Preis (Einheit)",
	"eoffer.table.price.value": "Preis (Wert)",
	"eoffer.table.quantity.unit": "Menge (Einheit)",
	"eoffer.table.quantity.value": "Menge (Wert)",
	"eoffer.table.shipto": "Versand an",
	"eoffer.title.my.offers": "Meine Angebote",
	"eoffer.title.productlist.filter": "Wählen Sie das Produkt aus, das Sie anfordern möchten",
	"eoffer.title.section.coilWeightInPercent": "Coilgewicht in %",
	"eoffer.title.section.dimensionUnit": "Einheit Dimension",
	"eoffer.title.section.length": "Länge",
	"eoffer.title.section.organicCoating": "Organische Beschichtung",
	"eoffer.tonnes": "Tonnen",
	"eoffer.total.quantity.for.period.draft": "Gesamtmenge für den Zeitraum",
	"eoffer.track.status": "Sie können den Status Ihrer RFQ verfolgen via Ihrer",
	"eoffer.transport.mode": "Transportmittel",
	"eoffer.validityDate": "Gültigkeit",
	"eoffer.weightAndInvoicing": "Gewicht und Rechnung",
	"eoffer.wizard.cart": "Einkaufswagen",
	"eoffer.wizard.delivery.address": "Lieferadresse",
	"eoffer.wizard.end": "Überprüfen und bestätigen",
	"eoffer.wizard.error.products.families": "Produktfamilien nicht gefunden",
	"eoffer.wizard.header.entity.information": "Unternehmensinformation",
	"eoffer.wizard.header.terms.information": "Informationen zu Bedingungen",
	"eoffer.wizard.parameters.error": "Nicht möglich die Angebotsparameter zu laden",
	"eoffer.wizard.period.error": "Datum wurde zurückgesetzt",
	"eoffer.wizard.period.selection.error": "Bitte wählen Sie ein Datum, das in der Zukunft liegt und für den gewählten Zeitraum gültig ist",
	"eoffer.wizard.request": "Angebot anfragen",
	"eoffer.wizard.specs": "Produktspezifikationen",
	"eoffer.wizard.step.status": "Schritt {{step}} von 4",
	"eoffer.wizard.submit": "Senden Sie Ihre Angebotsanfrage",
	"eoffer.wizard.table.header.quantity": "Menge (t)",
	"eoffer.wizard.terms": "Bedingungen des Angebots",
	"eorder.action.next": "Weiter",
	"eorder.action.save.draft": "Bestellung als Entwurf speichern",
	"eorder.add.item.confirm.action": "Möchten Sie diese Aktion bestätigen?",
	"eorder.add.item.confirm.change": "Möchten Sie diese Änderung bestätigen?",
	"eorder.add.item.different.family.warning": "Der/die ausgewählte(n) Artikel gehört/gehören nicht zur selben Familie wie der/die Artikel im Warenkorb. Wir werden den Warenkorb leeren, bevor wir den/die neuen Artikel hinzufügen.",
	"eorder.add.item.different.form.warning": "Der/die ausgewählte(n) Artikel hat/haben nicht die gleiche Form wie der/die Artikel im Warenkorb. Wir werden den Warenkorb leeren, bevor wir den/die neuen Artikel hinzufügen.",
	"eorder.add.item.empty.customer.warning": "Das Kundenfeld ist leer. Es ist nicht möglich, einen Artikel in den Warenkorb zu legen.",
	"eorder.add.item.limit.exeeds.warning": "Durch das Hinzufügen von [X] Artikel(n) in den Warenkorb wird die Bestellung zu groß für den aktuellen Prozess (>100 Artikel). Bitte reduzieren Sie den Inhalt des Warenkorbs oder die Anzahl der hinzuzufügenden Artikel und versuchen Sie es erneut.",
	"eorder.add.item.success": "[X] Artikel richtig in den Warenkorb gelegt",
	"eorder.confirm.message": "Bestätigen",
	"eorder.create.order.title": "Auftragsinformationen",
	"eorder.customer.change.warning": "Wenn Sie das Feld Kunde ändern, wird der aktuelle Warenkorb gelöscht. In einer Bestellung können keine Artikel von verschiedenen Kunden gemischt werden.",
	"eorder.draft.deleted.successfully": "Ihr Auftragsentwurf wurde ordnungsgemäß gelöscht",
	"eorder.draft.edit.message.text": "Sie können es bearbeiten unter",
	"eorder.draft.last.update.date": "Datum der letzten Aktualisierung",
	"eorder.draft.list.link": "Ihrer Liste der Vorlagen.",
	"eorder.draft.norequest": "Keine Anfrage für einen Entwurf",
	"eorder.draft.order-card.edit": "Bearbeiten Sie diesen Entwurf",
	"eorder.draft.order-card.no-item.text": "Kein Entwurfselement",
	"eorder.draft.order-card.placed.text": "Auftragsdetails des Entwurfs",
	"eorder.draft.order-card.title": "Auftragsdetails des Entwurfs",
	"eorder.draft.product.family": "Familie",
	"eorder.draft.product.number": "Anzahl Produkt(e)",
	"eorder.draft.requested.quantity": "Angeforderte Menge",
	"eorder.draft.saved.successfully": "Ihr Entwurf wurde gespeichert.",
	"eorder.fixed-columns": "Feste Spalten",
	"eorder.grid.header.view.label": "Siehe",
	"eorder.line.select.family.product": "Um einen Artikel in den Warenkorb zu legen, wählen Sie die Anzahl der Exemplare eines Produkts und klicken Sie auf die entsprechende Schaltfläche In den Warenkorb legen",
	"eorder.mandatory.currency": "Die Währung muss angegeben werden",
	"eorder.mandatory.end.user": "Der Endverbraucher muss angegeben werden",
	"eorder.mandatory.idd": "Interpretation des Lieferdatums muss angegeben werden",
	"eorder.mandatory.pricingUnit": "Die Preiseinheit muss angegeben werden",
	"eorder.mandatory.shipTo.reference": "Lieferadresse muss angegeben werden",
	"eorder.message.order.not.saved": "Es ist nicht möglich den Auftrag zu speichern",
	"eorder.no.product.family": "Für den ausgewählten Kunden wurden keine Produkte gefunden",
	"eorder.order": "Auftragsanfrage",
	"eorder.order.creation": "Auftragserstellung",
	"eorder.orders.request": "Bestellanfrage",
	"eorder.product.color.bottom": "Farbe (Unten)",
	"eorder.product.colour.top": "Farbe (Oben)",
	"eorder.product.custmaterialnum": "Material-Kundennummer",
	"eorder.product.data.commercial.steelgrade.id": "kommerzielleStahlsorteID",
	"eorder.product.data.customer.article": "Kundenartikel",
	"eorder.product.dimension": "Abmessungen",
	"eorder.product.empty.row": "Kein aktives Produkt mit dieser Vorlage verknüpft",
	"eorder.product.family.infos.title": "Bitte wählen Sie den Kunden für diese Bestellanfrage aus, damit Sie die Liste der zugehörigen Produkte sehen können. Alle Artikel im Warenkorb sollten sich auf denselben Kunden beziehen.",
	"eorder.product.fc.products.label": "Vollständig konfigurierte Produkte",
	"eorder.product.grid.note.fc": "[Y] Produkt(e).",
	"eorder.product.grid.note.nfc": "Vorlage(n) und [Y] Produkt(e). Eine Vorlage ist ein Artikel mit leeren Variablen, mit dem Sie ein neues Produkt erstellen können",
	"eorder.product.lastused": "Letzter Gebrauch",
	"eorder.product.lastused.default": "Nie",
	"eorder.product.metalliccoating": "Metallisch beschichtet",
	"eorder.product.organiccoating.datasheet.top": "Datenblatt für organische Beschichtungen (Oben)",
	"eorder.product.organicdatasheet.bottom": "Datenblatt für organische Beschichtungen (Unten)",
	"eorder.product.removablefilm": "Abnehmbare Schutzfolie",
	"eorder.product.steelgrade": "Stahlsorte",
	"eorder.product.surfaceaspect": "Oberflächenaspekt",
	"eorder.product.template.add.to.cart": "Als leeres Produkt in den Warenkorb legen",
	"eorder.product.type.fc": "Katalog Produkt",
	"eorder.product.type.fm": "Zu konfigurieren (mit Standardwerten)",
	"eorder.product.type.nfc": "Zu konfigurieren",
	"eorder.product.variables": "variablen(n)",
	"eorder.product.variables.title": "Variablen auf dieser Vorlage:",
	"eorder.save.draft.confirmation": "Möchten Sie [X] als Entwurf speichern?",
	"eorder.save.draft.error.message": "Es ist ein Fehler beim Speichern Ihres Bestellentwurfs aufgetreten. Bitte versuchen Sie es später erneut oder senden Sie eine Nachricht an Ihren AM-Ansprechpartner.",
	"eorder.save.draft.success.message": "Ein Entwurf für Ihre Bestellung wurde ordnungsgemäß gespeichert.",
	"eorder.select.product.spec": "List der Produkte",
	"eorder.submit.error.msg.bad.data": "Fehlerhafte Daten in der Anfrage.",
	"eorder.submit.error.msg.rqd.data.missing": "Es fehlen Pflichtangaben.",
	"eorder.submit.order.success.follow.up.link": "VERFOLGUNG DER BESTELLUNG UND LIEFERUNG.",
	"eorder.submit.order.success.follow.up.text": "Sie können den Status verfolgen, und zwar in Ihrem",
	"eorder.submit.order.success.text1": "Ihre Bestellanfrage",
	"eorder.submit.order.success.text2": "wurde bearbeitet.",
	"eorder.wizard.header.customer": "Der Kunde ist erforderlich",
	"eorder.wizard.header.customer-order-number": "Kundenbestellnummer",
	"eorder.wizard.header.customer-order-number.error.invalid": "Ungültige Kundenbestellnummer",
	"eorder.wizard.header.customer-order-number.error.mandatory": "Die Kundenbestellnummer ist erforderlich",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Ungültige Vertragsnummer",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "Kaufvertrag ist obligatorisch",
	"eorder.wizard.order.currency": "Währung",
	"eorder.wizard.order.enduser": "Endverbraucher",
	"eorder.wizard.order.idd": "Interpretation Liefertermin",
	"eorder.wizard.order.pricingUnit": "Preiseinheit",
	"eorder.wizard.order.purchase.contract": "Kaufvertrag der Bestellung",
	"eorder.wizard.order.shipto.name": "Lieferadresse",
	"eorder.wizard.order.soldto.name": "Kunde",
	"eorder.wizard.parameters.error": "eOrder-Parameter können nicht geladen werden",
	"eorder.wizard.product.action.delete": "Löschen",
	"eorder.wizard.product.action.duplicate": "Duplikat",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Positionsnummer",
	"eorder.wizard.product.modification.no.products": "Kein Produkt.",
	"eorder.wizard.product.modification.order.title": "Bestellung",
	"eorder.wizard.product.modification.title.cart": "Ihr Warenkorb",
	"eorder.wizard.product.modification.title.item": "Artikel",
	"eorder.wizard.product.modification.title.items": "Gegenstand(e)",
	"eorder.wizard.product.quantity": "Menge (t)",
	"eorder.wizard.product.rdd": "RDD",
	"eorder.wizard.product.rdd.error": "Datum in der Vergangenheit",
	"eorder.wizard.product.rdd.type": "RDD-Typ",
	"eorder.wizard.product.service.level": "Service Level",
	"eorder.wizard.product.steelgrade": "Stahlsorte",
	"eorder.wizard.product.thickness": "Dicke",
	"eorder.wizard.product.width": "Breite",
	"eorder.wizard.quantity.error": "Bitte geben Sie eine gültige Menge ein, die größer oder gleich 1 ist.",
	"eorder.wizard.stepper.step.order.information": "Bestellinformationen und Produktauswahl",
	"eorder.wizard.stepper.step.product.modification": "Produkt-modifikation",
	"eorder.wizard.stepper.step.summary": "Zusammenfassung der Bestellung",
	"eorder.wizard.summary.header.contract.po": "Vertrag (PO)",
	"eorder.wizard.summary.header.currency.po": "Rechnungswährung",
	"eorder.wizard.summary.header.order.title": "Auftragsinformationen",
	"eorder.wizard.summary.order.placed.text": "Bestellung aufgegeben - ",
	"eorder.wizard.summary.terms.conditions.text": "Wenn Sie auf „Bestellung fortsetzen“ klicken, akzeptieren Sie die Allgemeinen Geschäftsbedingungen für die Online-Bestellung.",
	"eorder.wizard.summary.total.quantity": "Gesamtmenge (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Bitte installieren Sie ein Programm das PDF-Dokumente präsentieren kann auf Ihrem Telefon.",
	"error.deleting.draft": "Fehler beim Löschen des Entwurfs",
	"error.file.download": "Ein Fehler ist während des Herunterladens aufgetreten",
	"error.file.not.found": "Diese Datei existiert nicht.",
	"error.inavlid.transport.cost": "Ungültige Transportkosten",
	"error.place.atleast.one.bid": "Geben Sie vor dem Speichern mindestens ein Gebot ab.",
	"exception-report.amlno": "AML-Nr.",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "Ihre Anfrage nach einem Ausnahmebericht wurde gelöscht.",
	"exception-report.dialog.add-comment.title": "Schreiben Sie einen Kommentar, um Ihren Ausnahmebericht folgenden Bestellung abzuschließen:",
	"exception-report.dialog.current-status.title": "Der aktuelle Status Ihrer Anfrage zur Bestellung",
	"exception-report.dialog.processing": "Verarbeitung",
	"exception-report.docNo": "Dokument Nr.",
	"exception-report.edit-request": "Kommentar bearbeiten",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Besondere Anfrage",
	"exception-report.save": "Ihre Anfrage nach einem Ausnahmebericht wurde versendet. Sie können Ihre wöchentliche Anfrage in der BESTELLLISTE verfolgen.",
	"exception-report.status": "Kommentar Status",
	"exception-report.yearweek": "Jahr Woche",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Anhänge",
	"fastlane.create.details.field.currency": "Wählen Sie Ihre Währung",
	"fastlane.delivery.address": "Lieferadresse ist obligatorisch!",
	"fastlane.delivery.infos.title": "Bitte wählen Sie die Lieferadresse für Ihre Artikel in der vordefinierten Liste aus oder passen Sie eine an. Im Falle eines benutzerdefinierten Ziels müssen Sie einige Details angeben.",
	"fastlane.error.nosoldto": "Kunde nicht gefunden",
	"fastlane.file.import.button": "Importieren",
	"fastlane.file.import.note": "Alle Artikel mit Hilfe einer Datei vorausfüllen",
	"fastlane.file.import.progressMessage": "Import in progress.",
	"fastlane.file.import.result.label": "Ergebnis",
	"fastlane.file.import.result.text": "Bitte laden Sie eine Datei hoch",
	"fastlane.file.import.validate": "Validieren",
	"fastlane.file.template.download.note": "Verwenden Sie das richtige Format für die Datei, indem Sie die Vorlage herunterladen, indem Sie hier klicken",
	"fastlane.header.customer-request-name.error.mandatory": "Anfragename ist obligatorisch!",
	"fastlane.header.wizard.customer-request-name": "Anfragename",
	"fastlane.import.popup.text.1": "Laden Sie eine XLS-Datei hoch, um in einem Durchgang alle Ihre Artikel auszufüllen. Bitte folgen Sie der Vorlage, um eine automatische Erkennung zu ermöglichen.",
	"fastlane.import.popup.text.2": "Wenn einige Felder zu lang für Textfelder sind, werden sie abgeschnitten (z.B.: Name für einen Artikel: Limit = 80 Zeichen)",
	"fastlane.import.popup.text.3": "Wenn einige Felder eine Liste von Werten erfordern und die Datei einen nicht vorhandenen Wert enthält, wird dieser ignoriert.",
	"fastlane.import.popup.text.4": "Bei einem bestimmten Artikel müssen alle Pflichtfelder ausgefüllt werden.",
	"fastlane.import.popup.text.5": "Die Liste aller Fehler wird am Ende des Prozesses angezeigt, so dass Sie sie überprüfen oder erneut versuchen können.",
	"fastlane.import.popup.title": "Alle Artikel vorausfüllen",
	"fastlane.info.commercial.data": "Kommerzielle Daten",
	"fastlane.info.request.details": "Anfragedetails",
	"fastlane.itemlist.coil.inner.diameter": "Innendurchmesser",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "K.A.",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertikal",
	"fastlane.itemlist.coil.max_outer_diameter": "Maximaler Außendurchmesser",
	"fastlane.itemlist.global.quantity": "Menge",
	"fastlane.itemlist.global.quantity.error": "Die Menge ist obligatorisch!",
	"fastlane.itemlist.global.select_unit.error": "Bitte wählen Sie eine Einheit",
	"fastlane.itemlist.global.unit": "Einheit",
	"fastlane.itemlist.global.unit.error": "Die Einheit muss angegeben werden!",
	"fastlane.itemlist.item.additional.info": "Zusätzliche Informationen zum Artikel",
	"fastlane.itemlist.navig.duplicate": "Duplikat",
	"fastlane.itemlist.navig.reset": "Zurücksetzen",
	"fastlane.itemlist.order.thickness": "Dicke",
	"fastlane.itemlist.product.blankWeight.error.invalid": "BlankWeight muss größer als 0 sein.",
	"fastlane.itemlist.product.blank_weight": "Einheitsgewicht",
	"fastlane.itemlist.product.blank_weight.error": "Einheitsgewicht ist obligatorisch!",
	"fastlane.itemlist.product.coating.error.invalid": "Die Beschichtung muss größer als 0 sein.",
	"fastlane.itemlist.product.coating.mandatory": "Beschichtung ist obligatorisch!",
	"fastlane.itemlist.product.coil_axis": "Achse der Spule",
	"fastlane.itemlist.product.coil_axis.default": "-- Keine --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertikal",
	"fastlane.itemlist.product.form_blank": "Blank Form",
	"fastlane.itemlist.product.item_form": "Bilden",
	"fastlane.itemlist.product.item_form.error": "Die Form muss angegeben werden!",
	"fastlane.itemlist.product.item_name": "Name",
	"fastlane.itemlist.product.item_name.error": "Der Name für den Artikel ist obligatorisch!",
	"fastlane.itemlist.product.item_number": "Positionsnummer",
	"fastlane.itemlist.product.length.error": "Die Länge ist obligatorisch!",
	"fastlane.itemlist.product.length.error.invalid": "Die Länge muss größer als 0 sein.",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "MaxOuterDiameter muss größer als 0 sein.",
	"fastlane.itemlist.product.quantity.error.invalid": "Die Menge muss größer als 0 sein",
	"fastlane.itemlist.product.select_form.error": "Bitte wählen Sie eine Form",
	"fastlane.itemlist.product.slitting_coil": "Bandstahl",
	"fastlane.itemlist.product.steel_grade": "Stahlsorte",
	"fastlane.itemlist.product.steel_grade.error": "Die Stahlsorte ist obligatorisch!",
	"fastlane.itemlist.product.thickness.error": "Die Dicke ist obligatorisch!",
	"fastlane.itemlist.product.thickness.error.invalid": "Die Dicke muss zwischen 0.1 und 999 liegen.",
	"fastlane.itemlist.product.width.error": "Die Breite ist obligatorisch!",
	"fastlane.itemlist.product.width.error.invalid": "Die Breite muss größer als 0 sein.",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Ölung",
	"fastlane.itemlist.quality.calculator.coil": "Coil",
	"fastlane.itemlist.quality.calculator.sheet": "Blech",
	"fastlane.itemlist.unit.blanks": "Platzpatronen",
	"fastlane.itemlist.unit.sheets": "Bleche",
	"fastlane.itemlist.unit.tons": "Tonnen",
	"fastlane.mandatory.delivery.address": "Die Lieferadresse ist eine Pflichtangabe",
	"fastlane.prototype.dialog.week": "woche",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Fast Lane Anfrage",
	"fastlane.request.title": "Anfrage information",
	"fastlane.soldto.shipto.error": "Entschuldigung, es gibt ein Problem in Ihren Diensteinstellungen, bitte wenden Sie sich an den SteelUser-Administrator",
	"fastlane.submit.error.msg": "Es ist ein Problem aufgetreten. Bitte wenden Sie sich an Ihren SteelUser-Administrator.",
	"fastlane.submit.error.msg.mandatoryfield": "Obligatorische Felder fehlen.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Es gibt ein Problem mit Ihren Settings für diesen Dienst",
	"fastlane.submit.error.msg.notoken": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich in der Anwendung neu an.",
	"fastlane.submit.request.error.msg.title": "Fehler während der Validierung Ihres Antrags",
	"fastlane.template.addinfo.validation": "Additional Information cannot exceed 255 chars ([X] detected)",
	"fastlane.template.blankweight.validation": "Blank Weight is mandatory for Form Blank and must be a valid number greater or equal to 1 with 2 digits (truncated if more). ([X] detected)",
	"fastlane.template.coating.validation": "Coating is mandatory and cannot exceed 50 chars ([X] detected)",
	"fastlane.template.coilaxis.validation": "Coil Axis is mandatory and must be one of the followed values: -- None --, Horizontal, Vertical (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.currency.validation": "Currency is mandatory and must be one of the followed values: EUR, GPB, USD (“[X]” detected). EUR will be set by default",
	"fastlane.template.deliveryaddress.validation": "Delivery address is not mandatory, but if filled in, cannot exceed 150 chars ([X] detected)",
	"fastlane.template.description.validation": "Description is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.detected.items": "[X] items detected in the file",
	"fastlane.template.form.validation": "Form is mandatory and must be one of the followed values: Coil, Sheet, Slitting Coil, Form Blank (“[X]” detected). Coil will be set by default",
	"fastlane.template.format.error": "The file should be a template provided by ArcelorMittal. We are not able to analyse it, it may be a wrong file or a corrupted one. If you have doubt on it, communicate with your AM contact by sending them the file.",
	"fastlane.template.global.data.issue": "Global data with issues",
	"fastlane.template.global.error": "Global error(s) preventing any analysis of the document",
	"fastlane.template.incoterms.validation": "Incoterms is mandatory and must be one of the followed values: -- None --, DAP, CIF, CIP, FCA, DDP (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.innerdiameter.validation": "Inner Diameter is mandatory and must be one of the followed values: N/A, 508 mm, 610 mm (“[X]” detected). “N/A” will be set by default",
	"fastlane.template.item.issue.header": "[X] items with issues",
	"fastlane.template.itemname.validation": "Item Name is mandatory and cannot exceed 80 chars ([X] detected)",
	"fastlane.template.length.validation": "Length is mandatory for Sheet and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.line": "Line",
	"fastlane.template.mill.validation": "Mill is mandatory and must be one of the valid values. (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.oiling.validation": "Oiling cannot exceed 50 chars ([X] detected)",
	"fastlane.template.outerdiameter.validation": "Max Outer Diameter must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.packing.validation": "Packing cannot exceed 50 chars ([X] detected)",
	"fastlane.template.quantity.validation": "Quantity is mandatory and must be a valid positive number with max 2 or 0 digits based on unit selected (truncated if more). ([X] detected)",
	"fastlane.template.rddday.validation": "A Delivery Date has been provided in Day, but not in proper pattern (dd/mm/yyyy, ex: 02/02/2024). (“[X]” detected)",
	"fastlane.template.rddweek.validation": "A Delivery Date has been provided in Week, but not in proper pattern (Www/YYYY, ex: W01/2024). (“[X]” detected)",
	"fastlane.template.rddwnd.validation": "The day provided for Delivery Date should correspond to the week. (“[Y]” is not part of “[X]” Week)",
	"fastlane.template.request": "Request",
	"fastlane.template.requestname.validation": "Request name is mandatory and cannot exceed 120 chars ([X] detected)",
	"fastlane.template.steelgrade.validation": "Steelgrade is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.thickness.validation": "Thickness is mandatory and must be a valid positive number with max 2 digits (truncated if more). Should be less than or equal to 999. ([X] detected)",
	"fastlane.template.tmode.validation": "Transport Mode is mandatory and must be one of the followed values: -- None --, Train, Boat, Truck, Plane (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.unitbasic.validation": "Unit is mandatory and must be one of the followed values: Tons, Sheets, m², Blanks. (“[X]” detected). Default value will be set linked to Form.",
	"fastlane.template.unitform.validation": "“[X]” Quantity value is not valid for “[Y]” Form.",
	"fastlane.template.upload.confirmation.text1": "Datei korrekt in Sitzung importiert.",
	"fastlane.template.upload.confirmation.text2": "Bitte überprüfen Sie noch einmal alle Elemente in der Sitzung, bevor Sie die Anfrage bestätigen.",
	"fastlane.template.upload.warning.text": "Sie können dieses Teilergebnis validieren oder versuchen, die Datei erneut hochzuladen, indem Sie Probleme beheben",
	"fastlane.template.valid.items": "[X] items without any issue",
	"fastlane.template.width.validation": "Width is mandatory and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.xls.mime.type": "The file must be an Excel file. Please use the proper template provided by SteelUser application.",
	"fastlane.wizard.contact.person.mandatory": "Kontaktperson ist obligatorisch!",
	"fastlane.wizard.contact.phone.number": "Telefonnummer dieser Kontaktperson",
	"fastlane.wizard.currency": "Währung",
	"fastlane.wizard.custom.destination": "Kundenspezifische Lieferadresse",
	"fastlane.wizard.custom.destination.contact.person": "Kontaktperson an dieser Lieferanschrift",
	"fastlane.wizard.decide.later": "-- Später entscheiden --",
	"fastlane.wizard.delivery.address": "Vordefinierte Lieferadresse",
	"fastlane.wizard.header.customer": "Der Kunde ist erforderlich",
	"fastlane.wizard.header.customer-request-name": "Anfragename",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "Kein Artikel in dieser Anfrage",
	"fastlane.wizard.header.request.data": "Daten der Anfrage",
	"fastlane.wizard.items.details.addanitem": "Artikel hinzufügen",
	"fastlane.wizard.items.details.datetype": "Datumstyp",
	"fastlane.wizard.items.details.datetype.errormsg": "Der Datentyp muss angegeben werden!",
	"fastlane.wizard.items.details.datetype.rdd": "Angefragtes Lieferdatum",
	"fastlane.wizard.items.details.day": "Tag",
	"fastlane.wizard.items.details.itemrequest": "Artikelanfragen",
	"fastlane.wizard.items.details.sheet.weight": "Gewicht eines Blattes (in kg)",
	"fastlane.wizard.items.details.total.weight": "Gesamtgewicht (in Tonnen)",
	"fastlane.wizard.items.details.week": "Woche",
	"fastlane.wizard.parameters.error": "Fastlane-Parameter können nicht geladen werden",
	"fastlane.wizard.phone.number.mandatory": "Telefonnummer ist obligatorisch!",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "ArcelorMittal-Werk gewünscht",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "Das Werk ist obligatorisch!",
	"fastlane.wizard.product.transport.mode.errormsg": "Das Transportmittel muss angegeben werden!",
	"fastlane.wizard.shipto.name": "Lieferadresse",
	"fastlane.wizard.soldto.name": "Kunde",
	"fastlane.wizard.stepper.step.items.details": "Hauptinformationen",
	"fastlane.wizard.stepper.step.main.data": "Hauptinformationen",
	"fastlane.wizard.stepper.step.transport.details": "Details zum Transport",
	"fastlane.wizard.stepper.step.transport.summary": "Übersicht",
	"fastlane.wizard.summary.header.currency.po": "Rechnungswährung",
	"fastlane.wizard.summary.submitBtn": "Ihre Fast Lane Anfrage einreichen",
	"fastlane.xlx.template": "XLS-Vorlage",
	"favorite-orders.title": "Meine vorgemerkten Aufträge",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Abbrechen",
	"filter.add": "Hinzufügen",
	"filter.add.dimension": "Abmessungen (in mm)",
	"filter.all": "Alle",
	"filter.apply": "Ausführen",
	"filter.atConsignment": "Konsignation",
	"filter.batchid": "Materialnummer",
	"filter.bottom-color": "Farbe Unterseite",
	"filter.cancel": "Abbrechen",
	"filter.cdd": "Bestätigtes Lieferdatum",
	"filter.cddGtRdd": "Best.Lief.Dat. > Angefr.Lief.Dat.",
	"filter.coating": "Beschichtungsspezifikation",
	"filter.confirmation.deleteall": "Wollen Sie wirklich alle Filter löschen?",
	"filter.contractNumber": "Vertragsnummer",
	"filter.criteria.applied": "Filter",
	"filter.criteria.no.applied": "Kein Filter",
	"filter.customerArticleReference": "Artikelreferenz des kunden",
	"filter.customerOrderNumber": "Kundenbestellnummer",
	"filter.date": "Datum…",
	"filter.date.from": "Von",
	"filter.date.invalid": "Das Datum muss gültig sein",
	"filter.date.to": "Zum",
	"filter.deleteall": "Alle löschen",
	"filter.delivered": "Geliefert",
	"filter.deliveryMode": "Lieferweise",
	"filter.dimension": "Abmessungen",
	"filter.dimensions.length": "Länge",
	"filter.dimensions.thickness": "Dicke",
	"filter.dimensions.width": "Breite",
	"filter.dispatchAdviceNumber": "Lieferscheinnummer",
	"filter.dispatchDate": "Versanddatum",
	"filter.enddate.inferior": "Dieses Datum muss grösser sein als das vorhergehende Datum",
	"filter.field.invalid": "Ungültiger Wert",
	"filter.field.required": "Pflichtfeld",
	"filter.filters": "Filter",
	"filter.format.day": "Tag",
	"filter.format.week": "Woche",
	"filter.grossOrdersWithMaterial": "Bruttoaufträge mit Material",
	"filter.inTransit": "Transit",
	"filter.is-not-a-number": "Der Wert muss eine Zahl sein",
	"filter.is-not-a-positive-number": "Der Wert muss eine positive Zahl sein",
	"filter.length": "Länge (m)",
	"filter.less-than": "Gleich oder kleiner als",
	"filter.mill": "Werk",
	"filter.more-than": "Gleich oder größer als",
	"filter.multiple-values": "Mehrere Werte…",
	"filter.netOrdersWithMaterial": "Nettoaufträge mit Material",
	"filter.no-matching-value": "Keine passenden Werte",
	"filter.no-value": "Kein Wert",
	"filter.no.predefined": "Keine vordefinierten Filter",
	"filter.number.from": "Von",
	"filter.number.to": "Zum",
	"filter.ok": "Ok",
	"filter.operator.exact": "Exakt",
	"filter.operator.range": "Auswahl",
	"filter.order-number.item": "Artikel",
	"filter.order-number.reference": "Referenz",
	"filter.order.item.number": "Positionsnummer",
	"filter.order.reference": "Auftragsnummer",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Aufträge mit Material",
	"filter.placeholder.list": "Wählen Sie aus der Liste aus:",
	"filter.placeholder.suggestive.list": "Wert suchen",
	"filter.predefined": "Vordefiniert",
	"filter.readyToShip": "Versandbereit",
	"filter.reset": "Zurücksetzen",
	"filter.schedule-business-order": "Schedule business order",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "Produktion",
	"filter.shipment-section-n2": "Produktion",
	"filter.spot-order": "Spot order",
	"filter.standardsteelgrade": "Stahlsorte",
	"filter.supplierOrderNumber": "Lieferantenauftragsnummer",
	"filter.text": "Benutzen Sie \";\" als Trennzeichen. Benutzen Sie \"*\" oder \"%\" als Platzhalter.",
	"filter.thickness": "Dicke (mm)",
	"filter.top-color": "Farbe Oberseite",
	"filter.week.to": "Bis",
	"filter.width": "Breite (mm)",
	"filter.workInProgress": "Produktion",
	"filter.x-filter-applied": "Filter",
	"filter.x-filters-applied": "Filter",
	"filter.x-selected-values": "ausgewählt ",
	"filter.yes": "Ja",
	"footer.alerts": "Alarme",
	"footer.home": "Home",
	"footer.message": "Nachricht",
	"footer.search": "Suche",
	"form.blanks": "Blanks",
	"form.coil": "Coil",
	"form.heavy.plate": "Heavy Plate",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "Sheet",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "Thick Plate",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Vollständiger Produktkatalog",
	"global-subcategory.BL": "Warmgewalzt ungebeizt",
	"global-subcategory.CR": "Cold rolled",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Aktion abgebrochen",
	"global.business-type": "Business Type",
	"global.cancelled": "Storniert",
	"global.clickhere": "Hier klicken",
	"global.closed": "Geschlossene",
	"global.copyto": "Kopie an",
	"global.error": "Bei dem Versuch, Ihre Produktliste zu erhalten, ist ein Fehler aufgetreten.",
	"global.error.unexpected": "Unerwarteter Fehler",
	"global.internal.server.error": "Interner Serverfehler",
	"global.internal.soldto.error": "Einstellungsfehler in Ihrem Konto, Sie können diese Bestellanfrage nicht durchführen (Kunde). Bitte setzen Sie sich mit Ihrem AM-Kontakt in Verbindung.",
	"global.message": "Nachright",
	"global.message-error": "Eine Nachricht ist obligatorisch!",
	"global.next": "Weiter",
	"global.no": "Nein",
	"global.none": "Keine",
	"global.open": "Offen",
	"global.or": "ODER",
	"global.search-filter": "Global Search",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Senden",
	"global.servicelevel": "Dienstleistung",
	"global.subject": "Betreff",
	"global.subject-error-msg": "Ein Betreff ist obligatorisch!",
	"global.submit.error.unexpected": "Während des Absendevorgangs ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später oder wenden Sie sich an Ihren AM-Kontakt.",
	"global.submit.service.error": "Ihr Konto hat nicht die richtigen Berechtigungen, um eine Bestellanfrage zu übermitteln. Bitte wenden Sie sich an Ihren AM-Kontakt.",
	"global.unexpected.error.identified": "unexpected error identified",
	"global.warning": "Warnung",
	"global.yes": "Ja",
	"guaranatee.aluminium.parts": "Aluminium für Teile",
	"guarantee.Others": "Andere",
	"guarantee.Poultry": "Geflügel",
	"guarantee.acoustic": "Lärmschutzwände",
	"guarantee.acoustic.concrete": "Gibt es einen Betonsockel, durch den die mit Magnelis® beschichteten Elemente vom Boden getrennt sind?",
	"guarantee.acoustic.railroad": "Lärmschutzwände für eine Eisenbahnstrecke",
	"guarantee.acoustic.road.traffic": "Schallschutzvorrichtungen für den Straßenverkehr / Schallschutzwände für Straßen",
	"guarantee.activity.building": "Aktivität innerhalb des Gebäudes",
	"guarantee.activity.specify": "Bitte spezifizieren Sie die Aktivität",
	"guarantee.add.parts": "Teile hinzufügen",
	"guarantee.additional.comments": "Zusätzliche Informationen oder Anmerkungen",
	"guarantee.additional.documents": "Zusätzliche Dokumente",
	"guarantee.address": "Stadt / Land",
	"guarantee.age.material": "Alter des zu ersetzenden Materials",
	"guarantee.agricultural": "Lanswitschaftlich",
	"guarantee.agricultural.questions": "Fragen in Bezug auf landwirtschaftliche Gebäude",
	"guarantee.agricultural.specify": "Bitte angeben",
	"guarantee.air.renewal": "Lufterneuerungsrate angeben (in m³ pro Stunde und Tier)",
	"guarantee.allocation.building": "Zuordnung und Bestimmung des Gebäudes",
	"guarantee.altitude.above.900m": "Mehr als 900 m über NN",
	"guarantee.altitude.below.900m": "Unterhalb von 900 m über NN",
	"guarantee.aluminium": "Aluminium",
	"guarantee.ambiance": "Bedingungen im Inneren des Gebäudes",
	"guarantee.ammonia": "Ammoniakkonzentration im Inneren angeben (in ppm)",
	"guarantee.animals.density": "Anzahl der Tiere pro m²",
	"guarantee.animals.inside.building": "Welche Tiere werden in dem Gebäude gehalten?",
	"guarantee.animals.shed": "Geben Sie die Zahl der Tiere im Stall an.",
	"guarantee.area": "Name des Gebiets",
	"guarantee.atmospheric.corrosion": "Atmosphärische Korrosion",
	"guarantee.attachment": "Angehängtes Dokument",
	"guarantee.attachment.categorize.title": "Kennzeichnen Sie jedes Dokument mit der zugehörigen Analyse:",
	"guarantee.attachment.category.label": "Dokumententyp",
	"guarantee.attachment.category.other": "Sonstige",
	"guarantee.attachment.category.soil": "Bodenanalyse",
	"guarantee.attachment.category.water": "Wasseranalyse",
	"guarantee.attachment.column.actions": "Aktionen",
	"guarantee.attachment.column.file": "Dateiname",
	"guarantee.attachment.column.size": "Größe",
	"guarantee.attachment.description": "Laden Sie Ihre Dokumente hoch und kennzeichnen Sie sie. Jede Datei muss mit der zugehörigen Analyse gekennzeichnet werden.",
	"guarantee.attachment.limit": "Die maximale Dateigröße beträgt 115 MB.",
	"guarantee.attachment.missing.soil": "Fehlt: Dokument für Bodenanalyse",
	"guarantee.attachment.missing.title": "Erforderliches Dokument fehlt",
	"guarantee.attachment.missing.water": "Fehlt: Dokument für Wasseranalyse",
	"guarantee.attachment.size": "Die Größe des Anhangs sollte 115 MB nicht überschreiten",
	"guarantee.attachment.title": "Anhänge",
	"guarantee.attachment.uploaded.title": "Hochgeladene Dokumente",
	"guarantee.between.2kmand10km": "Zwischen 2 km und 10 km von der Küste entfernt gelegen",
	"guarantee.between.300mand2km": "Zwischen 300 m und 2 km von der Küste entfernt gelegen",
	"guarantee.breeding.animals": "Tierzucht",
	"guarantee.building.altitude": "Höhe",
	"guarantee.building.heated": "Ist das Gebäude beheizt?",
	"guarantee.cancelled": "Abbrechen",
	"guarantee.card.client.project.name": "Name des Kundenprojekts",
	"guarantee.card.details": "Details zur Garantieanforderung",
	"guarantee.card.info": "Informationen zur Garantie",
	"guarantee.card.title": "Garantiekarte - Garantieanforderung",
	"guarantee.cattle": "Rinder",
	"guarantee.certificate.issued": "Zertifikat ausgestellt",
	"guarantee.certificate.request": "Zertifikat anfordern",
	"guarantee.certificate.request.confirmation": "Möchten Sie das Zertifikat für diese Garantieanforderung anfordern",
	"guarantee.certificate.request.failed": "Entschuldigung, während des Vorgangs ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"guarantee.certificate.request.success": "Die Zertifikatsanforderung wurde erfolgreich übermittelt.",
	"guarantee.certificate.request.unavailable": "Diese Garantie ist für eine Zertifikatsanforderung nicht mehr verfügbar.",
	"guarantee.certificate.requested": "Zertifikat angefordert",
	"guarantee.characteristics": "Projekteigenschaften",
	"guarantee.chimney": "Schornstein",
	"guarantee.choose.applicationtype": "Wählen Sie die Art der Garantie, die Sie anfordern möchten.",
	"guarantee.cladding": "Verkleidung",
	"guarantee.cladding.double.skin": "Doppelschale",
	"guarantee.cladding.single.skin": "Ein-Schalen-Dach",
	"guarantee.cladding.specify.material.type": "In der Verkleidung (Art des Materials und bedeckte Fläche angeben)",
	"guarantee.client.project.name": "Name des Projekts",
	"guarantee.coastal.marine": "In einer Küsten- oder Meeresumgebung",
	"guarantee.cold.structure": "Kaltgeformte Bauteile von Gebäuden (Pfetten, Schienen, ...)",
	"guarantee.composite.floor": "Verbunddecke (composite floor)",
	"guarantee.concrete.foundations": "Beton für Fundamente",
	"guarantee.condensation.rink": "Besteht die Gefahr von Kondenswasserbildung im Inneren des Gebäudes?",
	"guarantee.condition.material": "Zustand des zu ersetzenden Materials",
	"guarantee.construction.new.building": "Errichtung eines vollständig neuen Gebäudes",
	"guarantee.construction.site": "Baustelle",
	"guarantee.construction.site.mandatory": "Der GPS-Standort (Breiten- und Längengrad) ist obligatorisch",
	"guarantee.contact": "(z. B. durchgehend feuerverzinkter Stahl, stückverzinkter Stahl, Holz usw.)",
	"guarantee.contact.orther.parts": "Welche anderen Materialien werden in Kontakt mit den mit Magnelis® beschichteten Teilen verwendet? Bitte spezifizieren, falls zutreffend!",
	"guarantee.contact.parts": "Welche Beschichtungen werden für Teile verwendet, die mit Teilen mit Magnelis®-Beschichtung in Kontakt kommen? Bitte spezifizieren, falls zutreffend!",
	"guarantee.coordinates.decimal": "Koordinaten in Dezimalgrad",
	"guarantee.coordinates.dms": "Koordinaten in Grad, Minuten und Sekunden",
	"guarantee.coordinates.pair.mandatory": "Bitte geben Sie sowohl Breiten- als auch Längengrad ein",
	"guarantee.corporate.name.mandatory": "Das Feld Kunde ist obligatorisch",
	"guarantee.current.status": "Aktueller Status",
	"guarantee.customer.information": "Kundeninformationen",
	"guarantee.customer.name": "Kunde",
	"guarantee.customer.rejected": "Vom Kunden abgelehnt",
	"guarantee.desert": "In der Wüste",
	"guarantee.designation": "Bezeichnung",
	"guarantee.direction.of.cladding.installation": "Verlegungsrichtung der Verkleidung",
	"guarantee.distance.3KM.seafront": "Wenn die Entfernung zur Küste weniger als 3 km beträgt, dann geben Sie bitte die Entfernung an.",
	"guarantee.distance.lake": "Entfernung zu einem See oder Fluss (km)",
	"guarantee.distance.less than 300m": "In weniger als 300 m Entfernung von der Küste gelegen",
	"guarantee.distance.seafront": "Wenn die Entfernung zur Küste weniger als 10 km beträgt, dann geben Sie bitte die Entfernung an",
	"guarantee.distance.seafrontkm": "Entfernung zur Küste (km)",
	"guarantee.distance.site": "Entfernung vom Standort (km)",
	"guarantee.documents": "Garantiedokumente",
	"guarantee.documents.title": "Dokumente",
	"guarantee.double.skin.roof": "Doppelschalendach",
	"guarantee.draft": "Entwurf",
	"guarantee.draft.edit": "Sie können die Änderungen in Ihrem Entwurf nachträglich vornehmen.",
	"guarantee.draft.saved.successfully": "Ihr Entwurf wurde gespeichert",
	"guarantee.duckboard": "Durch Betongitter/Lattenrost",
	"guarantee.duration.year": "{{value}} Jahr",
	"guarantee.duration.years": "{{value}} Jahre",
	"guarantee.duration.years.indoor": "Erwartete Garantiedauer innen (in Jahren)",
	"guarantee.duration.years.outdoor": "Erwartete Garantiedauer außen (in Jahren)",
	"guarantee.emission.type": "Art der Emissionen",
	"guarantee.epassivation.type": "Art der E-Passivation",
	"guarantee.epc": "Planung, Beschaffung und Bau (Engineering, Procurement & Constructions, EPC)",
	"guarantee.epc.company.name": "Unternehmensname",
	"guarantee.equipment": "Welche Einrichtungen stehen für die Ableitung von Rauch, Qualm, Dampf und Feuchtigkeit zur Verfügung?",
	"guarantee.extension.existing.building": "Anbau an ein bestehendes Gebäude",
	"guarantee.extension.solar.plant": "Erweiterung einer bestehenden Solaranlage",
	"guarantee.extractor": "Extraktor",
	"guarantee.fabrication": "Herstellungsprozess",
	"guarantee.fastners": "Materialien für Befestigungselemente",
	"guarantee.fertilizer": "Lagerung von Dünger",
	"guarantee.floating.solar.installation": "Schwimmende Solaranlage",
	"guarantee.floating.solar.magnelis": "Garantie für schwimmende Solaranlagen mit Magnelis®",
	"guarantee.fodder": "Lagerung von Futter",
	"guarantee.forced": "erzwungene Belüftung",
	"guarantee.forced.ventilation": "Erzwungene Belüftung",
	"guarantee.gas.building": "Werden im Gebäude Gase oder Dämpfe freigesetzt?",
	"guarantee.gratings": "Auf Gittern",
	"guarantee.ground.mounted": "Freiflächen Solaranlage",
	"guarantee.heating.type": "Heizungsart",
	"guarantee.horizontal.rails": "Horizontale Holme für Stahlschutzplanken",
	"guarantee.humidity.high": "Hoch",
	"guarantee.humidity.low": "Niedrig",
	"guarantee.humidity.medium": "Mittel",
	"guarantee.humidity.rate.inside.building": "Luftfeuchtigkeit im Inneren des Gebäudes",
	"guarantee.humidity.saturated": "Gesättigt",
	"guarantee.humidity.specify": "Geben Sie den Feuchtigkeitsgrad an.",
	"guarantee.humidity.very.high": "Sehr hoch",
	"guarantee.hydrogen.sulphide": "Geben Sie die Schwefelwasserstoffkonzentration im Gebäude an (in ppm)",
	"guarantee.industrial": "Industriell",
	"guarantee.industrial.questions": "Frage nach industriellem Gebäude",
	"guarantee.industry.type": "Art der Industrie",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Horizontal",
	"guarantee.installation.direction.vertical": "Vertikal",
	"guarantee.last.modified.date": "Letzte Aktualisierung",
	"guarantee.lat.degree": "Grad (0–89)",
	"guarantee.lat.degrees": "Breitengrad",
	"guarantee.lat.max": "Breitengrad (–90 bis 90)",
	"guarantee.lat.minutes": "Breitengrad Minuten",
	"guarantee.lat.seconds": "Breitengrad Sekunden",
	"guarantee.latitude": "Breitengrad",
	"guarantee.latlong.degree.pattern": "Max. 6 Dezimalstellen",
	"guarantee.latlongmin.max": "Minuten (0–59)",
	"guarantee.latlongsec.max": "Sekunden (0–59,9999)",
	"guarantee.latlongsec.pattern": "Max. 4 Dezimalstellen",
	"guarantee.launch.analysis": "Analyse der Einführung",
	"guarantee.long.degrees": "Längengrad Grad",
	"guarantee.long.max": "Längengrad (–180 bis 180)",
	"guarantee.long.minutes": "Längengrad Minuten",
	"guarantee.long.seconds": "Längengrad Sekunden",
	"guarantee.longdegress.max": "Grad (0–179)",
	"guarantee.longitude": "Längengrad",
	"guarantee.magnelis": "Magnelis® Auflagenmasse",
	"guarantee.magnelis.other": "Andere",
	"guarantee.magnelis.poles": "Magnelis® Auflagenmasse für Rammpfosten",
	"guarantee.magnelis.upper.structure": "Magnelis® Auflagenmasse für Oberkonstruktion",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 mit einer Auflagenmasse von 310 g/m² auf beiden Seiten",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 mit einer Auflagenmasse von 430 g/m² auf beiden Seiten",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 mit einer Auflagenmasse von 620 g/m² auf beiden Seiten",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 mit einer Auflagenmasse von 800 g/m² auf beiden Seiten",
	"guarantee.magnelisbuilding.long": "Magnelis® für Bauanwendungen",
	"guarantee.magnelisbuilding.short": "Magnelis® Gebäude",
	"guarantee.magnelisothers.long": "Magnelis® für andere Anwendungen",
	"guarantee.magnelisothers.short": "Magnelis® Sonstige",
	"guarantee.magnelissolar.long": "Magnelis® für Solaranwendungen",
	"guarantee.magnelissolar.short": "Magnelis® Solar",
	"guarantee.manure.management": "Güllemanagement für Gebäude mit Tieren",
	"guarantee.mineral.wool.insulation": "Mineralwolle",
	"guarantee.mounting.system.producer": "Hersteller des Montagesystems",
	"guarantee.msp.company.name": "Unternehmensname",
	"guarantee.name.copy": "Kopieren",
	"guarantee.name.unique.error": "Bei der Verarbeitung ist ein unerwarteter Fehler aufgetreten ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "Eindeutigkeit des Namens",
	"guarantee.name.unique.reason.network": "Server nicht erreichbar",
	"guarantee.natural.ventilation": "Natürliche Belüftung",
	"guarantee.nature.content": "Art der Atmosphäre im Innern des Gebäudes",
	"guarantee.nature.material": "Art des zu ersetzenden Materials",
	"guarantee.new.solar.plant": "Kompletter Bau einer neuen Solaranlage",
	"guarantee.no.duckboard": "Kein Lattenrost",
	"guarantee.no.parts.magnelis": "Keine Teile mit Magnelis®-Beschichtung",
	"guarantee.notypes.available": "Keine Garantieart verfügbar",
	"guarantee.open.building": "Offenes Gebäude",
	"guarantee.open.building.specify": "Angeben:",
	"guarantee.organiccoating.long": "Organisch beschichtete Stähle für Bauanwendungen",
	"guarantee.other": "Sonstige Anwendungen",
	"guarantee.other.application": "Bitte geben Sie die Anwendung an",
	"guarantee.other.building": "Sonstiges (z. B. Büro, Gesundheit, Hotel, Sport und Freizeit, Parken ...)",
	"guarantee.other.coatings": "Beschichteter Stahl mit anderen Beschichtungen",
	"guarantee.other.materials": "Andere Materialien, die in direktem Kontakt mit Magnelis® verwendet werden",
	"guarantee.other.materials.used": "Andere verwendete Materialien",
	"guarantee.others.animals": "Andere",
	"guarantee.others.please.specify": "Bitte angeben",
	"guarantee.part.corrosion": "Korrosionsart",
	"guarantee.part.magnelis": "Magnelis®-Beschichtungsmasse (g/m2)",
	"guarantee.parts.magnelis": "Teile mit Magnelis®-Beschichtung",
	"guarantee.pdf.page": "Seite",
	"guarantee.per.app": "Für welche Anwendung soll das perforierte Blech verwendet werden?",
	"guarantee.per.rich": "Bitte geben Sie das Perforationsschema an",
	"guarantee.perforated.sheet": "Perforiertes Blech",
	"guarantee.pigs": "Schweine",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Geplante Maßnahme(n)",
	"guarantee.poles.magnelis": "Garantie für Pfosten bei Magnelis® Projekten mir Rammpfosten im Erdboden",
	"guarantee.poles.soil": "Projekte mit Rammpfosten im Erdboden",
	"guarantee.power.generation": "Stromerzeugung",
	"guarantee.presence.animals": "Anwesenheit von Tieren im Gebäude",
	"guarantee.prevailing.wind": "Werden die Gase, der Rauch oder die pulverförmigen Freisetzungen von den vorherrschenden Winden weitergetragen?",
	"guarantee.project.characteristics": "Projekteigenschaften",
	"guarantee.project.environment": "Projektumgebung",
	"guarantee.project.for.floating.solar": "Projekt für schwimmende Solaranlagen",
	"guarantee.project.location": "Einsatzort",
	"guarantee.project.name": "Name des Projekts",
	"guarantee.project.name.mandatory": "Der Projektname ist erforderlich",
	"guarantee.project.size": "Projektgröße",
	"guarantee.project.type": "Projektart",
	"guarantee.proposal.ongoing": "Angebot in Arbeit",
	"guarantee.proposals": "Vorschlag und zusätzliche Dokumente",
	"guarantee.proximity.buildings": "In der Nähe von einem oder mehreren Gebäuden, in denen Tiere untergebracht sind oder Gärprodukte gelagert werden",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Bitte geben Sie den Zweck des Gebäudes an",
	"guarantee.questions": "Fragen für industrielle und landwirtschaftliche Gebäude",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "Nein",
	"guarantee.radio.yes": "Ja",
	"guarantee.rainwater.systems": "Regenwasseranlagen / Dachrinnen",
	"guarantee.reason": "Grund",
	"guarantee.refineries.factories": "Dazu gehören vor allem Raffinerien, Verbrennungsanlagen, Kohle- oder Ölkraftwerke, Destillationsanlagen, Zementwerke, Papierfabriken, chemische Anlagen …",
	"guarantee.register": "Produkt – Garantieanfrage",
	"guarantee.register.magnelisbuilding": "Produkt – Garantiezertifikat-Anfrage – Magnelis® für Bauanwendungen",
	"guarantee.register.magnelisothers": "Produkt – Garantiezertifikat anfordern – Magnelis® für andere Anwendungen",
	"guarantee.register.magnelissolar": "Produkt – Garantiezertifikat anfordern – Magnelis® für Solaranwendungen",
	"guarantee.relative.humidity": "Bitte geben Sie die relative Luftfeuchtigkeit an",
	"guarantee.remarks": "Bitte geben Sie weitere Informationen oder Details zu Ihrem Projekt an:",
	"guarantee.request.author": "Autor",
	"guarantee.request.certificate.id": "Zertifikat",
	"guarantee.request.date": "Datum",
	"guarantee.request.drafts": "Garantieanfrage – Entwurf der Liste",
	"guarantee.request.duplicate": "Duplikat",
	"guarantee.request.followup": "Sie können es unter Meine Garantieanträge einsehen.",
	"guarantee.request.id": "Garantie-ID",
	"guarantee.request.list": "Meine Garantieanforderungen",
	"guarantee.request.requested.date": "Gewünschter Termin",
	"guarantee.request.submitted.successfully": "Ihr Garantieantrag wurde erfolgreich eingereicht.",
	"guarantee.request.type": "Typ",
	"guarantee.requested": "Garantie angefordert",
	"guarantee.requested.type.indoor": "Innenanwendung",
	"guarantee.requested.type.indoor.label": "Garantie für Innenanwendung angefordert",
	"guarantee.requested.type.outdoor": "Außenanwendung",
	"guarantee.requested.type.outdoor.label": "Garantie für Außenanwendung angefordert",
	"guarantee.residential": "Für Wohnzwecke",
	"guarantee.retrofitting.existing.building": "Nachrüstung/Reparatur eines bestehenden Gebäudes",
	"guarantee.retrofitting.solar.plant": "Nachrüstung/Reparatur einer bestehenden Solaranlage",
	"guarantee.road.restraint": "Rückhaltesysteme für den Straßenverkehr (Stahlschutzplanken)",
	"guarantee.roofing": "Dachdeckung",
	"guarantee.roofing-cladding.anti-condensation.felt": "Antikondensationsfilz",
	"guarantee.roofing-cladding.color": "Farbe",
	"guarantee.roofing-cladding.desired.back.coat": "Gewünschter Rückseitenanstrich",
	"guarantee.roofing-cladding.desired.coating": "Gewünschte Beschichtung",
	"guarantee.roofing-cladding.external.skin": "Außenschale",
	"guarantee.roofing-cladding.insulation": "Isolierung",
	"guarantee.roofing-cladding.internal.skin": "Innenschale",
	"guarantee.roofing-cladding.made.with.product": "Vollständig mit dem Produkt hergestellte Dacheindeckungen und/oder Verkleidungen",
	"guarantee.roofing-cladding.metallic.coating.weight": "Gewicht der Metallauflage",
	"guarantee.roofing-cladding.overlapping": "Überlappung",
	"guarantee.roofing-cladding.perforation": "Perforation",
	"guarantee.roofing-cladding.pv.solar.roof": "PV-/Solardach",
	"guarantee.roofing-cladding.substrate.thickness": "Dicke des Substrats",
	"guarantee.roofing-cladding.surface": "Fläche",
	"guarantee.roofing.decking.roof": "Terrassendach",
	"guarantee.roofing.roofslope": "Dachneigung (%)",
	"guarantee.roofing.specify.material.type": "In der Dacheindeckung (Art des Materials und bedeckte Fläche angeben)",
	"guarantee.rooftop.installation": "Installation auf dem Dach",
	"guarantee.rrs.miscellaneous": "Verschiedene Teile von Verkehrsrückhaltesystemen, die der atmosphärischen Korrosion ausgesetzt sind",
	"guarantee.rrs.poles": "Pfosten für Verkehrsrückhaltesysteme",
	"guarantee.rrs.welded": "Sind die aus Magnelis® hergestellten Teile geschweißt?",
	"guarantee.rural.area": "In einer ländlichen Gegend mehr als 10 km von der Küste entfernt",
	"guarantee.rural.area.20KM": "In einer ländlichen Gegend, mehr als 20 km von der Küste entfernt",
	"guarantee.sandwich.panel": "Sandwich-Paneele oder Aufbausystem",
	"guarantee.satisfied": "Zufrieden",
	"guarantee.save.failed": "Garantieübermittlung fehlgeschlagen.",
	"guarantee.save.failed.message": "Bitte versuchen Sie es später noch einmal oder kontaktieren Sie ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "Meine Garantieanforderungen",
	"guarantee.sheet.thickness": "Blechdicke (mm)",
	"guarantee.silo": "Silo",
	"guarantee.silo.cylinder": "Zylinder des Silos",
	"guarantee.silo.liner": "Wird der Silo eine Auskleidung haben?",
	"guarantee.silo.parts": "Welche Teile des Silos werden mit Magnelis® hergestellt?",
	"guarantee.silo.products": "Welche Produkte sollen im Silo gelagert werden?",
	"guarantee.silo.roof": "Dach des Silos",
	"guarantee.silo.soil": "Basis des Sillos, die mit dem Erdboden oder mit Beton in Berührung kommt",
	"guarantee.single.skin.roof": "Ein-Schalen-Dach",
	"guarantee.soil.analysis": "Liegt eine vollständige Bodenanalyse vor?",
	"guarantee.soil.document": "Wenn ja, hängen Sie bitte das Dokument mit der Bodenanlyse an:",
	"guarantee.soil.information": "Die Bodenanalyse sollte mindestens die folgenden Informationen enthalten: Granulometrie, pH-Wert, Feuchtigkeitsgehalt, Chloridgehalt, Sulfatgehalt, Sulfidgehalt, spez. Bodenwiderstand, Vorhandensein von Grundwasser. Jede weitere Information über den Boden, die für die Bewertung nach DIN 50929-3:2024 benötigt wird, ist nützlich.",
	"guarantee.soil.requirements.title": "Anforderungen an die Bodenanalyse",
	"guarantee.specific.environment": "In einer bestimmten Umgebung (Kombination der oben genannten Exposition und bestimmter zusätzlicher Effekte, hohe Temperatur, hohe Luftfeuchtigkeit, erhebliche Staubablagerungen usw.)",
	"guarantee.specify": "Bitte spezifizieren Sie:",
	"guarantee.specify.perforation.scheme": "Perforationsschema angeben",
	"guarantee.stainless.steel": "Nichtrostender Stahl",
	"guarantee.steel.parts": "Nichtrostender Stahl für Teile",
	"guarantee.storage.chemicals": "Vorhandensein und/oder Verwendung und/oder Lagerung von chemischen Produkten",
	"guarantee.storage.fermentation": "Vorhandensein und/oder Lagerung von Fermentationsprodukten",
	"guarantee.structure": "Die Struktur ist vollständig aus Magnelis® hergestellt.",
	"guarantee.suggested.coating.mass": "Die Auflagenmasse wird von ArcelorMittal auf Grundlage der erwarteten Garantiedauer vorgeschlagen.",
	"guarantee.summary": "Zusammenfassung",
	"guarantee.supplier.rejected": "Abgelehnt durch den Lieferanten",
	"guarantee.surface.building": "Für Bauanwendungen: Oberfläche (m²):",
	"guarantee.tonnage.magnelis": "Tonnage von mit Magnelis® beschichtetem Stahl",
	"guarantee.type": "Art der Garantie",
	"guarantee.type.application": "Art der Anwendung",
	"guarantee.type.of.installation": "Art der Installation",
	"guarantee.types.of.guarantee": "Garantiearten",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Garantie für die Oberkonstruktion aus Magnelis®",
	"guarantee.urban.agglomeration": "In einer städtischen Agglomeration und/oder industriellen Umgebung",
	"guarantee.use.of.other.materials": "Verwendung anderer Materialien, insbesondere von Zement und Schlackenbetonstein",
	"guarantee.ventilation.roof": "natürliche Belüftung durch Blenden im Dach",
	"guarantee.ventilation.walls": "natürliche Belüftung durch Blenden in den Wänden",
	"guarantee.wall.facade": "Wand / Fassade",
	"guarantee.water.analysis": "Ist eine Wasseranalyse verfügbar?",
	"guarantee.water.document": "Bitte übermitteln Sie die Wasseranalyse zusammen mit dem Garantieantrag",
	"guarantee.water.information": "Die Wasseranalyse sollte mindestens die folgenden Angaben enthalten: Chloridgehalt, Sulfatgehalt, Calciumgehalt, Magnesiumgehalt, Alkalität Ks4,3, pH-Wert, Struktur/Wasserpotential UH, Leitfähigkeit. Alle anderen Informationen über das Wasser, die der DIN 50929-3:2018 entsprechen, sind nützlich.",
	"guarantee.water.requirements.title": "Anforderungen an die Wasseranalyse",
	"guarantee.with.partial.momentary.wetting": "Bei teilweiser oder kurzzeitiger Befeuchtung mit Meerwasser und/oder direkter Einwirkung von Meeresgischt",
	"guarantee.without.direct.wetting": "Ohne direkte Befeuchtung mit Meerwasser und/oder direkter Einwirkung von Meeresgischt",
	"guarantee.without.gratings": "Ohne Gitter",
	"guarantee.zinc": "Verzinkter Stahl",
	"gurantee.duration.years": "Erwartete Garantiedauer (in Jahren)",
	"gurantee.other.coating.mass": "Andere Beschichtungsmasse",
	"help.data.documents": "Dokumente",
	"help.documents": "Unterstützende Dokumente",
	"highest.stocks.widget.title": "Top 5 der höchsten Bestände",
	"home.batch-list": "Mein Material",
	"home.customer.feedback": "Rückmeldung des Kunden",
	"home.dashboard": "Dashboard",
	"home.deliveryschedule": "Tracking: Lieferverfolgung Forecast: Liefervoraussage",
	"home.diplay.last.batches": "Die letzten 20 angezeigten Coils sehen",
	"home.identify.batch": "Ein Coil identifizieren",
	"home.last.seen.batch": "Zuletzt angezeigte Coils",
	"home.no.service": "Ihr Profil erlaubt leider keinen Zugriff auf die Funktionen. Bitte kontaktieren Sie Ihren SteelUser Relay, um vollen Zugang zu den App-Funktionalitäten zu erhalten.",
	"home.no.service.alert": "Kein Service",
	"home.order-tracking.commercial-documents": "Meine Handelsdokumente",
	"home.order-tracking.my-schedule-business-order": "Meine Lieferpläne",
	"home.order-tracking.orders": "Meine Aufträge",
	"home.ordertracking": "Auftragsverfolgung",
	"home.quality-issues.issues": "Meine Qualitätsprobleme",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR landed duty unpaid",
	"incoterm.23": "CFR liner terms duty unpaid",
	"incoterm.24": "CFR free out duty unpaid",
	"incoterm.25": "CIF landed duty unpaid",
	"incoterm.26": "CIF LINER TERMS DUTY UNPAID",
	"incoterm.27": "CIF FREE OUT",
	"incoterm.28": "CFR sous palan",
	"incoterm.33": "CFR FO Quick custom desp",
	"incoterm.CFR": "CFR (Cost and Freight)",
	"incoterm.CIF": "CIF (Cost, Insurance, Freight)",
	"incoterm.CIP": "CIP (Carriage and insurance paid to)",
	"incoterm.CPT": "CPT (Carriage paid to)",
	"incoterm.DAF": "Geliefert Grenze",
	"incoterm.DAT": "DPU (Delivered at Place Unloaded)",
	"incoterm.DDP": "DDP (Delivered duty paid)",
	"incoterm.DDU": "Geliefert unverzollt",
	"incoterm.DEQ": "Fracht bezahlt bis Kai",
	"incoterm.DES": "Geliefert ab Schiff",
	"incoterm.FAS": "FAS (Free alongside ship)",
	"incoterm.MAD": "Im Werk bereitgestellt",
	"incoterm.RC": "Einschließlich Transport zum Standort des Kunden",
	"incoterm.dap": "DAP (Delivered at place)",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "FCA (Free carrier)",
	"incoterm.fob": "FOB (Free on board)",
	"inner.greater.than.outer.error": "Feld größer als Außen-Ø.",
	"internal.placeholder.choose.customer": "Kundennamen bitte eingeben",
	"issue.acceptedquantity": "Akzeptierte Menge",
	"issue.acceptedquantity.value": "Akzeptierte Menge (Wert)",
	"issue.action.data.center": "Datenzentrum",
	"issue.action.filters": "Filter",
	"issue.attach.documents": "Anhang hinzufügen",
	"issue.batch.cdd": "CDD",
	"issue.batch.commercial.documents": "Kommerzielle Dokumente",
	"issue.batch.customer.order.number": "Kundenbestellnummer",
	"issue.batch.dimension": "Abmessungen (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "Kein Ergebnis",
	"issue.batch.number": "Chargennummer",
	"issue.batch.quick.search": "Schnellsuche",
	"issue.batch.status": "Status",
	"issue.batch.steelgrade": "Stahlsorte",
	"issue.batch.view-details": "Details anzeigen",
	"issue.batchesassociated": "Coils zu diesem Problem",
	"issue.calimed.quantity": "reklamierte Menge ",
	"issue.calimed.quantity.value": "reklamierte Menge (Wert)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Beschwerde",
	"issue.closingdate": "Letzter Tag",
	"issue.contact.info": "Kontoinformationen",
	"issue.contact.label": "Ich möchte von einem ArcelorMittal-Ansprechpartner kontaktiert werden.",
	"issue.contact.type": "Kontaktart",
	"issue.creditnote": "Gutschrift",
	"issue.creditnotedate": "Datum Kreditdokument",
	"issue.currency": "Währung",
	"issue.customer.defect": "Kundendefekt",
	"issue.customer.reference": "Kundenreferenz für Qualitätsprobleme",
	"issue.decision": "Entscheidung",
	"issue.defect.type": "Art des Defekts",
	"issue.do.you.want.to.be.contacted": "Möchten Sie kontaktiert werden?",
	"issue.draft": "Vorlage",
	"issue.draft.deleted": "Ihr Entwurf wurde erfolgreich gelöscht",
	"issue.drag.and.drop.files": "Ziehen Sie Ihre Dateien per Drag & Drop hierher",
	"issue.filterbystatus": "Status filtern",
	"issue.followup.widget.title": "Feedback zur Qualität",
	"issue.inprocess": "in Bearbeitung",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Qualitätsproblem-Details",
	"issue.issuedocuments": "Dokumente",
	"issue.issueinformation": "Informationen zum Problem",
	"issue.ok.value": "OK",
	"issue.origin": "Herkunft",
	"issue.origin.ach": "ArcelorMittal Schadenerfassungssystem",
	"issue.origin.sta": "SteelUser",
	"issue.pending": "Ausstehende",
	"issue.qualityfeedback": "Dashboard zur Produktqualität - Problemliste",
	"issue.qualityissues": "Reklamationsübersicht",
	"issue.qualityissues.drafts": "Qualitätsproblem - Liste der Entwürfe",
	"issue.register": "Ein Qualitätsproblem registrieren",
	"issue.requested.total.amount": "Angeforderter Gesamtbetrag ",
	"issue.requested.total.amount.value": "Angeforderter Gesamtbetrag (Wert)",
	"issue.save.as.drafts": "Als Vorlage speichern",
	"issue.select.batches.action.next": "Weiter",
	"issue.select.current.batch": "Ihre aktuell ausgewählte Charge:",
	"issue.select.first.batch": "Wählen Sie die erste Charge für die Registrierung Ihrer Qualitätsprobleme aus.",
	"issue.select.other.batch": "Oder wählen Sie eine andere Charge",
	"issue.send.claim": "Absenden",
	"issue.sending.sample": "Probe versenden",
	"issue.shipments": "Lieferungen",
	"issue.submit.quality.feedback": "Geben Sie Ihr Qualitätsfeedback ab",
	"issue.supplierdefect": "Lieferantendefekt",
	"issue.supplierissuenumber": "ArcelorMittal Qualitätsproblem number",
	"issue.total.amount.accepted": "Gesamtbetrag akzeptiert",
	"issue.total.amount.accepted.value": "Gesamtbetrag akzeptiert (Wert)",
	"issue.type.of.request": "Art der Anfrage",
	"issue.unit": "Einheit",
	"issue.widget.overviewofqi": "Überblick der Qualitätsprobleme",
	"issue.widget.selector.feedbackselected": "Sie haben ausgewählt: Quality Feedback Follow-up",
	"issue.widget.selector.validateadvice": "Klicken Sie auf validieren, um Ihre Auswahl zu bestätigen",
	"label.calculation": "Berechnung erhalten",
	"label.coil.calculator": "Coilrechner",
	"last.guarantee.requests": "Letzte Garantieanforderungen",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "ArcelorMittal Need4Steel® Vertriebs",
	"legal-documents.agree.to.sales.conditions": "Bitte akzeptieren Sie unsere",
	"legal-documents.and": "und",
	"legal-documents.confirm.cart.with.sales.conditions": "Mit der Bestätigung Ihres Warenkorbs akzeptieren Sie unsere",
	"legal-documents.general.sales.conditions": "die Allgemeinen Verkaufbedinungen",
	"legal-documents.non.prime.sales.framework": "Rahmen für nicht erstklassige Verkäufe",
	"legal.data.header": "Allgemeine Geschäftsbedingungen und Richtlinien",
	"line.select.family.period": "Wählen Sie einen Zeitraum zum Durchsuchen",
	"line.select.family.product": "Wählen Sie eine Produktfamilie zum Durchsuchen",
	"line.select.period.fiveyears": "5 Jahre",
	"line.select.period.oneyear": "1 Jahr",
	"line.select.period.sixmonths": "6 Monate",
	"line.select.period.threemonths": "3 Monate",
	"line.select.period.twoyear": "2 Jahre",
	"line.select.tab.layout": "Wählen Sie Ihr Registerkartenlayout",
	"linked.soldto": "Verknüpft Verkauft an",
	"loader.text": "Laden des Produkts",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Services hinzufügen",
	"manage.services.drag-and-drop-items-on-the-right": "Elemente von rechts heranziehen, um einen Service hinzuzufügen",
	"manual.data.customer": "Kundenbestellnummer",
	"manual.data.enter.reference": "Bitte geben Sie eine Bestellnummer ein",
	"manual.data.not.found": "Keine Charge gefunden.",
	"manual.data.num": "Artikel",
	"manual.data.reference": "Referenz",
	"manual.data.supplier": "Lieferantenauftragsnummer",
	"manual.data.supplier.or.customer": "Bitte geben Sie die Lieferantenauftragsnummer oder die Kundenbestellnummer ein.",
	"materials.rts.widget.title": "Versandfertiges Material",
	"menu.closed.issues": "Geschlossene Qualitätsprobleme",
	"menu.declare.choose.customer": "Wählen Sie einen Kunden aus",
	"menu.declare.order-tracking": "Web-Auftragsverfolgung",
	"menu.declare.order-tracking.deliveryschedule": "Tracking: Lieferverfolgung\r\r\r\r\r\r\r\r\nForecast: Liefervoraussage",
	"menu.declare.order-tracking.ordertracking": "Auftragsverfolgung",
	"menu.declare.quality.issue": "Qualitätsproblem deklarieren",
	"menu.drafts": "Vorlagen",
	"menu.logout": "ABMELDEN",
	"menu.modify.quality.issue": "Qualitätsproblem ändern",
	"menu.order-services": "Services bestellen",
	"menu.pending.issues": "Offene Qualitätsprobleme",
	"menu.product-services": "Produktservices",
	"menu.profile": "Profil",
	"menu.sales-services": "Verkaufsservices",
	"menu.settings": "Einstellungen",
	"menu.sign.in": "Anmelden",
	"modification.error.message": "Ihre Änderung wird nicht gespeichert",
	"n4steel.contact-add-attachment": "Anhang hinzufügen",
	"n4steel.contact-attachment-help": "Fügen Sie Ihre Datei hier ein",
	"n4steel.contact-mail": "Kontakt ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "Von",
	"n4steel.contact-mail-invalid-email": "Ungültiges Format der E-Mail Adresse",
	"n4steel.contact-mail-mill": "Werk",
	"n4steel.contact-mail-offer": "Angebot",
	"n4steel.contact-mail-prefill-data": "Diese Daten werden automatisch mit der Nachricht gesendet",
	"n4steel.upload.file.size.error.message": "Maximal 10 MB pro Datei und maximal 3 Dateien.",
	"navig.confirm": "Bestätigen",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "No historical order from your ArcelorMittal Need4Steel® orderbook is matching the current offer options",
	"need4steel-order.history.import": "Import",
	"need4steel-order.history.notfound": "No order found",
	"need4steel-order.history.subtitle": "Please select products to import",
	"need4steel-order.history.title": "Order History",
	"need4steel-product-details-tooltip.no-price-msg": "Produktdaten nicht verfügbar",
	"need4steel-product-details-tooltip.price-msg": "Produktdaten anzeigen",
	"need4steel-product-details.chemical-treatment": "Chemische Behandlung",
	"need4steel-product-details.effectivedelivered": "€/t effektiv geliefert",
	"need4steel-product-details.header-msg": "Einzelheiten zum Produkt -",
	"need4steel-product-details.max-outside-Diameter": "Maximaler Außendurchmesser (mm)",
	"need4steel-product-details.min-coil-weight": "Min. Ringgewicht (t)",
	"need4steel-product-details.proposed-price": "Vorgeschlagener Preis",
	"need4steel-product-details.unrolledWelds": "Abgerollte Schweißnähte",
	"need4steel-product-offers.additional-fields": "Zusätzliche Felder",
	"need4steel-product-section-details.min-coil-weight": "Min Coil Weight (t)",
	"need4steel-schedule.button": "Import from history",
	"need4steel-summary-details.effectivedelivered": "effektiv geliefert",
	"need4steel.dialog.coil.weight": "Max. Ringgewicht (t)",
	"need4steel.dialog.coil.weight.range": "von {{minValue}} bis {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Max. Ringgewicht Bereich",
	"need4steel.dialog.max.coilweight.range.content": "Maximal verfügbares Ringgewicht",
	"need4steel.dialog.max.specific.weight.range.content": "Maximal verfügbares spezifisches Gewicht",
	"need4steel.dialog.range.steelgrade": "Für Grad",
	"need4steel.dialog.specific.weight.range": "von {{minValue}} bis {{maxValue}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Max. spezifischer Gewichtsbereich",
	"need4steel.dialog.thickness.content": "Bitte wählen Sie eine SteelGrade aus",
	"need4steel.dialog.thickness.list.content": "Wenn es offensichtlich ist, einen Wert auswählen zu müssen",
	"need4steel.dialog.thickness.range.content": "Verfügbare Abmessungen für die Dicke sind",
	"need4steel.dialog.thickness.range.title": "Bereich der Dicke",
	"need4steel.dialog.width.content": "Bitte geben Sie einen geeigneten Wert für die Dicke ein",
	"need4steel.dialog.width.list.content": "Bitte wählen Sie einen geeigneten Wert für die Dicke aus",
	"need4steel.dialog.width.range.content": "Verfügbare Abmessungen für die Breite sind",
	"need4steel.dialog.width.range.title": "Bereich der Breite",
	"need4steel.dialog.width.range.title.content": "und Dicke",
	"need4steel.offer.error.message": "Beim Zugriff auf dieses Angebot sind leider einige Fehler aufgetreten. Bitte versuchen Sie es erneut oder senden Sie eine Nachricht an Ihre ArcelorMittal-Kontaktperson.",
	"need4steel.offer.finishingline": "Veredelungslinie",
	"need4steel.offer.simulation.error.message": "Entschuldigung, es sind einige Fehler aufgetreten. Bitte versuchen Sie es erneut oder senden Sie eine Nachricht an Ihren ArcelorMittal-Kontakt",
	"need4steel.offers.order.button": "Bestellung",
	"need4steel.offers.title": "ArcelorMittal Need4Steel® Angebote",
	"need4steel.product.details.product.coilweight": "Max. Ringgewicht (t)",
	"need4steel.product.details.specific.weight": "Max. spezifisches Gewicht (kg/mm)",
	"need4steel.product.thickness.tolerance": "DickeToleranz",
	"need4steel.soldto.shipto.error.message": "Entschuldigung, es gibt ein Problem in Ihren Serviceeinstellungen. Bitte wenden Sie sich an den SteelUser-Administrator.",
	"need4steel.submit.credit.limit.error.msg": "☹ ArcelorMittal Need4Steel® order request impossible: not sufficient credit limit available. Please contact us at need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Etwas ist schief gelaufen, bitte kontaktieren Sie den SteelUser-Administrator",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "Der Wechselkurs ist erforderlich",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "Der Wechselkurs wurde während Ihres Bestellvorgangs aktualisiert. Bitte prüfen Sie ihn, bevor Sie die Bestellung erneut absenden",
	"need4steel.submit.order.error.msg.title": "Fehler bei der Validierung Ihrer Bestellung",
	"need4steel.submit.order.success.msg.row1": "Ihre Bestellung wurde bearbeitet",
	"need4steel.submit.order.success.msg.row2": "Sie können den Status Ihrer Bestellung verfolgen in der",
	"need4steel.submit.order.success.msg.row2.link": "NACHVERFOLGUNG DER BESTELLUNG UND LIEFERUNG.",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Bitte geben Sie einen gültigen Wert kleiner oder gleich 1.000 ein.",
	"need4steel.wizard.estimated": "Geschätzt:",
	"need4steel.wizard.exchange-rate.rate": "Wechselkurs",
	"need4steel.wizard.exchange-rate.reference-date": "Referenzdatum",
	"need4steel.wizard.header.Delivery-address": "Die Lieferadresse ist eine Pflichtangabe",
	"need4steel.wizard.header.customer": "Der Kunde ist erforderlich",
	"need4steel.wizard.header.customer-order-number": "Kundenbestellnummer",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Ungültige Kundenbestellnummer",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "Die Kundenbestellnummer ist erforderlich",
	"need4steel.wizard.header.delivery.date": "Lieferdatum",
	"need4steel.wizard.header.mill": "Werk",
	"need4steel.wizard.header.shipto": "Lieferadresse",
	"need4steel.wizard.header.soldto": "Kunde",
	"need4steel.wizard.header.transport-mode": "Transportmittel",
	"need4steel.wizard.maxcoilweight.range.error": "Bitte geben Sie ein gültiges maximales Ringgewicht ein.",
	"need4steel.wizard.maxspecificweight.range.error": "Bitte geben Sie ein gültiges maximales spezifisches Gewicht ein",
	"need4steel.wizard.no.weight.option.error.message": "Problem mit den Vorlageneinstellungen: keine Gewichtsoptionen",
	"need4steel.wizard.product.coil.weight": "t max. Coilgewicht",
	"need4steel.wizard.product.max.specific.weight": "kg/mm max. Coilgewicht",
	"need4steel.wizard.product.price.calculate.offline": "Bitte stellen Sie sicher, dass Sie einen Internetzugang haben, um einen Preis anzufragen",
	"need4steel.wizard.product.specific.weight": "Max. spezifisches Gewicht (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Auswahl des Gewichtstyps",
	"need4steel.wizard.step.product.title": "Produkt spezifizieren",
	"need4steel.wizard.stepper.product.action.delete": "Löschen",
	"need4steel.wizard.stepper.product.action.duplicate": "Kopieren",
	"need4steel.wizard.stepper.product.action.reset": "Zurücksetzen",
	"need4steel.wizard.stepper.product.add": "Produkt hinzufügen",
	"need4steel.wizard.stepper.product.coil": "# (Ring)",
	"need4steel.wizard.stepper.product.coilweight": "Max. Ringgewicht (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Positionsnummer",
	"need4steel.wizard.stepper.product.steelgrade": "Stahlsorte",
	"need4steel.wizard.stepper.product.thickness": "Dicke (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Gesamtgewicht",
	"need4steel.wizard.stepper.product.width": "Breite (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Produktspezifikationen",
	"need4steel.wizard.stepper.step.summary": "Zusammenfassung",
	"need4steel.wizard.summary.confirm.to.order.button": "Bestellung bestätigen",
	"need4steel.wizard.summary.proceed.order.button": "Weiter zur Bestellung",
	"need4steel.wizard.summary.product.coils": "Nr. der Spulen",
	"need4steel.wizard.summary.product.dimension": "Abmessungen (mm)",
	"need4steel.wizard.summary.product.price": "Preis (€/t)",
	"need4steel.wizard.summary.product.selection": "Produktauswahl",
	"need4steel.wizard.summary.product.total.weight": "Gesamtgewicht (t)",
	"need4steel.wizard.summary.terms.conditions.text": "Wenn Sie auf „Bestellung fortsetzen“ klicken, akzeptieren Sie die Allgemeinen Geschäftsbedingungen von ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Bitte geben Sie eine gültige Dicke ein.",
	"need4steel.wizard.thickness.tolerance.field": "Dickentoleranz",
	"need4steel.wizard.width.range.error": "Bitte geben Sie eine gültige Breite ein.",
	"new.offer.request.message": "Kennen Sie die Menge, die Sie pro Artikelspezifikation benötigen?",
	"news.detail": "Details anzeigen",
	"news.last-news": "Aktuelle Nachrichten",
	"news.news-list": "Nachrichtenliste",
	"news.view-all": "Alle ansehen",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "Keine Garantiedokumente",
	"no.legal.documents": "Keine Dokumente gefunden",
	"no.product.family": "Es wurde keine Produktfamilie gefunden.",
	"no.result": "kein Ergebnis gefunden",
	"notifications.daily": "Täglich",
	"notifications.immediatly": "Sofort",
	"notifications.management": "Benachrichtigungsverwaltung",
	"notifications.monthly": "Monatlich",
	"notifications.weekly": "Wöchentlich",
	"number.of.items.in.order": "Zu viele Artikel, um sie dieser Bestellung hinzuzufügen.",
	"number.of.items.infos.message": "Bitte geben Sie die Anzahl der Exemplare dieses Produkts ein, die Sie als Artikel in dieser Bestellung wünschen",
	"number.of.items.label": "Anzahl der Artikel",
	"number.of.items.limit.in.order": "Wir können nur 100 Artikel in einer Bestellung akzeptieren. Bitte überprüfen Sie Ihre Auswahl.",
	"offer-dashboard-card.accepted": "Akzeptiert",
	"offer-dashboard-card.annually": "Jährlich",
	"offer-dashboard-card.monthly": "Monatlich",
	"offer-dashboard-card.offered": "Angeboten",
	"offer-dashboard-card.order": "Bestellung",
	"offer-dashboard-card.other-period": "Andere Periode",
	"offer-dashboard-card.quarterly": "Vierteljährlich",
	"offer-dashboard-card.remaining-to-order": "Verbleibend zu bestellen",
	"offer-dashboard-card.requested": "Angefordert",
	"offer-dashboard-card.semesterly": "Halbjahr",
	"offer-dashboard-card.view-details": "Details anzeigen",
	"offer-period.from": "Von",
	"offer-period.reset": "Zurücksetzen",
	"offer-period.to": "An",
	"offer.card.table.header.quantity": "Menge (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "Meine Services",
	"offer.end.date": "Enddatum",
	"offer.enduser.update.cart.warning": "Dieser Endkunde ist mit einigen ausgewählten Produkten nicht kompatibel. Sie werden automatisch aus dem Warenkorb entfernt.",
	"offer.multiple.families": "Mehrere",
	"offer.new.request.title": "Neue Anfrage",
	"offer.product.disabled.tooltip": "Dieses Produkt ist mit der aktuell ausgewählten Lieferadresse oder dem Endbenutzer nicht kompatibel",
	"offer.product.family": "Produktfamilie",
	"offer.quantity.framework": "Wählen Sie die Mengen pro Familie, auf die Sie ein Angebot erhalten möchten ",
	"offer.quantity.spot": "Wählen Sie die Mengen pro Artikel, auf die Sie ein Angebot erhalten möchten ",
	"offer.shipto.update.cart.warning": "Diese Lieferadresse ist mit einigen ausgewählten Produkten nicht kompatibel. Sie werden automatisch aus dem Warenkorb entfernt.",
	"offer.sub.family": "Unterfamilie",
	"offer.template.disabled.tooltip": "Dieses Vorlage ist mit der aktuell ausgewählten Lieferadresse oder dem Endbenutzer nicht kompatibel",
	"offer.transport.condition": "Transportbedingung",
	"offer.type.no": "Nein",
	"offer.type.yes": "Ja",
	"offer.weight": "Gewicht",
	"offers.action.next": "Weiter",
	"offers.commercial.terms": "Geschäftsbedingungen",
	"offers.commitment.period": "Verpflichtungszeitraum",
	"offers.create.details.customer.offer-name": "RFQ-Nummer des Kunden",
	"offers.create.details.customer.offer-name.error.mandatory": "Die Kundenanfragenummer ist obligatorisch",
	"offers.create.details.field.currency": "Wählen Sie Ihre Währung",
	"offers.create.details.field.offer-name": "Name der Angebotsanfrage",
	"offers.create.details.field.offer-name.error.mandatory": "Der Name der Angebotsanfrage ist obligatorisch",
	"offers.create.details.section.entities": "Rechtsträger",
	"offers.create.details.section.offer-period": "Angebotsbedingungen und Bindungsdauer",
	"offers.create.path.cart": "Menge festlegen",
	"offers.create.path.confirmation": "Senden Sie Ihre Angebotsanfrage",
	"offers.create.request.offer": "Bitte um ein Angebot",
	"offers.create.section.offer-period": "Bedingungen und Bindungsfrist",
	"offers.product.list": "Liste der Produkte",
	"offers.proposals.price.nooffer": "Kein Angebot verfügbar",
	"offers.proposals.price.period": "Zugehöriger Zeitraum",
	"offers.proposals.price.title": "Letzte Preisangebote",
	"offers.request.info": "Informationen zur Angebotsanfrage",
	"offers.soldTo.selection.text": "Bitte wählen Sie den richtigen Kunden für diese Angebotsanfrage aus, um die Liste der verfügbaren Produkte anzuzeigen. Alle Artikel im Warenkorb sollten sich auf denselben Kunden beziehen.",
	"offers.sqmeters": "Quadratmeter",
	"offers.wizard.stepper.customization": "Personalisierung",
	"offers.wizard.stepper.request.and.selection": "Angebotsanfrage & Auswahl",
	"offers.wizard.stepper.step.offer-summary": "Zusammenfassung",
	"offers.wizard.stepper.step.quantity": "Anzahl",
	"offline.alert": "Alarm",
	"ok.value": "OK",
	"order-card.batches-at-reshipper": "Beim Verschiffer",
	"order-card.batches-available": "Coils - verfügbar",
	"order-card.batches-blocked": "Coils - blockiert",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Konsignationslager",
	"order-card.batches-delivered": "Coils - geliefert",
	"order-card.batches-land-transit": "Landtransit",
	"order-card.batches-on-vessel": "Verschifft",
	"order-card.batches-overseas-transit": "Überseetransit",
	"order-card.batches-ready-to-ship": "Versandbereit",
	"order-card.batches-transit-to-customer": "Im Transit zum Kunden",
	"order-card.commercial-documents": "Kommerzielle Dokumente",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Dokument",
	"order-card.due-to-technical-issue": "Aufgrund eines technischen Problems können wir diese Daten nicht anzeigen.",
	"order-card.gross": "Brutto: {{value}}",
	"order-card.name": "Name",
	"order-card.net": "Netto: {{value}}",
	"order-card.no-rows-to-show": "Keine Informationen verfügbar",
	"order-card.proforma": "Proforma",
	"order-card.type": "Typ",
	"order-card.we-are-actively-working": "Wir arbeiten aktiv an der Wiederherstellung des Services.",
	"order-card.wip-quantity": "Menge (t)",
	"order-card.work-in-progress": "In Produktion",
	"order-item-status.completely-produced": "Produktion abgeschlossen",
	"order-tracking.card.batches-in-stock": "Versandbereites Material",
	"order-tracking.card.callables-batches.days": "{{value}} Tage",
	"order-tracking.card.callables-batches.view-details": "Details anzeigen",
	"order-tracking.card.delivery-date.cdd": "CDD",
	"order-tracking.card.delivery-date.first-batch": "FRÜHESTER LAGEREINGANG",
	"order-tracking.card.delivery-date.last-batch": "SPÄTESTER LAGEREINGANG",
	"order-tracking.card.delivery-date.rdd": "RDD",
	"order-tracking.card.delivery-date.view-details": "Details anzeigen",
	"order-tracking.card.delivery-status": "Auftragsstatus",
	"order-tracking.cdd": "Best.Lief.Dat.",
	"order-tracking.choice": "Wahl",
	"order-tracking.customerArticleReference": "Artikelreferenz des Kunden",
	"order-tracking.delivered": "Geliefert",
	"order-tracking.delivered-t": "Geliefert (t)",
	"order-tracking.dimension": "Abmessungen (mm)",
	"order-tracking.final.use": "Verwendungszweck",
	"order-tracking.form": "Form",
	"order-tracking.in.production": "In Produktion",
	"order-tracking.in.production-t": "In Produktion (t)",
	"order-tracking.in.stock": "Lager",
	"order-tracking.in.stock-t": "Lager (t)",
	"order-tracking.in.transit": "Transit",
	"order-tracking.in.transit-t": "Transit (t)",
	"order-tracking.list": "Liste",
	"order-tracking.no.connection": "Die Web-Auftragsverfolgung ist nicht verfügbar.",
	"order-tracking.no.result": "Kein Ergebnis",
	"order-tracking.overview": "Übersicht",
	"order-tracking.product": "Produkt",
	"order-tracking.product.category": "Produktkategorie",
	"order-tracking.product.description": "Produktbeschreibung",
	"order-tracking.running.orders": "Aktive Liefereinteilungen",
	"order-tracking.standard-steel-grade": "Stahlsorte",
	"order-tracking.standard.steelgrade": "Stahlsorte",
	"order-tracking.steelgrade": "Stahlsorte",
	"order.avail-t": "Verfüg (t)",
	"order.bill.to": "Rechnungsempfänger",
	"order.book.only": "Nur Auftragsbuch",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Auftragsdetails",
	"order.card.all.documents": "Alle Dokumente für diesen Auftrag",
	"order.card.certificate.display.all": "Alle Werkszeugnisse anzeigen",
	"order.card.dates": "Daten",
	"order.card.detail.information": "Auftragsinformationen anzeigen",
	"order.card.dispatch.advice.display.all": "Alle Lieferscheine anzeigen",
	"order.card.document.certificates": "Werkszeugnisse",
	"order.card.document.date": "Datum",
	"order.card.document.dispatch.advices": "Lieferscheine",
	"order.card.document.display.batches": "Alle Coils anzeigen",
	"order.card.document.invoices": "Fakturiert",
	"order.card.document.number": "Dokumentnummer",
	"order.card.document.order.acknowledgments": "Auftragsbestätigung",
	"order.card.document.show": "Dokument anzeigen",
	"order.card.document.type": "Typ",
	"order.card.followup": "Auftragsverfolgung",
	"order.card.in-consignment": "In Konsignation",
	"order.card.in-consignment-t": "In Konsignation (t)",
	"order.card.information": "Auftragsinformationen",
	"order.card.invoice.display.all": "Alle Rechnungen anzeigen",
	"order.card.last.certificate": "Letztes Werkszeugnis",
	"order.card.last.dispatch.advice": "Letzter Lieferschein",
	"order.card.last.documents": "Letzte Dokumente",
	"order.card.last.invoice": "Letzte Rechnung",
	"order.card.last.order.acknowledgment": "Letzte Auftragsbestätigung",
	"order.card.order.acknowledgment.display.all": "Alle Auftragsbestätigungen anzeigen",
	"order.card.product": "Produkt",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "Best.Lief.Dat. (Woche)",
	"order.certificate": "Werkszeugnis",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Wahl",
	"order.coating": "Beschichtung",
	"order.coating-side": "Beschichtungsseite",
	"order.color-bottom-side": "Farbe Unterseite",
	"order.color-top-side": "Farbe Oberseite",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Bestätigtes Lieferdatum",
	"order.contract.number": "Vertragsnummer",
	"order.creation.date": "Erstellungsdatum",
	"order.customer": "Kunde",
	"order.customer-template-reference": "Referenz der Kundenvorlage",
	"order.customer.article.reference": "Artikelreferenz des Kunden",
	"order.customer.order.number": "Kundenbestellnummer",
	"order.daysInStock": "Anzahl der Tage im Lager",
	"order.delivered-t": "Geliefert (t)",
	"order.delivery": "Lieferung",
	"order.delivery.address": "Lieferadresse",
	"order.delivery.mode": "Lieferweise",
	"order.dim-mm": "Dim (mm)",
	"order.easy-film-bottom": "Easyfilm Unterseite",
	"order.easy-film-top": "Easyfilm Oberseite",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "eBusiness Auftragsnummer",
	"order.end.user": "Endverbraucher",
	"order.enduser": "Endverbraucher",
	"order.entry": "Auftragseingang",
	"order.final-use": "Verwendungszweck",
	"order.firm": "Bestätigt",
	"order.first.batch.available": "Frühestes Lagereingangsdatum",
	"order.first.batch.in.stock": "Frühestes Lagereingangsdatum",
	"order.form": "Form",
	"order.grade": "Grad",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Innendurchmesser (mm)",
	"order.interpretation.delivery.date": "Interpretation des Lieferdatums",
	"order.item.reference.soldto.party": " item reference sold to ",
	"order.item.status": "Status des Auftragsartikels",
	"order.last.batch.available": "Spätestes Lagereingangsdatum",
	"order.last.batch.in.stock": "Spätestes Lagereingangsdatum",
	"order.last.updated": "Zuletzt aktualisiert",
	"order.maximum-outside-diameter": "Max. Aussendurchmesser",
	"order.mill": "Werk",
	"order.mill.order.number": "Werksnummer",
	"order.minimum-outside-diameter": "Min. Aussendurchmesser",
	"order.no-documents": "Keine Dokumente verfügbar",
	"order.oil-reference": "Ölreferenz",
	"order.oil-side": "Ölseite",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Best (t)",
	"order.order-status": "Auftragsstatus",
	"order.ordered": "Bestellt",
	"order.ordered-t": "Bestellt (t)",
	"order.orders": "Aufträge",
	"order.packing": "Verpackung",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Zielhafen",
	"order.prevision.item": "Postenvorschau mit Abruf",
	"order.protection": "Protektion",
	"order.provisional": "Vorläufig",
	"order.provisional.item": "Voraussichtlicher / fester Auftrag",
	"order.rdd": "Angefragtes Lieferdatum",
	"order.reason": "Typ",
	"order.responsible.order.manager": "Verantwortlicher Auftragsmanager",
	"order.sales.quarter": "Verkaufsquartal",
	"order.service.level": "Servicelevel",
	"order.service.request": "Serviceanfrage",
	"order.ship.to": "Warenempfänger",
	"order.sortby": "Sortieren",
	"order.spangle": "Zinkblume",
	"order.standard": "Norm",
	"order.status": "Auftragsstatus",
	"order.steelgrade": "Stahlsorte",
	"order.stock-alert": "Alarm Lagerbestand",
	"order.sub.category": "Sub Category",
	"order.submit": "Senden",
	"order.supplier": "Lieferant",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Lieferantenauftragsnummer",
	"order.surface-aspect": "Oberflächenbeschaffenheit",
	"order.thickness": "Dicke",
	"order.transport-mode": "Transportmittel",
	"order.transport.mode": "Transportmittel",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Breite",
	"order.wip": "In Produktion",
	"order.wip-t": "WIP (t)",
	"order.wip.forecast.stock": "Vorausgesagtes Lagereingangsdatum",
	"order.wip.quantity": "Menge",
	"order.woe.version": "Version WOE",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "Best.Lief.Dat.",
	"orderview.sort.order": "Auftrag",
	"orderview.sort.product": "Produkt",
	"organization-type.agency": "Agentur",
	"organization-type.buyer": "Kunde",
	"organization-type.lab": "Labor",
	"organization-type.selag": "Agence vendeur",
	"organization-type.seller": "Verkäufer",
	"organization-type.super-user": "Super User",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Derzeit verantwortlich für diese Organisation",
	"organization.card.administrator.email": "Email",
	"organization.card.administrator.name": "Name",
	"organization.card.details": "Detail",
	"organization.card.details.administrator": "Administrator",
	"organization.card.details.identity": "Identität",
	"organization.card.identity.address": "Adresse",
	"organization.card.identity.city": "Stadt",
	"organization.card.identity.country": "Land",
	"organization.card.identity.country.AD": "Andorra",
	"organization.card.identity.country.AE": "Einheit Arabischer Emir.",
	"organization.card.identity.country.AF": "Afghanistan",
	"organization.card.identity.country.AG": "Antigua/Barbuda",
	"organization.card.identity.country.AI": "Anguilla",
	"organization.card.identity.country.AL": "Albanien",
	"organization.card.identity.country.AM": "Armenien",
	"organization.card.identity.country.AN": "Niederländische Antillen",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antarktis",
	"organization.card.identity.country.AR": "Argentinien",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Österreich",
	"organization.card.identity.country.AU": "Australien",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Aserbaidschan",
	"organization.card.identity.country.BA": "Bosnien Herzeg.",
	"organization.card.identity.country.BB": "Barbados",
	"organization.card.identity.country.BD": "Bangladesch",
	"organization.card.identity.country.BE": "Belgien",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bulgarien",
	"organization.card.identity.country.BH": "Bahrain",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Benin",
	"organization.card.identity.country.BM": "Bermuda",
	"organization.card.identity.country.BN": "Brunei",
	"organization.card.identity.country.BO": "Bolivien",
	"organization.card.identity.country.BR": "Brasilien",
	"organization.card.identity.country.BS": "Bahamas",
	"organization.card.identity.country.BT": "Bhutan",
	"organization.card.identity.country.BU": "Birma",
	"organization.card.identity.country.BV": "Bouvetinsel",
	"organization.card.identity.country.BW": "Botswana",
	"organization.card.identity.country.BY": "Weißrussland",
	"organization.card.identity.country.BZ": "Belize",
	"organization.card.identity.country.CA": "Kanada",
	"organization.card.identity.country.CC": "Cocos-Inseln",
	"organization.card.identity.country.CD": "Dom. Rep. Kongo",
	"organization.card.identity.country.CF": "Zentralafrikanische Rep.",
	"organization.card.identity.country.CG": "Kongo",
	"organization.card.identity.country.CH": "Schweiz",
	"organization.card.identity.country.CI": "Elfenbeinküste",
	"organization.card.identity.country.CK": "Cook-Inseln",
	"organization.card.identity.country.CL": "Chile",
	"organization.card.identity.country.CM": "Kamerun",
	"organization.card.identity.country.CN": "China",
	"organization.card.identity.country.CO": "Kolumbien",
	"organization.card.identity.country.CR": "Costa Rica",
	"organization.card.identity.country.CS": "nicht verwenden (S/M)",
	"organization.card.identity.country.CU": "Kuba",
	"organization.card.identity.country.CV": "Kap Verdian",
	"organization.card.identity.country.CX": "Weihnachtsinsel",
	"organization.card.identity.country.CY": "Zypern",
	"organization.card.identity.country.CZ": "Tschechische Republik",
	"organization.card.identity.country.DE": "Deutschland",
	"organization.card.identity.country.DJ": "Dschibuti",
	"organization.card.identity.country.DK": "Dänemark",
	"organization.card.identity.country.DM": "Dominica",
	"organization.card.identity.country.DO": "Dominikanische Rep.",
	"organization.card.identity.country.DZ": "Algerien",
	"organization.card.identity.country.EC": "Ecuador",
	"organization.card.identity.country.EE": "Estland",
	"organization.card.identity.country.EG": "Ägypten",
	"organization.card.identity.country.EH": "Westsahara",
	"organization.card.identity.country.ER": "Eritrea",
	"organization.card.identity.country.ES": "Spanien",
	"organization.card.identity.country.ET": "Äthiopien",
	"organization.card.identity.country.FI": "Finnland",
	"organization.card.identity.country.FJ": "Fidschi",
	"organization.card.identity.country.FK": "Falklandinseln",
	"organization.card.identity.country.FM": "Mikronesien",
	"organization.card.identity.country.FO": "Färöer Inseln",
	"organization.card.identity.country.FR": "Frankreich",
	"organization.card.identity.country.GA": "Gabun",
	"organization.card.identity.country.GB": "Grossbritannien",
	"organization.card.identity.country.GD": "Grenada",
	"organization.card.identity.country.GE": "Georgien",
	"organization.card.identity.country.GF": "Französisch Guyana",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibraltar",
	"organization.card.identity.country.GL": "Grönland",
	"organization.card.identity.country.GM": "Gambia",
	"organization.card.identity.country.GN": "Guinea",
	"organization.card.identity.country.GP": "Guadeloupe",
	"organization.card.identity.country.GQ": "Äquatorial Gui.",
	"organization.card.identity.country.GR": "Griechenland",
	"organization.card.identity.country.GS": "S. Sandwich-Inseln",
	"organization.card.identity.country.GT": "Guatemala",
	"organization.card.identity.country.GU": "Guam",
	"organization.card.identity.country.GW": "Guinea-Bissau",
	"organization.card.identity.country.GY": "Guyana",
	"organization.card.identity.country.HK": "Hongkong",
	"organization.card.identity.country.HM": "Heard/McDon.Isl",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Kroatien",
	"organization.card.identity.country.HT": "Haiti",
	"organization.card.identity.country.HU": "Ungarn",
	"organization.card.identity.country.ID": "Indonesien",
	"organization.card.identity.country.IE": "Irland",
	"organization.card.identity.country.IL": "Israel",
	"organization.card.identity.country.IN": "Indien",
	"organization.card.identity.country.IO": "Brit.Ind.Oc.Ter",
	"organization.card.identity.country.IQ": "Irak",
	"organization.card.identity.country.IR": "Iran",
	"organization.card.identity.country.IS": "Island",
	"organization.card.identity.country.IT": "Italien",
	"organization.card.identity.country.JM": "Jamaika",
	"organization.card.identity.country.JO": "Jordanien",
	"organization.card.identity.country.JP": "Japan",
	"organization.card.identity.country.KE": "Kenia",
	"organization.card.identity.country.KG": "Kirgisistan",
	"organization.card.identity.country.KH": "Kambodscha",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Komoreninsel",
	"organization.card.identity.country.KN": "St.Chr.",
	"organization.card.identity.country.KP": "Nordkorea",
	"organization.card.identity.country.KR": "Südkorea",
	"organization.card.identity.country.KW": "Kuwait",
	"organization.card.identity.country.KY": "Cayman-Inseln",
	"organization.card.identity.country.KZ": "Kasachstan",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Libanon",
	"organization.card.identity.country.LC": "St. Lucia",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Liberia",
	"organization.card.identity.country.LS": "Lesotho",
	"organization.card.identity.country.LT": "Litauen",
	"organization.card.identity.country.LU": "Luxemburg",
	"organization.card.identity.country.LV": "Lettland",
	"organization.card.identity.country.LY": "Libyen",
	"organization.card.identity.country.MA": "Marokko",
	"organization.card.identity.country.MC": "Monaco",
	"organization.card.identity.country.MD": "Moldawien",
	"organization.card.identity.country.ME": "Montenegro",
	"organization.card.identity.country.MF": "Sankt Martin",
	"organization.card.identity.country.MG": "Madagaskar",
	"organization.card.identity.country.MH": "Marshall-Insel",
	"organization.card.identity.country.MK": "Nord-Mazedonien",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Myanmar",
	"organization.card.identity.country.MN": "Mongolei",
	"organization.card.identity.country.MO": "Macau",
	"organization.card.identity.country.MP": "Nord-Mariana",
	"organization.card.identity.country.MQ": "Martinique",
	"organization.card.identity.country.MR": "Mauretanien",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malta",
	"organization.card.identity.country.MU": "Mauritius",
	"organization.card.identity.country.MV": "Malediven",
	"organization.card.identity.country.MW": "Malawi",
	"organization.card.identity.country.MX": "Mexiko",
	"organization.card.identity.country.MY": "Malaysia",
	"organization.card.identity.country.MZ": "Mosambik",
	"organization.card.identity.country.NA": "Namibia",
	"organization.card.identity.country.NC": "Neukaledonien",
	"organization.card.identity.country.NE": "Niger",
	"organization.card.identity.country.NF": "Norfolkinsel",
	"organization.card.identity.country.NG": "Niger",
	"organization.card.identity.country.NI": "Nicaragua",
	"organization.card.identity.country.NL": "Niederlande",
	"organization.card.identity.country.NO": "Norwegen",
	"organization.card.identity.country.NP": "Nepal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niue",
	"organization.card.identity.country.NZ": "Neuseeland",
	"organization.card.identity.country.O1": "Sonstige NON-CORE",
	"organization.card.identity.country.O2": "Sonstige TASIA",
	"organization.card.identity.country.O3": "Sonstige TAEX",
	"organization.card.identity.country.O4": "Sonstige TANY",
	"organization.card.identity.country.OM": "Oman",
	"organization.card.identity.country.OT": "Andere Länder",
	"organization.card.identity.country.PA": "Panama",
	"organization.card.identity.country.PE": "Peru",
	"organization.card.identity.country.PF": "Französisch-Polynesien",
	"organization.card.identity.country.PG": "Papua-Neuguinea",
	"organization.card.identity.country.PH": "Philippinen",
	"organization.card.identity.country.PK": "Pakistan",
	"organization.card.identity.country.PL": "Polen",
	"organization.card.identity.country.PM": "St.Pier",
	"organization.card.identity.country.PN": "Pitcairn-Inseln",
	"organization.card.identity.country.PR": "Puerto Rico",
	"organization.card.identity.country.PS": "Paläst. Territ.",
	"organization.card.identity.country.PT": "Portugal",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paraguay",
	"organization.card.identity.country.QA": "Katar",
	"organization.card.identity.country.RE": "Reunion",
	"organization.card.identity.country.RO": "Rumänien",
	"organization.card.identity.country.RS": "Serbien",
	"organization.card.identity.country.RU": "Russische Föderation",
	"organization.card.identity.country.RW": "Ruanda",
	"organization.card.identity.country.SA": "Saudi-Arabien",
	"organization.card.identity.country.SB": "Salomonen",
	"organization.card.identity.country.SC": "Seychellen",
	"organization.card.identity.country.SD": "Sudan",
	"organization.card.identity.country.SE": "Schweden",
	"organization.card.identity.country.SG": "Singapur",
	"organization.card.identity.country.SH": "St. Helena",
	"organization.card.identity.country.SI": "Slowenien",
	"organization.card.identity.country.SJ": "Spitzbergen",
	"organization.card.identity.country.SK": "Slowakei",
	"organization.card.identity.country.SL": "Sierra Leone",
	"organization.card.identity.country.SM": "San Marino",
	"organization.card.identity.country.SN": "Senegal",
	"organization.card.identity.country.SO": "Somalia",
	"organization.card.identity.country.SR": "Surinam",
	"organization.card.identity.country.ST": "S.Tome",
	"organization.card.identity.country.STL": "Staatenlos",
	"organization.card.identity.country.SV": "El Salvador",
	"organization.card.identity.country.SY": "Syrien",
	"organization.card.identity.country.SZ": "Swasiland",
	"organization.card.identity.country.TC": "Turks&Caicos Inseln",
	"organization.card.identity.country.TD": "Tschad",
	"organization.card.identity.country.TF": "Französisch S.Territ",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Thailand",
	"organization.card.identity.country.TJ": "Tadschikistan",
	"organization.card.identity.country.TK": "Tokelau-Inseln",
	"organization.card.identity.country.TL": "Timor-Leste",
	"organization.card.identity.country.TM": "Turkmenistan",
	"organization.card.identity.country.TN": "Tunesien",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "Osttimor",
	"organization.card.identity.country.TR": "Türkei",
	"organization.card.identity.country.TT": "Trinidad",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Taiwan",
	"organization.card.identity.country.TZ": "Tansania",
	"organization.card.identity.country.UA": "Ukraine",
	"organization.card.identity.country.UG": "Uganda",
	"organization.card.identity.country.UM": "Geringfügige Outl.Ins.",
	"organization.card.identity.country.US": "USA",
	"organization.card.identity.country.UY": "Uruguay",
	"organization.card.identity.country.UZ": "Usbekistan",
	"organization.card.identity.country.VA": "Vatikanstadt",
	"organization.card.identity.country.VC": "St. Vincent",
	"organization.card.identity.country.VE": "Venezuela",
	"organization.card.identity.country.VG": "Britische Jungferninseln",
	"organization.card.identity.country.VI": "US Jungferninseln",
	"organization.card.identity.country.VN": "Vietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Samoa Inseln",
	"organization.card.identity.country.XK": "Kosovo",
	"organization.card.identity.country.YE": "Jemen",
	"organization.card.identity.country.YT": "Mayotte",
	"organization.card.identity.country.YU": "Jugoslawien",
	"organization.card.identity.country.ZA": "Südafrika",
	"organization.card.identity.country.ZM": "Sambia",
	"organization.card.identity.country.ZR": "Zaire",
	"organization.card.identity.country.ZW": "Simbabwe",
	"organization.card.identity.name": "Name",
	"organization.card.identity.postCode": "Postleitzahl",
	"organization.card.identity.state": "Bundesland",
	"organization.card.identity.suppliers": "Lieferant",
	"organization.card.identity.vat": "Steuernummer",
	"organization.card.manage-transactional-visibilities": "Verwalten von Sichtbarkeiten von Transaktionen",
	"organization.card.organizationcard": "Organisations Karte",
	"organization.card.services": "Services",
	"organization.card.services.no-data": "Sie haben keine Services zur Verfügung",
	"organization.card.services.tab.desc": "Beschreibung",
	"organization.card.services.tab.name": "Name",
	"organization.card.services.title": "Service-Liste",
	"organization.card.services.title.desc": "Liste aller für diese Organisation verfügbaren Services im entsprechenden Anbieterkontext",
	"organization.card.transactional-visibilities": "Sichtbarkeiten von Transaktionen",
	"organization.card.users": "Benutzer/in",
	"organization.card.visibilities": "Sichtbarkeiten",
	"organization.details-card.flow-chart": "Flow chart",
	"organization.details-card.flow-chart.current-organization": "Aktuelle Organisation",
	"organization.details-card.flow-chart.customer": "Kunde/in",
	"organization.details-card.flow-chart.desc": "Ort dieser Organisation in der Landschaftsraum",
	"organization.details-card.flow-chart.supplier": "Lieferant",
	"organization.is-payer": "istZahler",
	"organization.is-shipto": "istLieferung an",
	"organization.is-soldto": "istVerkauft an",
	"organization.status.deactivated": "Deaktiviert",
	"organization.status.deleted": "Gelöscht",
	"organization.user-accept": "Akzeptieren",
	"organization.user-id": "ID",
	"organization.user-manage": "Verwalten",
	"organization.user-reject": "Ablehnen",
	"organization.user-status-in-organization": "Status in der Organisation",
	"organization.users.list.desc": "Liste aller verfügbaren Benutzer in dieser Organisation",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Administrator",
	"organizationrole.hlpdk": "HelpDesk",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "Benutzer/in",
	"overview.survey-answer": "Ich antworte",
	"overview.survey-no-answer": "Nein, danke",
	"overview.survey.please": "Bitte",
	"overview.survey.questions": "beantworten Sie diese 3 Fragen nach Ihrer Navigation (geschätzte Zeit 20 Sekunden)",
	"overview.viewby": "Sortieren nach",
	"product.added.to.cart": "das/die Produkt(e) wurde(n) ordnungsgemäß in den Warenkorb gelegt",
	"product.card.new.specification": "Neue Spezifikation",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "Ok",
	"product.feasibility.pending": "Ausstehende",
	"product.feasibility.refused": "Abgelehnt",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "Produkt kann nicht gespeichert werden",
	"product.message.template.product.not.saved": "Nicht möglich das Produkt zu erstellen",
	"product.most.used.values": "Die am häufigsten benutzten Werte",
	"product.no.original.value": "Kein ursprünglicher Wert",
	"product.not.exist": "Dieses Produkt existiert nicht",
	"product.original.value": "Ursprünglicher Wert",
	"product.other.values": "Andere Werte",
	"product.pc.label.max": "Max",
	"product.pc.label.min": "Min",
	"product.pc.label.unit": "Einheit",
	"product.product.submitted": "Produkt gesendet",
	"product.quality.dashboard": "Dashboard zur Produktqualität",
	"product.save.template.product": "Als neue Spezifikation speichern",
	"product.save.template.product.and.add.to.cart": "Speichern und zum Einkaufswagen hinzufügen",
	"product.table.header.add": "Hinzufügen",
	"product.table.header.view": "Ansehen",
	"product.template": "Produktvorlage",
	"product.template.isbeingsimulated": "Die neue Spezifikation wird geprüft…",
	"product.title.group.certificate": "Werkszeugnis",
	"product.title.group.coating": "Beschichtung",
	"product.title.group.dimensions": "Abmessungen",
	"product.title.group.insulationResistanceTest": "Isolationswiderstandsprüfung",
	"product.title.group.labelling": "Kennzeichnung",
	"product.title.group.management": "Management",
	"product.title.group.packing": "Verpackung",
	"product.title.group.productionProcess": "Produktionsprozess",
	"product.title.group.specifications": "Spezifikationen",
	"product.title.group.stamping": "Stempel",
	"product.title.group.surface": "Oberfläche",
	"product.title.group.surfaceTreatment": "Oberflächenbehandlung",
	"product.title.group.use": "Nutzung",
	"product.title.group.weightDiameter": "Gewicht / Durchmesser",
	"product.title.group.welds": "Schweißnähte",
	"product.title.section.bottom": "Unterseite",
	"product.title.section.bundleHeight": "Bündelhöhe",
	"product.title.section.bundleWeight": "Bündelgewicht",
	"product.title.section.coilWeight": "Coilgewicht",
	"product.title.section.customerArticle": "Kundenartikel",
	"product.title.section.diameter": "Diameter",
	"product.title.section.edge": "Kante",
	"product.title.section.insideDiameter": "Innendurchmesser",
	"product.title.section.numberSheetsPerBundle": "Anzahl der Bleche pro Bündel",
	"product.title.section.numberSlitCoilsPerPackage": "Anzahle der Spaltcoils pro Bündel",
	"product.title.section.outsideDiameter": "Aussendurchmesser",
	"product.title.section.packageHeight": "Pakethöhe",
	"product.title.section.packageHeightWithPalet": "Pakethöhe, Palette eingeschlossen",
	"product.title.section.packageWeight": "Pakethöhe (mehr als ein Coil pro Paket)",
	"product.title.section.removableProtectiveFilm": "Entfernbare Schutzfolie",
	"product.title.section.slabWeightInTon": "Brammengewicht in Tonnen",
	"product.title.section.specificWeight": "Bestimmtes Gewicht",
	"product.title.section.thickness": "Dicke",
	"product.title.section.top": "Oberseite",
	"product.title.section.weight": "Gewicht",
	"product.title.section.width": "Breite",
	"profile.no.access": "Bitte stellen Sie sicher, dass Sie über einen Internetzugang verfügen und melden Sie sich in der Applikation an, um das Profil anzuzeigen.",
	"profile.select": "Profil - Wählen",
	"profile.select.visibility": "Wählen Sie eine Firma/Präsenz aus",
	"profile.visibility.all": "Alle",
	"progress.message": "Ihre Transaktion ist in Bearbeitung",
	"progress.message.fastlane": "Ihre Transaktion ist noch nicht abgeschlossen",
	"promote.user.message": "Zu bewerbender Benutzer:",
	"prototype-card": "Prototyp-Karte",
	"prototype-card-details.proposed-price": "Vorgeschlagener Preis",
	"prototype-card-details.proposed-price.na": "K.A.",
	"prototype-card.data-not-found": "Der Prototyp existiert nicht",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Vorschlag",
	"prototype.card.proposal.deliveries": "Vorgeschlagene Lieferungen",
	"prototype.card.proposal.product.information": "Vorgeschlagenes Produkt",
	"prototype.card.proposed.quantities": "Vorgeschlagene Menge",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Angeforderte Lieferungen",
	"prototype.card.request.information": "Angefordertes Produkt",
	"prototype.card.request.quantities": "Angeforderte Menge",
	"prototype.card.sheetweight": "Gewicht eines Blattes",
	"prototype.card.status.accepted": "Angenommen",
	"prototype.card.status.materialnotfound": "Material nicht verfüGBar",
	"prototype.card.status.notavailable": "Not available",
	"prototype.card.status.refusedbycustomer": "Vom Kunden abgelehnt",
	"prototype.card.status.requested": "Gefordert",
	"prototype.production-po-reception-date": "Datum des PO-Eingangs",
	"prototype.production.po-delivery": "Lieferung",
	"prototype.production.po.order": "Bestellung",
	"prototype.status.accepted": "Akzeptiert",
	"prototype.status.closed": "Closed",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Entscheidung",
	"prototype.status.proposal": "Vorschlag",
	"prototype.status.refused": "Abgelehnt",
	"prototype.tracker.status": "Status des Prototyps",
	"qty-by-family.title.note": "Bitte geben Sie die Mengen für die entsprechenden Zeiträume für diese Familie an",
	"quality.feedback.card.closed.issues": "Geschlossene Themen",
	"quality.feedback.card.closed.paid": "Bezahlt",
	"quality.feedback.card.closed.rejected": "Abgelehnt",
	"quality.feedback.card.details": "Details anzeigen",
	"quality.feedback.card.open.issues": "Offene Themen",
	"quality.feedback.card.subtitle": "Details zu abgeschlossenen Forderungen",
	"quality.feedback.card.title": "Feedback zur Qualität",
	"quality.first.selected.batch": "Ihre gelieferten oder zum Versand bereitgestellten Chargen für die Bestellung",
	"quality.guarantee.request": "Garantieanfrage",
	"quality.information": "Informationen zur Qualität",
	"quality.issue.save.failed": "Übermittlung des Qualitätsproblems fehlgeschlagen.",
	"quality.issues.draft.edit": "Sie können die Änderungen in Ihrem Entwurf nachträglich vornehmen.",
	"quality.issues.draft.saved.successfully": "Ihr Entwurf wurde gespeichert",
	"quality.issues.followup": "Sie können sie in der Nachverfolgung unter Meine Qualitätsprobleme einsehen.",
	"quality.issues.save.failed.message": "Bitte versuchen Sie es später noch einmal oder kontaktieren Sie ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "Ihr Qualitätsproblem wurde erfolgreich übermittelt.",
	"quality.max.selected.batch": "Ausgewählte Chargen (maximal 6 Chargen)",
	"quapp.action.add.attach": "Einen Anhang hinzufügen",
	"quapp.action.add.attach.progress": "In Bearbeitung",
	"quapp.action.cancel": "Qualitätsproblem löschen",
	"quapp.action.change": "Ändern",
	"quapp.action.delete": "Löschen",
	"quapp.action.edit": "Bearbeiten",
	"quapp.action.go.back": "Zurück",
	"quapp.action.save": "Speichern",
	"quapp.action.select.file": "Wählen Sie Ihre Datei aus",
	"quapp.action.send": "Abschicken",
	"quapp.action.view": "Ansehen",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Kunde",
	"quapp.alert": "Alarm",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "Datei (PDF, Excel, ...)",
	"quapp.attach.picture": "Bild",
	"quapp.attach.record.sound": "Eine Audio aufnehmen",
	"quapp.attach.record.video": "Ein Video aufnehmen",
	"quapp.attach.take.picture": "Ein Bild aufnehmen",
	"quapp.attach.video": "Video",
	"quapp.detector": "Detektor",
	"quapp.error": "Fehler",
	"quapp.loading": "Wird geladen",
	"quapp.logout.warning1": "Achtung!",
	"quapp.logout.warning2": "Wenn Sie sich aus der Applikation austragen, verlieren Sie alle nicht synchronisierten Themen!",
	"quapp.logout.warning3": "Sie haben derzeit {{value}} nicht synchronisierte Aktion(en).",
	"quapp.logout.warning4": "Möchten Sie sich wirklich abmelden?",
	"quapp.notif.claim.cancelled": "{{value}} wurde storniert",
	"quapp.notif.claim.comment": "Kommentar: {{comment}}",
	"quapp.notif.claim.paid": "{{value}} wurde bezahlt ({{amount}} {{currency}}, {{quantity}} {{unit}})",
	"quapp.notif.claim.refused": "{{value}} wurde abgelehnt",
	"quapp.notif.claim.warning": "{{value}} wurde als Warnung registriert",
	"quapp.notif.label": "Forderung aktualisiert:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Mitteilung",
	"quapp.page.not.found": "Seite nicht gefunden",
	"quapp.process.closed": "Angenommen oder abgelehnt",
	"quapp.process.closed.paid": "Bezahlt",
	"quapp.process.closed.refused": "Abgelehnt",
	"quapp.process.closed.warning": "Als Warnung registriert",
	"quapp.process.create": "Warten auf Verbindung",
	"quapp.process.inprogress": "Wird von ArcelorMittal bearbeitet",
	"quapp.process.push": "An ArcelorMittal übertragen",
	"quapp.process.push-cancel": "Stornierung an ArcelorMittal übertragen",
	"quapp.process.push-update": "Änderung an ArcelorMittal übertragen",
	"quapp.process.registered": "Bei ArcelorMittal registriert",
	"quapp.reader": "Lesegerät",
	"quapp.validator": "Prüfer",
	"quapp.warning": "Warnung",
	"readonly.user.error": "Sie dürfen im Simulationsmodus keine Aktionen durchführen, Sie können nur die Kundenansicht einsehen.",
	"remove.notification": "Benachrichtigung entfernen",
	"remove.unrecognized.batch": "wird nicht als Charge erkannt. Bitte wählen Sie eine gültige Charge aus.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Informationen über den Antrag",
	"reset.order": "Zurücksetzen Ihrer Bestellung",
	"reset.order.confirmation": "Möchten Sie dennoch fortfahren?",
	"reset.order.warning.add.product.another.family": "Achtung: Sie haben bereits ein oder mehrere Produkte aus einer anderen Familie in Ihrem Warenkorb. Wenn Sie dieses Produkt hinzufügen, wird der aktuelle Warenkorb (alle ausgewählten Produkte) zurückgesetzt.",
	"reset.order.warning.customer.change": "Achtung: Wenn Sie den Kunden einer Bestellung ändern, wird der aktuelle Warenkorb (alle ausgewählten Produkte) zurückgesetzt.",
	"saBusinessStatus.closed": "Abgeschlossen",
	"saBusinessStatus.high.risk.external": "High Risk External",
	"saBusinessStatus.high.risk.internal": "High Risk Internal",
	"saBusinessStatus.high.runner": "High runner",
	"saBusinessStatus.low.runner": "Low runner",
	"saBusinessStatus.on.hold": "In Warteschleife",
	"saBusinessStatus.running": "Laufend",
	"saBusinessStatus.running.out": "Auslaufend",
	"saBusinessStatus.start.up": "Aufstart",
	"sb.Cancel": "Abbrechen",
	"sb.Download": "Download",
	"sb.choose.options": "Optionen auswählen",
	"sb.detailed.report": "Detaillierter Bericht",
	"sb.period": "Periode",
	"sb.type": "Typ",
	"scan.barcode": "Strichcode",
	"scan.batch.choose": "Dieses Coil auswählen",
	"scan.browser.title": "Coilerkennung",
	"scan.customer": "Kunde",
	"scan.dimensions": "Abmessungen",
	"scan.get.closer": "Gehen Sie näher an die Etiketten heran",
	"scan.go-batch-card": "Zu Materialkarte gehen",
	"scan.invoiced": "Fakturiert",
	"scan.looking.batch.data": "Chargendaten suchen...",
	"scan.looking.multi.batch.data": "Suche nach verwandten Chargen",
	"scan.material-scan": "Material-Scan",
	"scan.mill.order": "Werksnummer",
	"scan.quantity": "Anzahl",
	"scan.quantity.optional": "Anzahl (optional)",
	"scan.quantity.placeholder": "Art der Liefermenge",
	"scan.select.batch": "Wählen Sie Ihre Charge",
	"scan.serial.number": "Seriennummer",
	"scan.serial.number.placeholder": "Typ-Seriennummer",
	"scan.supplier.order": "Lieferauftrag",
	"scan.tip.disable-tips": "Tipps ausschalten",
	"scan.tip.message": "Sie können den Barcode nicht scannen? Schauen Sie in den Einstellungen nach (Schaltfläche oben rechts), ob der richtige Scan-Modus für Ihren Barcode eingestellt ist.",
	"scan.tip.ok": "Ok",
	"scan.tip.title": "Tipp",
	"scan.title": "Scannen Sie die Etiketten",
	"scan.weight": "Gewicht",
	"schedule-business-order-card.commercial-documents": "Kommerzielle Dokumente",
	"schedule-business-order-filter.customer-article-reference": "Kundenartikelreferenz",
	"schedule-business-order-filter.thickness": "Dicke (mm)",
	"schedule-business-order-filter.width": "Breite (mm)",
	"schedule-business-order.SA-unit": "SA-Einheit",
	"schedule-business-order.card": "SA-Bestellkarte",
	"schedule-business-order.cem-partner": "CEM-Partner",
	"schedule-business-order.certificate": "Werkszeugnis",
	"schedule-business-order.choice": "Wahl",
	"schedule-business-order.country-of-scf": "Land des SCF",
	"schedule-business-order.customer-expected-cumul": "Erwartete Kumulierung des Kunden",
	"schedule-business-order.customer-realized-cumul": "Realisierte Kumulierung des Kunden",
	"schedule-business-order.customer.article.reference": "Artikelreferenz des Kunden",
	"schedule-business-order.customer.order.number": "Kundenbestellnummer",
	"schedule-business-order.delivery": "Lieferung",
	"schedule-business-order.delivery.address": "Lieferadresse",
	"schedule-business-order.delivery.mode": "Lieferweise",
	"schedule-business-order.final-use": "Verwendungszweck",
	"schedule-business-order.form": "Form",
	"schedule-business-order.icon": "Symbol",
	"schedule-business-order.in-transit-stock": "Durchlaufender Bestand",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Innendurchmesser (mm)",
	"schedule-business-order.interpretation-delivery-date": "Interpretation Liefertermin",
	"schedule-business-order.lead-delay": "Vorlauf/Verzögerung",
	"schedule-business-order.needs": "Benötigt",
	"schedule-business-order.oil-reference": "Ölreferenz",
	"schedule-business-order.order-follow-up-schedule": "Zeitplan für die Auftragsverfolgung",
	"schedule-business-order.order-reason": "Grund der Bestellung",
	"schedule-business-order.packing": "Verpackung",
	"schedule-business-order.pds-instruction": "PDS-Anweisung",
	"schedule-business-order.plant-stock": "Werksbestand",
	"schedule-business-order.product": "Informationen zum Produkt",
	"schedule-business-order.product.category": "Produktkategorie",
	"schedule-business-order.protection": "Protektion",
	"schedule-business-order.realized-cumul": "Realisierte Kumulierung",
	"schedule-business-order.reference-of-alignment": "Referenz des Abgleichs",
	"schedule-business-order.sa-business-status": "SA-Geschäftsstatus",
	"schedule-business-order.sfc-country": "SFC-Land",
	"schedule-business-order.shortdescription": "Kurzbeschreibung",
	"schedule-business-order.situation-overview": "Überblick über die Situation",
	"schedule-business-order.standard": "Norm",
	"schedule-business-order.standard.steelgrade": "Stahlsorte",
	"schedule-business-order.stock": "Bestand",
	"schedule-business-order.stock-blocked": "Gesperrter Bestand",
	"schedule-business-order.stock-partner": "Partner im Bestand",
	"schedule-business-order.supplier.order.number": "Lieferantenauftragsnummer",
	"schedule-business-order.surface-aspect": "Oberflächenbeschaffenheit",
	"schedule-business-order.time-of-alignment": "Zeitpunkt des Abgleichs",
	"schedule-business-order.transport-mode": "Transportmittel",
	"schedule-business-order.wip": "WIP",
	"search.batches": "Material",
	"search.by": "suche nach",
	"search.certificates": "Werkszeugnisse",
	"search.claim": "Reklamationen",
	"search.count.batches": "{{value}} Coils",
	"search.count.closed": "{{value}} Geschlossene Qualitätsprobleme",
	"search.count.drafts": "{{value}} Vorlagen",
	"search.count.orders": "Aufträge",
	"search.count.pending": "{{value}} Offene Qualitätsprobleme",
	"search.dispatch.advices": "Lieferscheine",
	"search.display": "Anzeige",
	"search.guarantees": "Garantien",
	"search.invoices": "Fakturiert",
	"search.order.acknowledgments": "Auftragsbestätigung",
	"search.placeholder": "Suchen…",
	"search.see.result": "Siehe Ergebnis",
	"search.see.results": "Siehe {{value}} Ergebnisse",
	"search.shipment": "Versand / Lieferung",
	"search.shipments": "Versand",
	"section.filters": "Filter",
	"see.all.batches": "See all batches",
	"see.all.documents": "See all documents",
	"select.auction.title": "Wählen Sie Ihre Auktion",
	"select.new.administrator": "Wenn Sie diesen Benutzer entfernen, müssen Sie einen neuen Administrator für diese Organisation auswählen:",
	"select.product.spec": "Ihren Produktkatalog filtern",
	"sent.closed.no.issue": "Keine geschlossenen Themen",
	"sent.hide.process": "Vorgang verbergen",
	"sent.issue": "Reklamationsübersicht",
	"sent.pending.no.issue": "Keine offenen Themen",
	"sent.search.issues": "Thema suchen",
	"sent.show.process": "Vorgang anzeigen",
	"sent.since": "Seit {{value}}",
	"sent.status": "STATUS",
	"service.parameters.value": "Wert",
	"services.Back": "ZURÜCK ZUM HINZUFÜGEN EINES SERVICES",
	"services.management": "Verwaltung der Services",
	"services.settings": "Einstellungen",
	"settings.account": "Mein Konto",
	"settings.actions": "Aktionen",
	"settings.activity": "Aktivität",
	"settings.activity-desc": "Letzte Aktivität",
	"settings.add-all-services": "Alle Services hinzufügen",
	"settings.all-services-added": "Dem Nutzer wurden alle Services hinzugefügt",
	"settings.any": "Beliebig",
	"settings.boolean.off": "Aus",
	"settings.boolean.on": "An",
	"settings.business-id": "Business-ID",
	"settings.change-simulated-user": "Simulierten Benutzer wechseln",
	"settings.city": "Stadt",
	"settings.company": "Unternehmen",
	"settings.date-format-dd/mm/yyyy": "tt/mm/jjjj",
	"settings.date-format-mm/dd/yyyy": "mm/tt/jjjj",
	"settings.delegation.changement": "Ändern Sie meine delegierte Organisation",
	"settings.download.aggregated": "Aggregiert",
	"settings.download.duplicate": "Duplikat",
	"settings.drag-drop-services-here": "Ziehen Sie die Dienste, die Sie hinzufügen möchten, per Drag & Drop hierher",
	"settings.drag-services-here": "Ziehen Sie Dienste hierher, um sie vom Benutzer zu entfernen",
	"settings.email": "Email",
	"settings.faq": "FAQ",
	"settings.firstname": "Vorname",
	"settings.gender": "Frau / Herr",
	"settings.general": "Allgemeine Einstellungen",
	"settings.general.date-format": "Datumsformat",
	"settings.general.helper": "Einstellungen für mobile Anwendungen und Webpart",
	"settings.general.time-format": "Zeitformat",
	"settings.generalSalesCondition": "Allgemeine Verkaufsbedingungen",
	"settings.identity": "Identität",
	"settings.identity.desc": "Persönliche Daten des Benutzers ",
	"settings.informational-visibilities": "Informationelle Sichtbarkeiten",
	"settings.last-connection-date": "Letztes Verbindungsdatum",
	"settings.lastname": "Nachname",
	"settings.legal-information": "Gesetzliche Angaben",
	"settings.legal-information.property": "Die SteelUser App ist Eigentum von ArcelorMittal FCE SA, 24-26 Boulevard d'Avranches, L-1160 Luxemburg, Luxemburg.",
	"settings.legal-information.questions": "Bitte senden Sie alle Fragen oder Kommentare zu dieser App an unser eService Team",
	"settings.legal-information.require-registration": "Sie müssen registriert sein, um die App benutzen zu können.",
	"settings.login": "Einloggen",
	"settings.logout": "Logout",
	"settings.manage-info-visibilities": "Informationelle Sichtbarkeiten verwalten",
	"settings.manage-services": "Services verwalten",
	"settings.name": "Name",
	"settings.order.customer": "Kundenbestellnummer",
	"settings.order.number": "Auftragsnummer",
	"settings.order.supplier": "Lieferantenauftragsnummer",
	"settings.order.tracking": "Auftragsverfolgung",
	"settings.ordertracking.sorting.list": "Standardsortierung der Liste",
	"settings.organisation": "Organisation",
	"settings.organizations": "Organisation",
	"settings.organizations.desc": "Mitgliedschaft des Benutzers in einer Organisation",
	"settings.organizations.name": "Name",
	"settings.organizations.role": "Rolle",
	"settings.organizations.visibilities.address": "Anschrift",
	"settings.organizations.visibilities.name": "Name / Stadt",
	"settings.other": "Andere Einstellungen",
	"settings.password-doesn't-match-rules": "Das Passwort entspricht nicht den folgenden Regeln",
	"settings.password-updated-successfully": "Das Passwort wurde erfolgreich aktualisiert",
	"settings.phone": "Handy",
	"settings.phone-number": "Telefonnummer",
	"settings.privacy-policy": "Datenschutzrichtlinie",
	"settings.privacypolicy.ContactUs": "Möchten Sie Kontakt zu uns aufnehmen?",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxemburg, Luxemburg",
	"settings.privacypolicy.ContactUsByEmail": "oder per E-Mail an",
	"settings.privacypolicy.ContactUsPlease": "Mit Fragen oder Kommentaren zu dieser Datenschutzrichtlinie wenden Sie sich bitte an:",
	"settings.privacypolicy.GeneralInformation": "Allgemeine Informationen",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser ist Eigentum von ArcelorMittal France. ArcelorMittal France, ein französisches Unternehmen, eingetragen im Handels- und Gesellschaftsregister von Bobigny unter der Nr. 562 094 425, mit Hauptsitz im Gebäude Le Cézanne, 6, rue André Campra, F-93200 Saint-Denis, Frankreich, hostet die Website SteelUser.com, koordiniert die Wartung der Website und ist für die Integrationsfunktionen zuständig. Durch Registrierung als Mitglied von SteelUser erlangen Sie die Möglichkeit, im Internet in voller Sicherheit und Vertraulichkeit Transaktionen (Kauf, Online-Bestellverfolgung, Zugang zu Verkaufsunterlagen usw.) durchzuführen.",
	"settings.privacypolicy.GeneralInformationWebservices": "Die SteelUser-Plattform bietet den Kunden von ArcelorMittal moderne Web-Dienstleistungen wie Online-Bestellverfolgung, Abruf von Geschäftsdokumenten, Auktionen von nicht hochwertigen Materialien, Online-Bestellaufgabe und Beratung zu technischen Daten an. Sie vereinfacht und beschleunigt die Beziehungen zwischen den Stahleinkäufern und ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "Die Hyperlinks auf der SteelUser-Plattform zu anderen bestehenden Ressourcen im Internet, insbesondere zu den Partnern, wurden zuvor ausdrücklich und schriftlich genehmigt. Benutzer von SteelUser können ohne die ausdrückliche, vorherige Genehmigung von ArcelorMittal einen Hyperlink setzen, der auf diese Website verweist.",
	"settings.privacypolicy.PersonalInformation": "Persönliche Informationen, die Sie übermitteln möchten",
	"settings.privacypolicy.PersonalInformationContent": "Zweck der SteelUser-Plattform ist es, Geschäftsprozesse bei ArcelorMittal zu unterstützen, nämlich Bestellmanagement, Verfolgung von Streitfällen, Auktionen und Freigabe von kommerzieller und technischer Dokumente über ArcelorMittal-Produkte. Zu diesen geschäftlichen Funktionen gehört die Verwaltung von Aktionen der Benutzer als Vertreter der Kunden von ArcelorMittal. Daher fordert das SteelUser-Registrierungsformular Sie auf, uns Ihre Referenzdaten mitzuteilen (Kundenname, Nachname & Vorname, Kontaktdaten und Funktion). Wenn Sie für eine bestimmte Aktivität diese Pflichtangaben nicht machen, ist Ihnen diese Aktivität nicht möglich.",
	"settings.privacypolicy.PrivacyPolicy": "Datenschutzrichtlinie",
	"settings.privacypolicy.PrivacyPolicyContent": "Der Schutz Ihrer Privatsphäre und Ihrer persönlichen Daten ist uns wichtig. ArcelorMittal hat ein Datenschutzverfahren („Verbindliche Firmenregeln“) eingeführt. Dieses Verfahren bietet eine globale und vereinfachte rechtliche Grundlage für alle Datenbanken und Anwendungen, die personenbezogene Daten innerhalb der Firmengruppe gemeinsam nutzen oder weitergeben. Das ArcelorMittal-Datenschutzverfahren ist ein auf Firmengruppenebene gültiges Verfahren, das einen Mindeststandard für den Schutz personenbezogener Daten gewährleistet, die auf globaler Ebene ausgetauscht werden. Es gewährleistet einen ähnlichen Schutz wie den, der durch die EU-Vorschriften geboten wird. Das Datenschutzverfahren von ArcelorMittal  („Verbindliche Firmenregeln“) wird zusammen mit den wichtigsten Richtlinien veröffentlicht auf",
	"settings.privacypolicy.Property": "Geistiges und gewerbliches Eigentum",
	"settings.privacypolicy.PropertyContent": "Der Inhalt der SteelUser-Plattform (einschließlich, aber nicht ausschließlich Text, grafische Bilder, Audio-/Videodateien, HTML-Code, Schaltflächen, Marken, Software, Embleme) ist Eigentum von ArcelorMittal, sofern nichts anders angegeben ist. Die Rechte Dritter werden dabei respektiert. Der Inhalt darf ohne die vorherige schriftliche Zustimmung von ArcelorMittal nicht kommerziell verwertet, verbreitet, übermittelt, kopiert oder in irgendeiner Weise verändert werden. Die unbefugte Nutzung der Inhalte der SteelUser-Plattform ist streng untersagt. Eine solche Nutzung stellt eine Rechtsverletzung, einschließlich einer Verletzung geistigen Eigentums, von Handels- und Geschäftsnamen oder jeder anderen Art von Rechten an gewerblichem Eigentum dar. Die Benutzer können auf einem PC ausschließlich für den persönlichen und privaten Gebrauch eine Kopie dieser Seite herunterladen, sich anzeigen lassen oder ausdrucken.",
	"settings.privacypolicy.Protection": "Schutz personenbezogener Daten",
	"settings.privacypolicy.Protection2years": "Bleibt ein Benutzer 2 Jahre lang inaktiv, so wird der SteelUser-Zugang automatisch gelöscht. Personenbezogene Daten, die nicht mehr zur Erfüllung der genannten Zwecke benötigt werden, werden vernichtet, gelöscht oder anonymisiert. ArcelorMittal hat zur Regelung der Vernichtung personenbezogener Daten Richtlinien entwickelt und Verfahren eingerichtet.",
	"settings.privacypolicy.ProtectionAbuse": "Benutzer haben sich im Hinblick auf personenbezogene Daten, auf die sie in einer Datenbank zugreifen können, jeglichen Missbrauchs und aller Handlungen zu enthalten, die das Privatleben oder den Ruf der Personen beeinträchtigen könnten.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal teilt allen Benutzern mit, dass ihre personenbezogenen Daten nicht an Dritte weitergegeben werden. Falls erforderlich, wird eine Genehmigung eingeholt, in der die Gründe und Aktivitäten erläutert werden, für die die Informationen einmal verwendet werden sollen, sofern die Genehmigung erteilt wird. Ihre Daten werden absolut vertraulich behandelt. Falls es aus irgendeinem Grund gewünscht wird oder erforderlich ist, kann der Benutzer seine Einwilligung in die Verarbeitung und Abtretung seiner Daten widerrufen, indem er sich an die am Ende dieses Abschnitts angegebene Adresse wendet. Wenn Informationen angefordert werden, so erklärt sich der Benutzer damit einverstanden, dass (i) ArcelorMittal seine Informationen innerhalb der Unternehmensgruppe weitergeben kann (die Unternehmen sind auf der Webseite www.arcelormittal.com genannt) und (ii) es ArcelorMittal gestattet ist, diese Daten in Zukunft zu verwenden, um den Benutzer über Fragen oder Angelegenheiten zu informieren, die für ihn im Hinblick auf ArcelorMittal und dessen Produkte von Interesse sind.",
	"settings.privacypolicy.ProtectionResponsible": "Falls wir dem Benutzer ein Passwort zugewiesen haben (oder er eines gewählt hat), das ihm den Zugang zu bestimmten Teilen der SteelUser-Website ermöglicht, ist der Benutzer dafür verantwortlich, dieses Passwort vertraulich zu behandeln. Wir fordern den Benutzer auf, ein Passwort nicht an Dritte weiterzugeben. Der Benutzer verpflichtet sich, (a) uns unverzüglich über jede unbefugte Nutzung seines Passworts oder seines Kontos oder jede andere Sicherheitsverletzung zu unterrichten und (b) sich zu vergewissern, dass der Benutzer Ihr Konto am Ende jeder Sitzung verlässt. Es obliegt dem Benutzer, die Verbreitung und Nutzung seines Passworts sowie den Zugang zu seinem Konto und dessen Nutzung zu kontrollieren und uns zu benachrichtigen, wenn der Benutzer sein Konto auf dieser Website kündigen möchte. Wir sind nicht verantwortlich oder haftbar für Verluste oder Schäden, die sich aus der Nichteinhaltung dieser Bestimmung ergeben.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal tut sein Möglichstes, um seine Verpflichtung zur Geheimhaltung personenbezogener Daten zu erfüllen. Das Unternehmen ist verpflichtet, diese vertraulich zu behandeln und die notwendigen technischen und organisatorischen Sicherheitsmaßnahmen zu treffen, um unbefugte Datenveränderungen, -verluste oder -zugriffe zu verhindern.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal richtet die SteelUser-Plattform ein, um den Benutzern verfügbare, überprüfte Daten und/oder Tools zu Verfügung zu stellen; ArcelorMittal ist aber nicht verantwortlich für Fehler oder mangelnde Verfügbarkeit von Daten und/oder das Auftreten eines Virus auf SteelUser.",
	"settings.privacypolicy.UseCookiesInstalled": "Mit dem Besuch von SteelUser erklärt sich der Benutzer damit einverstanden, dass in seiner Browsersoftware Cookies installiert werden können. Die Cookies ermöglichen es, Informationen zu speichern, die für die Navigation des Benutzers auf der Website wichtig sind. Sie werden von SteelUser ausschließlich dazu verwendet, das ordnungsgemäße Funktionieren der privaten Bereiche der Website zu gewährleisten.",
	"settings.privacypolicy.UseCookiesNavigation": "Über die Einstellungen der Navigationssoftware kann der Benutzer die Existenz der Cookies erkennen und sie, wenn er es wünscht, auf die folgende Weise ablehnen:",
	"settings.privacypolicy.UseCookiesRefusing": "Der Benutzer wird jedoch darauf hingewiesen, dass die Ablehnung von Cookies ihm den Zugang zu den privaten Bereichen der Website unmöglich macht, und dass er dann insbesondere keine Online-Transaktionen mehr durchführen kann.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Einige Benutzer übernehmen die Rolle des Administrators und verwalten die Mitgliederprofile für ihr Unternehmen. Administratoren müssen diese Benutzer über deren Recht informieren, auf die sie betreffenden Profile zuzugreifen, diese zu ändern und zu löschen. Jeder SteelUser-Benutzer hat das Recht, seine personenbezogenen Daten einzusehen und zu berichtigen. Er kann dieses Recht ausüben, indem er sich schriftlich an folgende Adresse wendet: Arcelormital FCE SA, 24-26 boulevard D'avranches L-1160 Luxemburg, Luxemburg, oder per E-Mail an",
	"settings.privacypolicy.UseDataProvidedResponses": "Der Benutzer wird darauf hingewiesen, dass die in SteelUser eingegebenen Angaben, insbesondere diejenigen, die für den Zugang zu den privaten Bereichen der genannten Website als Mitglied erforderlich sind, von ArcelorMittal verwendet und an die für die Prüfung und Bearbeitung von Transaktionen zuständigen Dienstleister weitergeleitet werden können.",
	"settings.privacypolicy.UseGoogleAnalytics": "Benutzung von Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "Google-Analytics-Cookies werden verwendet, um Informationen über die Art und Weise zu sammeln, in der Besucher unsere Website nutzen. Wir verwenden diese Informationen, um Berichte zu erstellen. Sie sollen uns helfen, die Website zu verbessern.  Die Cookies sammeln Informationen in anonymisierter Form, darunter solche über die Anzahl der Besucher auf der Website, ihre Herkunft und die Seiten, die sie besucht haben. Falls Sie Informationen darüber wünschen, wie Google Daten verwendet, verweisen wir auf die folgende URL:",
	"settings.privacypolicy.Worldwidetransfer": "Weltweite Weitergabe personenbezogener Daten",
	"settings.privacypolicy.amwebsite": "Website von ArcelorMittal",
	"settings.privacypolicy.creditsforpictures": "Credits für Bilder",
	"settings.privacypolicy.hypertextlinks": "Hypertext Links",
	"settings.privacypolicy.ifyouareusing": "Wenn Sie benutzen",
	"settings.privacypolicy.responsabilities": "Verantwortlichkeiten",
	"settings.privacypolicy.tableofcontent": "Inhaltsverzeichnis",
	"settings.privacypolicy.usecookies": "Benutzung von Cookies",
	"settings.privacypolicy.usedataprovided": "Nutzung zur Verfügung gestellter Daten",
	"settings.privacypolicy.worldwidetransfercontent": "ArcelorMittal-Unternehmen weltweit haben Zugang zu SteelUser. Personenbezogene Daten werden nur für die in dieser Datenschutzrichtlinie beschriebenen Zwecke verwendet. Ein angemessenes Schutzniveau ist zu gewährleisten und Sicherheitsmaßnahmen sind zu treffen, um die personenbezogenen Daten gegen unbeabsichtigte oder unrechtmäßige Zerstörung, unbeabsichtigten Verlust, Veränderung, unbefugte Weitergabe oder unbefugten Zugang zu schützen.  Durch die Nutzung von SteelUser stimmen Sie einer solchen Übermittlung zu.",
	"settings.product": "Produkt",
	"settings.product.article": "Artikelreferenz des Kunden",
	"settings.product.standard.dimension": "Stahlsorte + Abmessungen",
	"settings.product.steelgrade": "Stahlsorte",
	"settings.profile": "Profil",
	"settings.remove-service": "Service entfernen",
	"settings.remove-service-confirmation": "Möchten Sie diesen Service wirklich löschen?",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Verkaufsrahmen",
	"settings.save-changes": "Änderungen speichern",
	"settings.scan": "Scan",
	"settings.scan.beep": "Tonsignal",
	"settings.scan.display-tip": "Tipps anzeigen",
	"settings.scan.mode": "Scan-Modus",
	"settings.scan.mode.laser": "Laser modus / einzelner Wert",
	"settings.scan.mode.matrix": "Matrix / mehrere Zonen",
	"settings.select.download-type": "Wählen Sie aus, wie Sie die Daten herunterladen möchten:",
	"settings.select.language": "Wählen Sie Ihre Sprache:",
	"settings.select.order.number": "Wählen Sie aus, wie Sie die Auftragsnummern anzeigen möchten:",
	"settings.select.ordertracking.sortlist": "Wählen Sie aus, wie Sie die Liste in der Auftragsverfolgung sortieren möchten:",
	"settings.select.product": "Wählen Sie aus, wie Sie Produkte anzeigen wollen:",
	"settings.select.scan.beep": "Möchten Sie einen Ton hören, wenn ein Wert erkannt wurde:",
	"settings.select.scan.mode": "Wählen Sie aus, mit welcher Methode Sie scannen möchten:",
	"settings.select.weight": "Wählen Sie aus, wie Sie Gewichte anzeigen wollen:",
	"settings.services-mangement": "Verwaltung der Dienste",
	"settings.snackbar.downloadType": "Ihr Download-Typ ist jetzt {{downloadType}}.",
	"settings.snackbar.language": "Ihr Sprache wird jetzt {{lang}} sein.",
	"settings.snackbar.order": "Ihre Bestell Referenz Anzeige ist {{order}}",
	"settings.snackbar.product": "Ihre Produktanzeige ist {{order}}",
	"settings.snackbar.visibility": "Sie können jetzt die Daten des Lieferanten zu sehen {{visibility} {{supplier}}",
	"settings.snackbar.weight": "Ihre Gewichtsanzeige ist {{weight}}",
	"settings.supplier": "Lieferant",
	"settings.survey.wot.overview": "die neue Bestell- und Lieferübersichtsseite",
	"settings.terms.of.use": "Nutzungsbedingungen",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Bestätigen",
	"settings.user-update-error": "Bei der Aktualisierung des Benutzers ist ein Fehler aufgetreten, die Änderungen werden nicht gespeichert.",
	"settings.visibility": "Sichtbarkeiten",
	"settings.visibility.changeimpact": "Das Ändern dieses Werts wirkt sich auf andere Steeluser-Systeme aus.",
	"settings.visibility.data": "aktuell sichtbare Daten für (Organisation - Lieferant)",
	"settings.visibility.helper": "Wählen Sie den Anwendungsbereich für Mobilie Applikationen und Web part",
	"settings.visibility.info": "Die Sichtbarkeit ist geteilt zwischen allen Steeluser Platformen (mobile und Web)",
	"settings.weight": "Gewicht",
	"settings.weight.gross": "Brutto",
	"settings.weight.net": "Netto",
	"share.view.share": "Freigeben",
	"shareview.success.message": "erfolgreich geteilt",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Lieferschein",
	"shipment.card.information": "Versandinformationen",
	"shipment.dispatch-advice": "Lieferschein",
	"shipment.dispatch-advice-date": "Datum der Versandanzeige",
	"shipment.dispatch-advice-number": "Lieferscheinnummer",
	"shipment.dispatch-date": "Versanddatum",
	"shipment.filter.batch-number": "Chargennummer",
	"shipment.filter.customer": "Kunde",
	"shipment.filter.customer-article-reference": "Artikelbezeichnung des Kunden",
	"shipment.filter.customer-order-number": "Kundenbestellnummer",
	"shipment.filter.dispatch-advice-date": "Datum des Lieferscheins",
	"shipment.filter.dispatch-advice-number": "Lieferscheinnummer",
	"shipment.filter.dispatch-date": "Datum des Versands",
	"shipment.filter.mill": "Werk",
	"shipment.filter.ship-to": "Warenempfänger",
	"shipment.filter.sold-to": "Auftragsgeber",
	"shipment.filter.standard-steelgrade": "Stahlgüte",
	"shipment.filter.supplier-order-number": "Lieferantenauftragsnummer",
	"shipment.filter.thickness": "Dicke ",
	"shipment.filter.transport-mode": "Transportart",
	"shipment.filter.transport-reference": "Transport-Referenz",
	"shipment.filter.width": "Breite",
	"shipment.first": "Zuerst",
	"shipment.last": "Letztes",
	"shipment.shipped-qty-gross": "Versendete Menge brutto (t)",
	"shipment.step": "Schritt",
	"shipment.tmode.byairplane": "Mit dem Flugzeug",
	"shipment.tmode.byinlandwaterways": "Auf Binnenwasserstraßen",
	"shipment.tmode.byrail": "Mit dem Zug",
	"shipment.tmode.byrail.feve": "Mit dem Zug (FEVE)",
	"shipment.tmode.byrailroad": "Auf Schiene und Straße",
	"shipment.tmode.byroad": "Auf der Straße",
	"shipment.tmode.bysea": "Schifffahrt",
	"shipment.tmode.bytrain": "Zug",
	"shipment.tmode.notspecified": "Nicht angegeben",
	"shipment.to": "Auslieferung an",
	"shipment.transport-reference": "Transportreferenz",
	"simulated.customer.updated": "Der simulierte Kunde wurde aktualisiert.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "Sie müssen angemeldet sein, um die Einstellungen zu ändern",
	"snackbar.survey": "Vielen Dank für Ihre Zeit, Ihr Feedback ist für uns sehr wichtig.",
	"sortby.cdd.asc": "Best.Lief.Dat. aufst.",
	"sortby.cdd.desc": "Best.Lief.Dat. abst.",
	"sortby.order.asc": "Auftrag aufst",
	"sortby.order.desc": "Auftrag abst",
	"sortby.product.asc": "Produkt aufst",
	"sortby.product.desc": "Produkt abst",
	"srvmg.requestor.description": "Als SOX-Antragsteller fungieren",
	"srvmg.requestor.label": "Antragsteller",
	"srvmg.validator.description": "Als SOX-Validator fungieren",
	"srvmg.validator.label": "Validator",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Startdatum",
	"status-group.blocked": "Blockierte Menge",
	"status-group.in-consignment": "Available - In consignment",
	"status-group.in-prod": "In Produktion",
	"status-group.in-transit": "Im Transit zum Kunden",
	"status-group.rtt": "Versandbereit",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Senden Sie Ihre Garantieanfrage",
	"supplier.comment": "Anmerkungen des Lieferanten",
	"suppliergroup.amds": "ArcelorMittal Distributionslösungen",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "Ich stimme zu",
	"survey.amount.of.time": "Zeit, die ich für die Suche nach Informationen gebraucht habe",
	"survey.answer.dialog.title": "Bitte bewerten Sie die Benutzerfreundlichkeit von",
	"survey.clarity.information": "Klarheit der Informationen",
	"survey.disagree": "Ich stimme nicht zu",
	"survey.ease.find.information": "Leichtigkeit, Informationen zu finden",
	"survey.evaluate.statement": "Bewerten Sie die 3 folgenden Aussagen",
	"survey.header.title": "Helfen Sie uns zu verbessern",
	"survey.statements": "Ich bin zufrieden mit",
	"survey.strongly": "Stark",
	"table.no.results": "kein Ergebnis",
	"table.results": "{{value}} Ergebnisse",
	"term.policy": "Geschäftsbedingungen und Richtlinien",
	"title.product.catalogue": "Ihrem Katalog ein neues Produkt hinzufügen",
	"title.product.order": "Wählen Sie das Produkt, das Sie bestellen möchten",
	"tmode.byair": "Flug",
	"tmode.bysea": "Seetransport",
	"tmode.default": "_Standard",
	"tmode.inlandwaterway": "Binnenschifffahrt",
	"tmode.lorry": "LKW",
	"tmode.lorryrailway": "Strasse + Schiene",
	"tmode.othertospecify": "Andere",
	"tmode.rail": "Bahn",
	"tmode.railwaylorry": "Schiene + Straße",
	"total.quantity.period": "Gesamtmenge für den Zeitraum",
	"transport.mode": "Transportmittel",
	"transport.mode.boat": "Boot",
	"transport.mode.plane": "Flugzeug",
	"transport.mode.train": "Zug",
	"transport.mode.truck": "Lkw",
	"transversal.dashboard": "Dashboard",
	"transversal.dashboard.plural": "Dashboards",
	"transversal.data-administration": "Verwaltung",
	"transversal.data-center": "Datencenter",
	"transversal.data-center-batches": "Batches",
	"transversal.data-center-documents": "Kommerzielle Dokumente",
	"transversal.data-center-order": "Aufträge",
	"transversal.data-center.batches": "Data center: Batches",
	"transversal.data-center.plural": "Data center",
	"transversal.data-center.prototype": "Prototypen",
	"transversal.data-center.users": "Benutzer",
	"transversal.delegated-to": "Übertragen zu",
	"transversal.eoffer": "eAngebot",
	"transversal.equality": "eQualität",
	"transversal.go-back-to-old-steeluser": "Gehe zum Altsystem",
	"transversal.guarantee-documents": "Garantiedokumente",
	"transversal.home": "Startseite",
	"transversal.in-a-delegation": "(in einer Delegation)",
	"transversal.lastbatches": "Neueste Coils",
	"transversal.legal": "Rechtlich",
	"transversal.order-tracking": "Auftragsverfolgung",
	"transversal.order.delivery": "Auftragsstatus",
	"transversal.quality": "Qualität",
	"transversal.schedule-busiess-order": "Geschäftsaufträge einplanen",
	"transversal.services": "Services",
	"transversal.shipments": "Lieferungen",
	"transversal.simulation-of": "Simulation von",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Stücke",
	"unit.to": "Metrische Tonnen",
	"unrecognized.batch": "Nicht erkannte Charge",
	"upload.file.count.error.message": "Maximal -max-count- Dateien pro Artikel",
	"upload.file.error.message": "Beim Hochladen ist ein Fehler aufgetreten",
	"upload.file.maxitem.error.message": "Maximal 3 Dateien pro Artikel",
	"upload.file.mime.type.error.message": "Nur PDF, DOC, XLS, PPT oder Bilder erlaubt. Upload-Typ ist MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "Die maximale Dateigröße beträgt 20MB",
	"upload.file.space.error.message": "Sorry: not enough space to add automatically template file as attachment",
	"upload.or": "oder",
	"user.belong.to": "Ich gehöre zu",
	"user.card.about-cookies": "Cookies sind kleine Textdateien, die von Websites verwendet werden können, um die Benutzererfahrung effizienter zu gestalten. Das Gesetz verlangt, dass Cookies nur auf Ihrem Gerät gespeichert werden dürfen, wenn sie für den Betrieb dieser Website unbedingt erforderlich sind. Für alle anderen Arten von Cookies benötigen wir Ihre Zustimmung. Diese Website verwendet verschiedene Arten von Cookies. Einige Cookies werden von Drittanbietern gesetzt, die auf unseren Seiten erscheinen. Sie können Ihre Zustimmung jederzeit über die Cookie-Erklärung auf unserer Website ändern oder widerrufen. Weitere Informationen über uns, wie Sie uns kontaktieren können und wie wir mit persönlichen Daten umgehen dürfen, finden Sie in unserer Datenschutzrichtlinie.",
	"user.card.about-cookies.title": "Über Cookies",
	"user.card.accept": "Akzeptieren",
	"user.card.account-info": "Kontoinformationen",
	"user.card.allowed": "Erlaubt",
	"user.card.apply": "Anwenden",
	"user.card.audience-measurement-cookies": "Wir verwenden Cookies zur Messung der Besucherzahlen, deren Zweck ausschließlich darin besteht, die Leistung der Website oder der Anwendung zu messen, Navigationsprobleme zu erkennen, die technische Leistung oder die Ergonomie zu optimieren, die Leistung der erforderlichen Server einzuschätzen und die Inhalte zu analysieren, die ausschließlich für Arcelor Mittal erstellt wurden.",
	"user.card.audience-measurement-cookies.title": "Cookies zur Messung der Besucherzahlen",
	"user.card.cookies-exempt-from-consents.one": "Die Cookies speichern die von den Benutzern im Plotter-Speicher getroffenen Entscheidungen.",
	"user.card.cookies-exempt-from-consents.three": "Cookies zur Anpassung der Benutzeroberfläche (z. B. für die Sprachauswahl oder die Darstellung eines Dienstes), wenn eine solche Anpassung ein wesentliches und erwartetes Element des Dienstes ist.",
	"user.card.cookies-exempt-from-consents.title": "Cookies, für die keine Zustimmung erforderlich ist",
	"user.card.cookies-exempt-from-consents.two": "Die Cookies, die für die Authentifizierung bei einem Dienst vorgesehen sind, einschließlich der Cookies, die die Sicherheit des Authentifizierungsmechanismus gewährleisten sollen, beispielsweise durch die Begrenzung robotischer oder unerwarteter Zugriffsversuche.",
	"user.card.details": "Details",
	"user.card.not-allowed": "Nicht erlaubt",
	"user.card.notifications": "Mitteilung",
	"user.card.notifications.no-data": "Sie haben noch keine Mitteilungen",
	"user.card.notifications.tab.description": "Beschreibung",
	"user.card.notifications.tab.details": "Details",
	"user.card.notifications.tab.frequency": "Häufigkeit",
	"user.card.notifications.tab.service": "Service",
	"user.card.notifications.tab.subscription": "Abonnement",
	"user.card.notifications.title": "Mitteilung",
	"user.card.notifications.title.desc": "Liste der Meldungen für diesen Benutzer",
	"user.card.personalcard": "Persönliche Karte",
	"user.card.personalize-privacy-settings.title": "Passen Sie Ihre Datenschutzeinstellungen an",
	"user.card.privacy-settings": "Datenschutzeinstellungen",
	"user.card.reject": "Ablehnen",
	"user.card.security": "Sicherheit",
	"user.card.security.1-lowercase-letter-rule": "1 Kleinbuchstabe (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 Zahl (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 Sonderzeichen (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 Großbuchstabe (A, B, C, D, E)",
	"user.card.security.15-character-rule": "Mindestens 15 Zeichen",
	"user.card.security.change-login-title": "Change your login",
	"user.card.security.change-password-title": "Ihr Passwort ändern",
	"user.card.security.confirm-password-match": "Das Passwort zur Bestätigung muss mit dem neuen Passwort übereinstimmen",
	"user.card.security.password-must-contain-title": "Um gültig zu sein, muss das Passwort mindestens enthalten:",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "Ihr aktuelles Passwort",
	"user.card.security.your-login": "Your login",
	"user.card.security.your-new-password": "Ihr neues Passwort",
	"user.card.security.your-repeat-new-password": "Wiederholen Sie Ihr neues Passwort",
	"user.card.services": "Services",
	"user.card.services.no-data": "Sie haben keine Services zur Verfügung",
	"user.card.services.tab.desc": "Beschreibung",
	"user.card.services.tab.name": "Name",
	"user.card.services.tab.settings": "Einstellungen",
	"user.card.services.title": "Service-Liste",
	"user.card.services.title.desc": "Liste aller für diesen Benutzer verfügbaren Services im entsprechenden Anbieterkontext",
	"user.card.settings": "Einstellungen",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "Herr",
	"user.gender.mrs": "Frau",
	"user.gender.ms": "Frau",
	"user.language": "Sprache",
	"user.need.connection": "Sie müssen authentifiziert sein, um auf diesen Bereich zuzugreifen.",
	"user.no.connection": "Sie benötigen eine gültige Verbindung, um auf diesen Bereich zugreifen zu können",
	"user.no.role": "Ihr Profil erlaubt Ihnen leider nicht Qualitätsprobleme zu managen. Bitte kontaktieren Sie Ihren SteelUser Relay, um vollen Zugang zum Service \"Qualität\" zu erhalten.",
	"user.no.service": "Ihr Profil kann kein Qualitätsproblem verwalten. Bitte setzen Sie sich mit Ihrem SteelUser Relay in Verbindung, um vollen Zugriff auf den Qualitäts-App-Service zu erhalten.",
	"user.notifications.add.subscription": "Hinzufügen",
	"user.notifications.btn.add.subscription": "Abonnement hinzufügen",
	"user.notifications.dialog.subscription": "Ein Abonnement hinzufügen",
	"user.notifications.dropdown.frequency": "Häufigkeit",
	"user.notifications.dropdown.services": "Services",
	"user.notifications.dropdown.subscription": "Abonnement",
	"user.notifications.select.frequency": "Bitte eine Häufigkeit auswählen",
	"user.notifications.select.service": "Bitte einen Service auswählen",
	"user.notifications.select.subscription": "Bitte ein Abonnement auswählen",
	"user.see.data": "Ich sehe gerade Informationen für",
	"user.supplier": "Mein Lieferant",
	"user.user": "Nutzer",
	"user.validation": "Benutzer ist erforderlich",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Aktive Services",
	"userServiceInfo.services.settings": "Einstellungen",
	"users.details-card.actions": "Aktionen",
	"users.list": "Benutzer-Liste",
	"view.shared.success": "Möchten Sie diese Vorlage {{value}} wirklich löschen?",
	"view.validation": "Ansicht ist erforderlich",
	"viewby.cdd.asc": "Best.Lief.Dat. aufst.",
	"viewby.cdd.desc": "Best.Lief.Dat. abst.",
	"viewby.mill.asc": "Werk aufst",
	"viewby.mill.desc": "Werk abst",
	"viewby.product.asc": "Produkt aufst",
	"viewby.product.desc": "Produkt abst",
	"viewby.step": "Schritt",
	"wait.message": "Bitte NICHT die Schaltfläche \"Zurück\" oder \"Aktualisieren\" in Ihrem Browser DRÜCKEN",
	"wait.message.fastlane": "Bitte klicken Sie NICHT auf die Schaltfläche \"Zurück\" oder aktualisieren Sie Ihren Browser",
	"wait.user.validation": "Waiting for user validation",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "Sind Sie sicher, dass Sie beenden möchten?",
	"want.to.delete.draft": "Möchten Sie diese Vorlage wirklich löschen?",
	"want.to.delete.notification": "Möchten Sie diese Benachrichtigung wirklich löschen?",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "Es können nicht mehr als 1000 Datensätze auf einmal heruntergeladen werden",
	"warning.maximum.30": "Es können nicht mehr als 30 Datensätze auf einmal heruntergeladen werden",
	"woe.noitems": "Keine Auftragsposition",
	"workflow-steps.next.error": "Etwas ist schief gelaufen, bitte kontaktieren Sie den SteelUser-Administrator",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
